/* GWIN DIY Sales 02 engine — build v1.95 (save+compare Stage 1: per-card build persistence + closed-card price/chip reflection + restore-on-reopen + rehydrate-on-load + closed-card edits update & carry the saved build; combined-description build manifest; multi card photos + per-card photo/desc overrides). Loaded as a theme asset to keep the section file under Shopify's 256KB limit.
   Pure JS; all data comes from window.GWIN_CFG + window.gwin_diy_sales_acc (both set inline in the section). */
(function(){
  if(!window.GWIN_CFG){ console.warn('[GWIN] GWIN_CFG missing — config bridge did not emit.'); return; }
  var GWIN_CFG = window.GWIN_CFG;

  /* ===================================================================
     LOCKED — sizing matrix + functions, copied verbatim from the proven
     mockup. Do not edit. The engine builds on these.
     =================================================================== */
const CONDENSER_MAX_HEAD = {18:12, 24:18, 30:24, 36:30, 42:36, 48:36, 60:36};
/* Air-handler TYPES are data-driven from the bridge (GWIN_CFG.handlerTypes): each type
   carries its own sizes[] and mountClass, so new types (4-way cassette, low-wall/floor,
   etc.) are added in the editor with NO engine change. The hardcoded tables below are a
   safety FALLBACK, used only for a known type whose editor fields are still blank — so
   day-one behavior is identical even before anyone fills the new fields in. */
const FALLBACK_TYPE_SIZES = {
  'hw-king': [7,9,12,18,24,30,36],   /* King high-wall — the only line with 7k / 30k / 36k */
  'hw-emp':  [9,12,18,24],           /* Emperor high-wall */
  'ducted':  [9,12,18,24],           /* Hidden ducted */
  'cassette':[9,12,20]               /* Slim ceiling cassette (note the 20k) */
};
const FALLBACK_MOUNT = { 'hw-king':'wall', 'hw-emp':'wall', 'ducted':'ducted', 'cassette':'cassette' };
const TYPE_SIZES = {};
const MOUNT_CLASS = {};
(GWIN_CFG.handlerTypes || []).forEach(function(t){
  var ds = (t.sizes && t.sizes.length) ? t.sizes.slice() : (FALLBACK_TYPE_SIZES[t.id] || []);
  TYPE_SIZES[t.id]  = ds.sort(function(a,b){ return a-b; });
  MOUNT_CLASS[t.id] = (t.mountClass && t.mountClass.length && t.mountClass !== 'auto') ? t.mountClass : (FALLBACK_MOUNT[t.id] || 'wall');
});
const OVER_CAP_K = 6;          /* total heads may exceed condenser by at most 6k */
const LINESET_INCLUDED = 15;   /* ft included per zone */

/* sizes selectable for a given condenser + handler type */
function allowedSizes(condK, typeId){
  const cap = CONDENSER_MAX_HEAD[condK] || 12;
  return (TYPE_SIZES[typeId] || [9,12]).filter(s => s <= cap);
}
/* snap a desired size to the nearest allowed size for (condenser,type) */
function snapSize(condK, typeId, k){
  const a = allowedSizes(condK, typeId);
  if(a.indexOf(k) !== -1) return k;
  const le = a.filter(s => s <= k);
  return le.length ? le[le.length-1] : a[0];
}
function condMin(condK){ return condK/2; }            /* heads must total >= half */
function condMax(condK){ return condK + OVER_CAP_K; } /* and <= condenser + 6k */
function isHighWallType(t){ return MOUNT_CLASS[t] === 'wall'; }

/* sizes a single head may be, given the OTHER heads' total, so the grand total
   stays within [half-condenser, condenser+6k]. Used to hard-stop bad picks. */
function validSizesForHead(condK, typeId, otherTotalK){
  const lo = condMin(condK), hi = condMax(condK);
  return allowedSizes(condK, typeId).filter(s => (otherTotalK + s) >= lo && (otherTotalK + s) <= hi);
}
/* snap a desired size to a VALID size for this type, keeping the load covered:
   if the type carries that exact size, keep it; otherwise round UP to the smallest
   valid size >= want; if the type doesn't go that high, cap at its largest valid size. */
function snapValid(condK, typeId, otherTotalK, want){
  const v = validSizesForHead(condK, typeId, otherTotalK);
  if(!v.length) return allowedSizes(condK, typeId)[0]; /* fallback (shouldn't happen from a valid combo) */
  if(v.indexOf(want) !== -1) return want;              /* type already has this size → unchanged */
  const ge = v.filter(s => s >= want);                 /* sizes that still cover the load */
  if(ge.length) return ge[0];                          /* round UP to the smallest that covers */
  return v[v.length-1];                                /* want exceeds this type's reach → cap at its max */
}
/* lowest-cost default combination: smallest total that is still >= half the condenser */
function defaultHeads(condK, zones, typeId){
  const sizes = allowedSizes(condK, typeId);            /* ascending */
  const lo = condMin(condK), hi = condMax(condK);
  const heads = new Array(zones).fill(sizes[0]);
  let total = sizes[0]*zones;
  let guard = 0;
  while(total < lo && guard++ < 200){
    /* bump the head whose next step adds the least, without exceeding the +6k ceiling */
    let bi=-1, bDelta=Infinity;
    for(let i=0;i<zones;i++){
      const ci = sizes.indexOf(heads[i]);
      if(ci < sizes.length-1){
        const delta = sizes[ci+1]-heads[i];
        if(total - heads[i] + sizes[ci+1] <= hi && delta < bDelta){ bDelta=delta; bi=i; }
      }
    }
    if(bi<0) break;
    const ci = sizes.indexOf(heads[bi]);
    total += sizes[ci+1]-heads[bi];
    heads[bi] = sizes[ci+1];
  }
  return heads;
}
function btuK(str){ return parseInt(String(str).replace(/[^0-9]/g,''),10)/1000; } /* "18,000" -> 18 */

  /* ===== data aliases — content comes from the bridge (GWIN_CFG) ===== */
  var SINGLE = GWIN_CFG.series || [];
  var ZONES = GWIN_CFG.zones || [];
  var HANDLER_TYPES = GWIN_CFG.handlerTypes || [];
  var HANDLERS = GWIN_CFG.handlerCards || [];
  var COVER = GWIN_CFG.cover || {};
  var COMING_SOON = GWIN_CFG.comingSoon || [];
  var ACC = GWIN_CFG.acc || {};
  var INFO = GWIN_CFG.info || {};
  var FINANCE = GWIN_CFG.finance || {};
  var LINKS = GWIN_CFG.links || {};
  var STICKY = GWIN_CFG.stickyTop || {desktop:0,mobile:0};

  /* ===== cross-section accessories catalog =====
     The data-only "DIY Sales — Accessories" section emits window.gwin_diy_sales_acc.
     Read it additively: if that section isn't on the page, ACC_CAT is just {} and the
     engine behaves exactly as before (today's placeholder pricing). */
  var ACC_CAT = (typeof window !== 'undefined' && window.gwin_diy_sales_acc) ? window.gwin_diy_sales_acc : {};

  var root = document.querySelector('.gwin-ds-engine');
  if(!root){ console.warn('[GWIN] section root not found'); return; }

  window.GWIN_ENGINE = { cfg: GWIN_CFG, accCat: ACC_CAT, SINGLE: SINGLE, ZONES: ZONES, HANDLER_TYPES: HANDLER_TYPES,
    allowedSizes: allowedSizes, defaultHeads: defaultHeads, validSizesForHead: validSizesForHead, snapValid: snapValid, snapSize: snapSize, btuK: btuK, TYPE_SIZES: TYPE_SIZES, MOUNT_CLASS: MOUNT_CLASS,
    nearestSingle: nearestSingle, nearestCond: nearestCond, nearestHeadK: nearestHeadK, zoneFromZip: zoneFromZip, condLabel: condLabel };

  /* ===================== ICON LIBRARY ===================== */
  const ICONS = {
  snow:'<path d="M12 3v18M5 7l14 10M19 7L5 17"/><path d="M9 4l3 2 3-2M9 20l3-2 3 2"/>',
  bolt:'<path d="M13 3L5 14h6l-1 7 8-11h-6z"/>',
  wifi:'<path d="M2 8.5a16 16 0 0120 0M5 12a11 11 0 0114 0M8 15.5a6 6 0 018 0"/><circle cx="12" cy="19" r="1.2" fill="currentColor"/>',
  leaf:'<path d="M5 19c0-8 6-13 14-13 0 8-6 13-14 13z"/><path d="M5 19c3-5 6-7 10-9"/>',
  shield:'<path d="M12 3l7 3v5c0 4.4-3 8.3-7 9.5C8 19.3 5 15.4 5 11V6l7-3z"/><path d="M9.5 12l1.8 1.8L15 10"/>',
  gauge:'<path d="M4 13a8 8 0 0116 0"/><path d="M12 13l4-3"/><circle cx="12" cy="13" r="1.4" fill="currentColor"/>',
  ruler:'<path d="M4 8l12 12 4-4L8 4z"/><path d="M8 8l1 1M11 11l1 1M14 14l1 1"/>',
  quiet:'<path d="M4 9v6h4l5 4V5L8 9z"/><path d="M16 9c1.5 1.5 1.5 4.5 0 6"/>',
  wall:'<rect x="4" y="6" width="16" height="7" rx="2"/><path d="M7 16q5 4 10 0"/>',
  cassette:'<rect x="4" y="6" width="16" height="6" rx="1.5"/><path d="M8 14v3M12 14v4M16 14v3"/>',
  ducted:'<path d="M3 7h10v6H3z"/><path d="M13 9h4l4 4v2h-8z"/><path d="M7 17v2M11 17v2"/>',
  cassette4:'<rect x="7" y="7" width="10" height="10" rx="2"/><path d="M12 7V3M12 17v4M7 12H3M17 12h4"/>',
  console:'<rect x="5" y="11" width="14" height="7" rx="2"/><path d="M8 18v2M16 18v2"/><path d="M8 8q4-3 8 0"/>',
  truck:'<path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>',
  arrowL:'<path d="M15 6l-6 6 6 6"/>',
  arrowR:'<path d="M9 6l6 6-6 6"/>',
  arrowRt:'<path d="M5 12h14M13 6l6 6-6 6"/>',
  chevronUp:'<path d="M6 15l6-6 6 6"/>',
  play:'<path d="M8 5v14l11-7z"/>',
  camera:'<path d="M4 8h3l1.5-2h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.4"/>',
  info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'
};
  function icon(name,w){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" '+(w?'width="'+w+'"':'')+'>'+(ICONS[name]||'<circle cx="12" cy="12" r="9"/>')+'</svg>';}

  /* ===================== PRICING (placeholder — real Shopify pricing lands in Phase 5) ===================== */
  var FIN_APR  = (FINANCE.apr  != null ? +FINANCE.apr  : 9.99);
  var FIN_TERM = (FINANCE.term != null ? +FINANCE.term : 60);
  var FINANCE_URL = FINANCE.url || '/pages/financing';
  function money(n){ return '$' + n.toLocaleString(undefined,{maximumFractionDigits:0}); }
  function monthly(price){
    var r = FIN_APR/100/12;
    var m = r ? (price*r)/(1 - Math.pow(1+r, -FIN_TERM)) : price/FIN_TERM;
    return '$' + Math.ceil(m).toLocaleString();
  }
  function basePrice(kind, btuk, zones){
    if(kind==='multi'){ return 1400 + btuk*70 + (zones-1)*350; }
    return 900 + btuk*55;
  }
  function cardStartPrice(kind, condK, zones, headSizes){
    var total = basePrice(kind, condK, zones);
    (headSizes||[]).forEach(function(k){ total += k*30; });
    return total;
  }

  /* Real base price for a single-zone card (condenser+air handler+15ft lineset, no add-ons),
     resolved from the connected system. Returns null if not fully connected (placeholder stays). */
  function cardRealBase(family, typeId, condK, voltage, cat){
    var cfg = {kind:'single', condK:condK, family:family||null, voltage:voltage||'230v', lockedType:typeId,
               sys:{mount:0,electrical:0}, heads:[{type:typeId, sizeK:condK, lineset:0, lineGuard:false, pump:false}]};
    var rb = resolveBuild(cfg, cat||null);
    return (rb && rb.unresolved && rb.unresolved.length===0) ? rb.total : null;
  }
  function voltKey(v){ return (v && String(v).indexOf('115')>=0) ? '115v' : '230v'; }

  /* Re-price the already-rendered single cards from the live catalog. Idempotent; called
     after render and again shortly after load to cover section/script ordering. */
  function refreshSingleCardPrices(){
    if(typeof root==='undefined' || !root) return;
    root.querySelectorAll('.scard[data-kind="single"]').forEach(function(card){
      applySavedState(card);
      if(CFG && CFG.openCard===card){ setCardPrice(card, CFG.total||0, true); syncCardDisplay(card, CFG); return; }
      var _sk=cardKey(card), _sv=_sk?savedBuild(_sk):null;
      if(_sv){ var _c=cfgFromCard(card,_sv); setCardPrice(card, totalForBuild(_c).total, true); syncCardDisplay(card,_c); return; }
      var condK = btuK(card.dataset.btu);
      var rb = cardRealBase(card.dataset.family, card.dataset.type, condK, voltKey(card.dataset.volts));
      if(rb==null) return;
      var lsIdx = parseInt(card.dataset.lsIdx,10) || 0;
      var lso = lsOptsFor(card.dataset.type, condK, null, card.dataset.volts, card.dataset.family);
      if(lso && lso.length){
        if(lsIdx >= lso.length){ lsIdx = 0; card.dataset.lsIdx = 0; }
        var chip = card.querySelector('.ls-chip');
        if(chip) chip.innerHTML = lso[lsIdx].label + ' ' + icon('arrowRt');
      }
      var delta = (lso && lso[lsIdx] && lso[0]) ? (lso[lsIdx].price - lso[0].price) : 0;
      var start = rb + delta;
      setCardPrice(card, start, false);
    });
  }
  /* Real "from $X" for a multi card: condenser + default (king) heads + base linesets,
     resolved from the multi catalog. Null until fully connected (placeholder stays). */
  function multiCardRealBase(zones, condK, headSizes){
    var hs = (headSizes||[]).map(function(k){ return {type:'hw-king', sizeK:+k, lineset:0, lineGuard:false, pump:false}; });
    if(!hs.length) return null;
    var cfg = {kind:'multi', condK:condK, zones:zones, family:null, voltage:'230v', sys:{mount:0,electrical:0}, heads:hs};
    var rb = resolveBuild(cfg, null);
    return (rb && rb.unresolved && rb.unresolved.length===0) ? rb.total : null;
  }
  /* Re-price already-rendered multi cards from the live multi catalog. Idempotent. */
  function refreshMultiCardPrices(){
    if(typeof root==='undefined' || !root) return;
    root.querySelectorAll('.scard[data-kind="multi"]').forEach(function(card){
      applySavedState(card);
      if(CFG && CFG.openCard===card){ setCardPrice(card, CFG.total||0, true); syncCardDisplay(card, CFG); return; }
      var _sk=cardKey(card), _sv=_sk?savedBuild(_sk):null;
      if(_sv){ var _c=cfgFromCard(card,_sv); setCardPrice(card, totalForBuild(_c).total, true); syncCardDisplay(card,_c); return; }
      var condK = btuK(card.dataset.btu);
      var zones = +card.dataset.zones;
      var headSizes = (card.dataset.headsizes||'').split(',').map(function(n){ return parseInt(n,10); }).filter(function(n){ return !isNaN(n); });
      var rb = multiCardRealBase(zones, condK, headSizes);
      if(rb==null){ var lbl0=card.querySelector('.price-row small'); if(lbl0) lbl0.textContent='starting at'; card.dataset.configured=''; return; }
      setCardPrice(card, rb, false);
    });
  }

  /* Photo reel for a resolved system (Slice 1, source order = 1-a):
     bundle  -> bundle.images
     split   -> condenser.images THEN handler.images
     Returns an array of URL strings (may be empty -> icon fallback, 4-a). */
  function systemPhotos(sys){
    if(!sys) return [];
    if(sys.cardPhotos && sys.cardPhotos.length) return sys.cardPhotos.slice();   /* 5-a: overrides fully replace */
    if(sys.connectionType==='bundle'){
      return (sys.bundle && sys.bundle.images) ? sys.bundle.images.slice() : [];
    }
    var out = [];
    if(sys.condenser && sys.condenser.images) out = out.concat(sys.condenser.images);
    if(sys.handler   && sys.handler.images)   out = out.concat(sys.handler.images);
    return out;
  }

  /* Inject the real-photo mini-gallery into already-rendered single cards from the live
     catalog (same idempotent late-refresh pattern as refreshSingleCardPrices). If a system
     has no images, the card keeps its line icon (4-a). Guarded by data-gal-done so the
     double boot-call (0ms / 500ms) only wires once per card. */
  function refreshSingleCardPhotos(){
    if(typeof root==='undefined' || !root || !INFO_PHOTOS) return;
    root.querySelectorAll('.scard[data-kind="single"]').forEach(function(card){
      if(card.dataset.galDone==='1') return;
      var condK = btuK(card.dataset.btu);
      var sys = findSystem(card.dataset.type, condK, null, card.dataset.volts, card.dataset.family);
      var imgs = systemPhotos(sys);
      if(!imgs.length) return;                                  /* keep icon fallback; retry next pass */
      var ph = card.querySelector('.photo'); if(!ph) return;
      card.dataset.galDone = '1';
      card._gi = 0; card._gimgs = imgs;
      var bare = ph.querySelector('svg'); if(bare && bare.parentNode===ph) bare.remove();
      ph.classList.add('has-gal');
      var many = imgs.length > 1;
      var gal = document.createElement('div');
      gal.className = 'card-gal';
      gal.innerHTML = '<img class="cg-img" src="'+imgs[0]+'" alt="" loading="lazy">'
        + (many
          ? '<button class="cg-arrow prev" type="button" aria-label="Previous photo">'+icon('arrowL')+'</button>'
            + '<button class="cg-arrow next" type="button" aria-label="Next photo">'+icon('arrowR')+'</button>'
            + '<div class="cg-dots">'+imgs.map(function(_,k){ return '<span class="'+(k===0?'on':'')+'"></span>'; }).join('')+'</div>'
          : '');
      ph.appendChild(gal);
      var cim = gal.querySelector('.cg-img');
      if(cim) cim.addEventListener('click', function(e){ e.stopPropagation(); e.preventDefault(); openLightbox(card._gimgs, card._gi); });
      if(many){
        gal.querySelectorAll('.cg-arrow').forEach(function(b){
          b.addEventListener('click', function(e){
            e.stopPropagation(); e.preventDefault();     /* never opens/closes the card */
            cardGalStep(card, b.classList.contains('next') ? 1 : -1);
          });
        });
      }
    });
  }
  function cardGalStep(card, dir){
    var imgs = card._gimgs; if(!imgs || imgs.length < 2) return;
    card._gi = (card._gi + dir + imgs.length) % imgs.length;
    var im = card.querySelector('.card-gal .cg-img'); if(im) im.src = imgs[card._gi];
    card.querySelectorAll('.card-gal .cg-dots span').forEach(function(s,k){ s.classList.toggle('on', k===card._gi); });
  }

  /* Multi-zone parity with systemPhotos/refreshSingleCardPhotos. Source = the matched
     condenser's connected product images (same data the condenser (i) popover reads).
     Empty -> caller keeps the truck icon (4-a fallback). */
  function multiCondenserPhotos(zones, condK){
    var c = multiCondenser(zones, condK);
    if(!c) return [];
    if(c.cardPhotos && c.cardPhotos.length) return c.cardPhotos.slice();   /* override REPLACES product photos */
    return (c.product && c.product.images) ? c.product.images.slice() : [];
  }
  /* Inject the real-photo mini-gallery into already-rendered MULTI cards — mirrors
     refreshSingleCardPhotos exactly (idempotent via data-gal-done, lightbox + arrows/dots,
     reuses cardGalStep). Multi cards are built once at boot (buildMulti) so the 0ms/500ms
     boot passes catch them just like single. */
  function refreshMultiCardPhotos(){
    if(typeof root==='undefined' || !root || !INFO_PHOTOS) return;
    root.querySelectorAll('.scard[data-kind="multi"]').forEach(function(card){
      if(card.dataset.galDone==='1') return;
      var imgs = multiCondenserPhotos(+card.dataset.zones, btuK(card.dataset.btu));
      if(!imgs.length) return;                                  /* keep icon fallback; retry next pass */
      var ph = card.querySelector('.photo'); if(!ph) return;
      card.dataset.galDone = '1';
      card._gi = 0; card._gimgs = imgs;
      var bare = ph.querySelector('svg'); if(bare && bare.parentNode===ph) bare.remove();
      ph.classList.add('has-gal');
      var many = imgs.length > 1;
      var gal = document.createElement('div');
      gal.className = 'card-gal';
      gal.innerHTML = '<img class="cg-img" src="'+imgs[0]+'" alt="" loading="lazy">'
        + (many
          ? '<button class="cg-arrow prev" type="button" aria-label="Previous photo">'+icon('arrowL')+'</button>'
            + '<button class="cg-arrow next" type="button" aria-label="Next photo">'+icon('arrowR')+'</button>'
            + '<div class="cg-dots">'+imgs.map(function(_,k){ return '<span class="'+(k===0?'on':'')+'"></span>'; }).join('')+'</div>'
          : '');
      ph.appendChild(gal);
      var cim = gal.querySelector('.cg-img');
      if(cim) cim.addEventListener('click', function(e){ e.stopPropagation(); e.preventDefault(); openLightbox(card._gimgs, card._gi); });
      if(many){
        gal.querySelectorAll('.cg-arrow').forEach(function(b){
          b.addEventListener('click', function(e){
            e.stopPropagation(); e.preventDefault();     /* never opens/closes the card */
            cardGalStep(card, b.classList.contains('next') ? 1 : -1);
          });
        });
      }
    });
  }
  /* ===================== SAVE + COMPARE · STAGE 1 =====================
     Persist a configured build per card (localStorage), reflect its total on the
     closed card, restore on reopen, and re-price saved builds against the live
     catalog on load. Storage is best-effort (guarded) and keyed per card. */
  var GWIN_BUILD_STORE = 'gwin_diy_builds_v1';
  function loadBuilds(){ try{ if(typeof localStorage==='undefined') return {}; var s=localStorage.getItem(GWIN_BUILD_STORE); return s?JSON.parse(s):{}; }catch(e){ return {}; } }
  function saveBuilds(o){ try{ if(typeof localStorage!=='undefined') localStorage.setItem(GWIN_BUILD_STORE, JSON.stringify(o)); }catch(e){} }
  function cardKey(card){ if(!card) return null; var d=card.dataset; return d.kind==='multi' ? ('m|'+d.btu+'|'+d.zones) : ('s|'+(d.type||'')+'|'+d.btu+'|'+(d.family||'')+'|'+(d.volts||'')); }
  function savedBuild(key){ if(!key) return null; var b=loadBuilds(); return b[key]||null; }
  function persistBuild(key, cfg){
    if(!key || !cfg) return; var b=loadBuilds();
    var prevSaved = (b[key] && b[key].saved) ? 1 : 0;
    b[key]={ heads:(cfg.heads||[]).map(function(h){ return {type:h.type, sizeK:+h.sizeK, lineset:+h.lineset||0, lineGuard:+h.lineGuard||0, pump:+h.pump||0}; }),
             sys:{mount:+(cfg.sys&&cfg.sys.mount)||0, electrical:+(cfg.sys&&cfg.sys.electrical)||0},
             pipeCutter: cfg.pipeCutter?1:0, saved: prevSaved, ts: Date.now() };
    saveBuilds(b);
  }
  function clearBuild(key){ if(!key) return; var b=loadBuilds(); if(b[key]){ delete b[key]; saveBuilds(b); } }
  /* a priceable cfg reconstructed from a card + its saved selections (build not open) */
  function cfgFromCard(card, saved){
    var d=card.dataset, kind=d.kind, condK=btuK(d.btu), zones = kind==='multi' ? (+d.zones||2) : 1;
    return {
      kind:kind, condK:condK, zones:zones,
      voltage:(d.volts && String(d.volts).indexOf('115')>=0)?'115v':'230v',
      family:d.family||null, lockedType:d.type||null, title:d.title,
      base: basePrice(kind, condK, zones),
      sys:{mount:+(saved.sys&&saved.sys.mount)||0, electrical:+(saved.sys&&saved.sys.electrical)||0},
      pipeCutter: saved.pipeCutter?1:0,
      heads: (saved.heads||[]).map(function(h){ return {type:h.type, sizeK:+h.sizeK, lineset:+h.lineset||0, lineGuard:+h.lineGuard||0, pump:+h.pump||0}; })
    };
  }
  /* total math (shared by recalcPrice + saved-build re-pricing). DOM-free. */
  function computeTotal(cfg){
    /* A placeholder/unconnected LINESET must NOT collapse the whole build to the crude
       base+sizeK*30 estimate: linesets are priced in the per-head loop below, and the cart
       is gated independently in buildCartItems. Only a genuinely unresolved condenser/head
       (the structural, real-price components) falls back. This keeps the price the SAME real
       value whether or not a zone's lineset happens to be connected. */
    var total, rb=resolveBuild(cfg);
    var fullyReal = rb && rb.unresolved.filter(function(u){ return u.indexOf('lineset')===-1; }).length===0;
    if(fullyReal){ total=0; if(rb.bundle) total+=rb.bundle.price; if(rb.condenser) total+=rb.condenser.price; rb.heads.forEach(function(r){ if(r.component) total+=r.component.price; }); }
    else { total=cfg.base||0; (cfg.heads||[]).forEach(function(h){ total += h.sizeK*30; }); }
    (cfg.heads||[]).forEach(function(h){
      ['lineGuard','pump'].forEach(function(k){ var list=accOptsList(k,null,h); var idx=Math.min(+h[k]||0,list.length-1); if(list[idx]) total+=list[idx].price; });
      var _lso=(cfg.kind==='multi')?multiLsOpts(h.type,h.sizeK):lsOptsFor(h.type,h.sizeK,null,cfg.voltage,condFamily(cfg)); total += _lso[Math.min(h.lineset||0,_lso.length-1)].price;
    });
    var _mo=condAccOpts(cfg,'mount'), _eo=condAccOpts(cfg,'electrical');
    total += _mo[Math.min((cfg.sys&&cfg.sys.mount)||0,_mo.length-1)].price + _eo[Math.min((cfg.sys&&cfg.sys.electrical)||0,_eo.length-1)].price;
    var _pc=(accCatalog()||{}).pipeCutter;
    if(cfg.pipeCutter && _pc && _pc.handle){ var _pcv=(_pc.variants&&_pc.variants[0]); total += (_pcv?_pcv.price:_pc.price)||0; }
    return { total:total, fullyReal:fullyReal };
  }
  /* price a build that is NOT the open one: accOptsList/lsOptsFor read the global CFG,
     so swap it in for the synchronous compute, then restore. */
  function totalForBuild(cfg){ var prev=CFG; CFG=cfg; try{ return computeTotal(cfg); } finally { CFG=prev; } }
  /* set a card's price + finance line, and flip its label to "your build" when configured.
     Never touches "coming soon" cards. */
  function setCardPrice(card, total, configured){
    if(!card || card.classList.contains('soon')) return;
    var pr=card.querySelector('.card-price'); if(pr) pr.textContent=money(total);
    var moEl=card.querySelector('.card-mo'); if(moEl) moEl.textContent=monthly(total);
    var lbl=card.querySelector('.price-row small'); if(lbl) lbl.textContent = configured ? 'your build' : 'starting at';
    card.dataset.configured = configured ? '1' : '';
  }
  /* reflect a build's selections on the CLOSED card's interactive chips:
     single → lineset chip (card.dataset.lsIdx + .ls-chip label);
     multi  → head-size roller chips (card.dataset.headsizes + [data-roll-i] text). */
  function syncCardDisplay(card, cfg){
    if(!card || !cfg) return;
    if(card.dataset.kind==='single'){
      var li = (cfg.heads && cfg.heads[0]) ? (+cfg.heads[0].lineset||0) : 0;
      var lso = lsOptsFor(card.dataset.type, btuK(card.dataset.btu), null, card.dataset.volts, card.dataset.family);
      if(lso && lso.length){
        if(li >= lso.length) li = 0;
        card.dataset.lsIdx = li;
        var chip = card.querySelector('.ls-chip');
        if(chip) chip.innerHTML = lso[li].label + ' ' + icon('arrowRt');
      }
    } else if(card.dataset.kind==='multi'){
      var sizes = (cfg.heads||[]).map(function(h){ return +h.sizeK; }).filter(function(n){ return !isNaN(n); });
      if(sizes.length){
        card.dataset.headsizes = sizes.join(',');
        card.querySelectorAll('[data-roll-i]').forEach(function(c,k){ if(sizes[k]!=null) c.textContent = sizes[k]+'k'; });
      }
    }
  }
  /* ---- Stage 2 · SAVED-BUILDS TRAY · foundations (saved flag + eye) ---- */
  function eyeSVG(){ return '<svg class="eye-svg" viewBox="0 0 24 24" aria-hidden="true"><path class="lens" d="M1.5 12C5 6.4 19 6.4 22.5 12C19 17.6 5 17.6 1.5 12Z"/><circle class="pupil" cx="12" cy="12" r="2.9"/></svg>'; }
  function savedCluster(){
    return '<div class="card-saved">'
      + '<span class="saved-tag"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg> Locked</span>'
      + '<button class="card-eye" type="button" data-eye aria-label="Lock this build to come back to it">'+eyeSVG()+'</button>'
      + '</div>';
  }
  function defaultSavedFromCard(card){
    var d=card.dataset;
    if(d.kind==='multi'){
      var sizes=(d.headsizes||'').split(',').map(function(x){return +x;}).filter(function(n){return !isNaN(n)&&n>0;});
      return { heads: sizes.map(function(k){ return {type:'hw-king', sizeK:k, lineset:0, lineGuard:0, pump:0}; }),
               sys:{mount:0,electrical:0}, pipeCutter:0 };
    }
    return { heads:[{type:(d.type||'hw-king'), sizeK:btuK(d.btu), lineset:(parseInt(d.lsIdx,10)||0), lineGuard:0, pump:0}],
             sys:{mount:0,electrical:0}, pipeCutter:0 };
  }
  function isSaved(card){ var k=cardKey(card), b=k?savedBuild(k):null; return !!(b && b.saved); }
  function setSaved(card, on){
    var key=cardKey(card); if(!key) return;
    var b=loadBuilds();
    if(!b[key]){
      if(CFG && CFG.openCard===card){ persistBuild(key, CFG); b=loadBuilds(); }
      else { b[key]=defaultSavedFromCard(card); b[key].ts=Date.now(); }
    }
    if(b[key]){ b[key].saved = on?1:0; saveBuilds(b); }
  }
  function savedCount(){ return loadTray().length; }
  /* On a fresh page load, only LOCKED cards keep their configured state.
     Unlocked configs persist within a session (close/reopen) but are dropped on reload. */
  function pruneUnlockedBuilds(){
    try{ var b=loadBuilds(), out={}, changed=false;
      for(var k in b){ if(b[k] && b[k].saved){ out[k]=b[k]; } else { changed=true; } }
      if(changed) saveBuilds(out);
    }catch(e){}
  }
  function updateSavedCount(){
    if(typeof root==='undefined' || !root) return;
    var n=savedCount();
    var cEl=root.querySelector('[data-saved-count]'); if(cEl) cEl.textContent=n;
    var btn=root.querySelector('[data-saved-btn]'); if(btn) btn.hidden=(n===0);
  }
  function applySavedState(card){ if(card) card.classList.toggle('is-saved', isSaved(card)); }
  function reflectSavedCard(card){
    var k=cardKey(card), sv=k?savedBuild(k):null;
    if(sv){ var c=cfgFromCard(card,sv); setCardPrice(card, totalForBuild(c).total, true); syncCardDisplay(card,c); }
    applySavedState(card);
  }

  /* ---- Stage 2 · SAVED-BUILDS TRAY · store (per-configuration, with qty) ---- */
  var GWIN_TRAY_STORE='gwin_diy_tray_v1';
  /* When a saved build is reopened from the tray (Edit Product), this holds that entry's
     signature so the next Save UPDATES it in place instead of cloning a second card. */
  var PENDING_EDIT_SIG=null;
  var PENDING_HEADS=null;   /* per-zone head sizes (k) handed in from the BTU calculator's "Show me my system" */
  function loadTray(){ try{ if(typeof localStorage==='undefined') return []; var s=localStorage.getItem(GWIN_TRAY_STORE); var a=s?JSON.parse(s):[]; return Array.isArray(a)?a:[]; }catch(e){ return []; } }
  function saveTray(a){ try{ if(typeof localStorage!=='undefined') localStorage.setItem(GWIN_TRAY_STORE, JSON.stringify(a)); }catch(e){} }
  function buildSig(cfg){
    var h=(cfg.heads||[]).map(function(x){ return x.type+':'+(+x.sizeK)+':'+(+x.lineset||0)+':'+(+x.lineGuard||0)+':'+(+x.pump||0); }).join('|');
    return [cfg.kind, cfg.condK, cfg.zones||1, cfg.family||'', cfg.voltage||'', cfg.lockedType||'', h,
            (cfg.sys&&cfg.sys.mount)||0, (cfg.sys&&cfg.sys.electrical)||0, cfg.pipeCutter?1:0].join('~');
  }
  function trayCfgSnapshot(cfg){
    return { kind:cfg.kind, condK:cfg.condK, zones:cfg.zones||1, family:cfg.family||null,
             voltage:cfg.voltage||((cfg.volts&&String(cfg.volts).indexOf('115')>=0)?'115v':'230v'),
             lockedType:cfg.lockedType||(cfg.heads&&cfg.heads[0]&&cfg.heads[0].type)||null,
             title:cfg.title||'', base:cfg.base||0,
             heads:(cfg.heads||[]).map(function(h){ return {type:h.type, sizeK:+h.sizeK, lineset:+h.lineset||0, lineGuard:+h.lineGuard||0, pump:+h.pump||0}; }),
             sys:{mount:+(cfg.sys&&cfg.sys.mount)||0, electrical:+(cfg.sys&&cfg.sys.electrical)||0},
             pipeCutter:cfg.pipeCutter?1:0 };
  }
  function addToTray(cfg){
    if(!cfg) return; var sig=buildSig(cfg); var t=loadTray();
    for(var i=0;i<t.length;i++){ if(t[i].sig===sig){ t[i].qty=(+t[i].qty||1)+1; t[i].ts=Date.now(); saveTray(t); return; } }
    var photo=(cfg.openCard && cfg.openCard._gimgs && cfg.openCard._gimgs[0]) || null;
    t.push({ sig:sig, qty:1, ts:Date.now(), cardKey:(cfg.openCard?cardKey(cfg.openCard):null), photo:photo, cfg:trayCfgSnapshot(cfg) });
    saveTray(t);
  }
  /* Re-saving a build that was reopened from the tray: rewrite THAT entry in place (keeping
     its qty) rather than appending a new card. If the edit makes it identical to a different
     saved build, merge the two. Robust to any minor cfg normalization that happens on reopen. */
  function updateTrayEntry(oldSig, cfg){
    if(!cfg) return;
    var t=loadTray(), newSig=buildSig(cfg), oldIdx=-1, collideIdx=-1, i;
    for(i=0;i<t.length;i++){
      if(t[i].sig===oldSig && oldIdx===-1) oldIdx=i;
      else if(t[i].sig===newSig && collideIdx===-1) collideIdx=i;
    }
    if(oldIdx===-1){ addToTray(cfg); return; }                 /* original gone — add normally */
    var photo=(cfg.openCard && cfg.openCard._gimgs && cfg.openCard._gimgs[0]) || t[oldIdx].photo || null;
    if(collideIdx!==-1 && collideIdx!==oldIdx){                 /* edit now equals another build — merge */
      t[collideIdx].qty=(+t[collideIdx].qty||1)+(+t[oldIdx].qty||1);
      t[collideIdx].ts=Date.now();
      t.splice(oldIdx,1);
    } else {                                                    /* update same entry, keep its qty */
      t[oldIdx].sig=newSig; t[oldIdx].cfg=trayCfgSnapshot(cfg); t[oldIdx].photo=photo; t[oldIdx].ts=Date.now();
    }
    saveTray(t);
  }
  function trayQty(sig, q){ var t=loadTray(); for(var i=0;i<t.length;i++){ if(t[i].sig===sig){ t[i].qty=Math.max(1, q|0); saveTray(t); return; } } }
  function trayRemove(sig){ saveTray(loadTray().filter(function(e){ return e.sig!==sig; })); }
  function trayEntry(sig){ var t=loadTray(); for(var i=0;i<t.length;i++){ if(t[i].sig===sig) return t[i]; } return null; }
  function trayPrice(cfg){ try{ return totalForBuild(cfg).total; }catch(e){ return 0; } }

  function gwinFlash(msg){
    if(typeof root==='undefined' || !root) return;
    var el=root.querySelector('#gwinToast');
    if(!el){ el=document.createElement('div'); el.id='gwinToast'; el.className='gwin-toast'; root.appendChild(el); }
    el.textContent=msg; el.classList.add('on'); clearTimeout(el._t); el._t=setTimeout(function(){ el.classList.remove('on'); }, 2200);
  }

  /* ---- Stage 2 · tray render + open/close + reopen + save+reset ---- */
  function trayTitle(cfg){
    if(cfg.kind==='multi') return cfg.condK+'k · '+(cfg.zones||2)+'-zone';
    var t=TYPE_LABEL[cfg.lockedType]||'High Wall';
    return cfg.condK+'k · '+t;
  }
  function lsClean(label){ return String(label||'').replace(/\s*\(?\s*\+?\s*\$[\d,.]+\s*\)?\s*$/,'').trim(); }
  /* Readable breakdown of the actual selections (no category restatement). Resolved under a
     CFG swap so multi linesets resolve; accessories pulled from the exact cart properties. */
  function trayBreakdown(cfg){
    var prev=CFG; CFG=cfg; var lines=[];
    try{
      var res=null; try{ res=buildCartItems(cfg); }catch(e){}
      var props={};
      if(res && res.items){ res.items.forEach(function(it){ var p=it.properties||{}; for(var k in p){ if(k!=='Build'){ (props[k]=props[k]||[]).push(p[k]); } } }); }
      var heads=cfg.heads||[];
      var volt = cfg.kind==='multi' ? '230v' : (cfg.voltage||'230v');
      var fam = cfg.kind==='multi' ? null : ((typeof condFamily==='function')?condFamily(cfg):null);
      if(cfg.kind==='multi'){
        heads.forEach(function(h, zi){
          var tname=TYPE_LABEL[h.type]||'High Wall';
          var lso=lsOptsFor(h.type, h.sizeK, null, volt, fam);
          var ls=(lso&&lso.length)?lsClean(lso[Math.min(+h.lineset||0, lso.length-1)].label):'';
          lines.push({k:'Zone '+(zi+1)+' · '+h.sizeK+'k '+tname, v: ls?('Lineset '+ls):''});
        });
      } else {
        var h0=heads[0]||{};
        var lso=lsOptsFor(h0.type, h0.sizeK, null, volt, fam);
        var ls=(lso&&lso.length)?lsClean(lso[Math.min(+h0.lineset||0, lso.length-1)].label):'';
        if(ls) lines.push({k:'Lineset', v:ls});
      }
      if(props['Mounting']) lines.push({k:'Mounting', v:props['Mounting'][0]});
      if(props['Electrical']) lines.push({k:'Electrical', v:props['Electrical'][0]});
      if(props['Line guard']) lines.push({k:'Line guard', v:props['Line guard'].join(', ')});
      if(props['Pump']) lines.push({k:'Condensate pump', v:props['Pump'].join(', ')});
      if(cfg.pipeCutter) lines.push({k:'Pipe cutter', v:'Added'});
      lines.push({k:'Licensed tech', v:'Included'});
    }catch(e){}
    CFG=prev;
    return lines;
  }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function photoForEntry(entry){
    if(entry.photo) return entry.photo;
    var c=entry.cardKey?findCardByKey(entry.cardKey):null;
    return (c && c._gimgs && c._gimgs[0]) || null;
  }
  function shareIcon(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>'; }
  function trayCardHTML(entry){
    var cfg=entry.cfg, p=trayPrice(cfg), ico=cfg.kind==='multi'?'truck':'snow';
    var ph=photoForEntry(entry);
    var photo = ph ? '<img class="tc-img" src="'+esc(ph)+'" alt="" loading="lazy">' : icon(ico);
    var detail = trayBreakdown(cfg).map(function(l){
      return '<li><span>'+esc(l.k)+'</span>'+(l.v?'<em>'+esc(l.v)+'</em>':'')+'</li>';
    }).join('');
    return '<div class="tray-card" data-sig="'+esc(entry.sig)+'">'
      + '<div class="tc-photo'+(ph?' has-img':'')+'">'+photo+'</div>'
      + '<div class="tc-body">'
      +   '<div class="tc-title">'+esc(trayTitle(cfg))+'</div>'
      +   '<ul class="tc-detail">'+detail+'</ul>'
      +   '<div class="tc-bottom">'
      +     '<div class="tc-price"><b>'+money(p)+'</b><small>your build</small></div>'
      +     '<div class="tc-qty"><button type="button" data-qty-dec aria-label="Decrease quantity">&minus;</button><span class="tc-q">'+(+entry.qty||1)+'</span><button type="button" data-qty-inc aria-label="Increase quantity">+</button></div>'
      +     '<div class="tc-acts">'
      +       '<button class="tc-cart" type="button" data-tray-cart>Add to cart</button>'
      +       '<div class="tc-actrow">'
      +         '<button class="tc-open" type="button" data-tray-open>Edit product</button>'
      +         '<button class="tc-share" type="button" data-tray-share aria-label="Share this build">'+shareIcon()+'</button>'
      +         '<button class="tc-rm" type="button" data-tray-rm aria-label="Remove from saved builds">&times;</button>'
      +       '</div>'
      +     '</div>'
      +   '</div>'
      + '</div></div>';
  }
  /* ---- cart from tray (CFG-swap so multi resolves; qty multiplies; surfaces real reasons) ---- */
  /* ---- stock/connection guard: catalog id->available map (shape-agnostic walk) ---- */
  var _availMap=null;
  function buildAvailMap(){
    var m={};
    function walk(o){
      if(!o || typeof o!=='object' || o.nodeType) return;
      if(Array.isArray(o)){ for(var i=0;i<o.length;i++) walk(o[i]); return; }
      if(o.id!=null && typeof o.available!=='undefined'){ m[o.id]=(o.available!==false); }
      for(var k in o){ if(Object.prototype.hasOwnProperty.call(o,k)){ var v=o[k]; if(v && typeof v==='object') walk(v); } }
    }
    try{ if(typeof window!=='undefined'){ walk(window.gwin_diy_sales_acc); walk(window.gwin_diy_sales_acc_multi); } }catch(e){}
    return m;
  }
  function availMap(){ if(!_availMap) _availMap=buildAvailMap(); return _availMap; }
  function unavailableInItems(items){
    var m=availMap(), bad=[];
    (items||[]).forEach(function(it){ if(m[it.id]===false){ var p=it.properties||{};
      bad.push(p.Zone||p.Condenser||p.Lineset||p.Mounting||p.Electrical||p['Line guard']||p.Pump||p.Build||'item'); } });
    return bad;
  }
  function itemsForEntry(entry){
    var prev=CFG; CFG=entry.cfg; var res;
    try{ res=buildCartItems(entry.cfg); }catch(e){ res={error:'err', unresolved:['build']}; } finally { CFG=prev; }
    if(!res || res.error || (res.unresolved && res.unresolved.length) || !res.items || !res.items.length){
      return {unresolved:(res && res.unresolved && res.unresolved.length ? res.unresolved : ['this build'])}; }
    var bad=unavailableInItems(res.items);
    if(bad.length){ return {unresolved: bad.map(function(x){ return x+' (out of stock)'; })}; }
    var q=+entry.qty||1;
    return {items: res.items.map(function(it){ return {id:it.id, quantity:(it.quantity||1)*q, properties:it.properties}; })};
  }
  function cartAdd(items){
    return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:items})})
      .then(function(r){ return r.text().then(function(tx){ var d={}; try{ d=JSON.parse(tx); }catch(_){}
        if(!r.ok){ throw new Error((d&&(d.description||d.message))||('Cart error '+r.status)); } return d; }); });
  }
  function cartCount(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ return (c&&c.item_count)||0; }); }
  /* add, then verify the cart actually grew by the expected qty — never claim success otherwise */
  function addItemsVerified(items){
    var want=(items||[]).reduce(function(s,it){ return s+(it.quantity||1); },0);
    return cartCount().then(function(pre){
      return cartAdd(items).then(function(){
        return cartCount().then(function(post){ return {ok:(post>pre && (post-pre)>=want), pre:pre, post:post, want:want}; });
      });
    });
  }
  var GWIN_DRAWER_SEL = '#cart-drawer,.cart-drawer,#CartDrawer,.drawer--cart,.cart-sidebar,.mini-cart,.minicart,.ajaxcart,.slide-cart,#slidecart,[class*="cart-drawer"],[id*="cart-drawer"],[class*="CartDrawer"],[class*="cartDrawer"],[data-cart-drawer]';
  /* the third-party cart drawer (vibe), returned only when actually visible; null when closed */
  function gwinCartDrawerEl(){
    try{
      var els=document.querySelectorAll(GWIN_DRAWER_SEL), vw=window.innerWidth, vh=window.innerHeight;
      for(var i=0;i<els.length;i++){ var el=els[i];
        if(root.contains(el)) continue;
        var cs=getComputedStyle(el);
        if(cs.visibility==='hidden' || cs.display==='none' || (+cs.opacity||1)<0.05) continue;
        var r=el.getBoundingClientRect();
        if(r.width>120 && r.height>120 && r.left < vw-40 && r.right>40 && r.top < vh-40) return el;
      }
    }catch(e){}
    return null;
  }
  function bumpCartUI(cart){
    try{
      var n = cart && cart.item_count!=null ? cart.item_count : null;
      if(n==null) return;
      var sels='[data-cart-count],.cart-count,.cart-count-bubble,.header__cart-count,.cart-item-count,#cart-icon-bubble .cart-count,.site-header__cart-count,.cart-link__bubble,.js-cart-count';
      var found=document.querySelectorAll(sels), themeHas=false;
      found.forEach(function(el){ el.textContent=n; el.removeAttribute('hidden'); if(el.classList){ el.classList.remove('hidden','is-empty'); } themeHas=true; });
      if(!themeHas){
        var link=document.querySelector('header a[href*="/cart"], .header a[href*="/cart"], [class*="header" i] a[href*="/cart"], a[href$="/cart"], a[href*="/cart"]');
        if(link){
          var b=link.querySelector('.gwin-cart-badge');
          if(!b){ b=document.createElement('span'); b.className='gwin-cart-badge'; if(getComputedStyle(link).position==='static') link.style.position='relative'; link.appendChild(b); }
          b.style.cssText='position:absolute;top:-6px;right:-8px;min-width:17px;height:17px;padding:0 4px;border-radius:99px;background:#a855f7;color:#fff;font:700 10px/17px Inter,Arial,sans-serif;display:flex;align-items:center;justify-content:center;z-index:6;box-shadow:0 0 0 2px rgba(0,0,0,.25);';
          b.textContent=n; b.style.display = n>0 ? 'flex' : 'none';
        }
      }
      /* Tell the cart-drawer app (vibe) to re-render its body so it matches Shopify's real
         cart — but ONLY while the drawer is CLOSED, so we never re-render it mid-open (that
         detaches its close button). After an add the drawer is closed, so it refreshes in the
         background and is correct the next time it's opened. */
      if(!gwinCartDrawerEl()){
        ['cart:refresh','cart:updated','cart:change','ajaxCart:afterCartLoad','cart:build'].forEach(function(ev){ try{ document.dispatchEvent(new CustomEvent(ev,{bubbles:true,detail:{cart:cart}})); }catch(_){} });
      }
    }catch(e){}
  }
  function bumpCartCount(n){ bumpCartUI({item_count:n}); }
  function addCartFromTray(entry, btn){
    var r=itemsForEntry(entry);
    if(r.unresolved){ gwinFlash('Can\u2019t add \u2014 '+r.unresolved.slice(0,2).join(', ')); return; }
    var label=btn?btn.textContent:''; if(btn){ btn.disabled=true; btn.textContent='Adding\u2026'; }
    addItemsVerified(r.items).then(function(v){
      if(v.ok){ trayRemove(entry.sig); renderTray(); updateSavedCount(); bumpCartCount(v.post); gwinFlash('Added \u2713 \u00b7 '+v.post+' in cart'); }
      else { if(btn){ btn.disabled=false; btn.textContent=label; } gwinFlash('Couldn\u2019t add \u2014 item may be out of stock'); }
    }).catch(function(err){
      if(btn){ btn.disabled=false; btn.textContent=label; }
      gwinFlash('Could not add: '+((err&&err.message)||'try again'));
    });
  }
  function addAllToCart(btn){
    var t=loadTray(); if(!t.length){ gwinFlash('No saved builds yet'); return; }
    var all=[], addedSigs=[], skipped=0;
    t.forEach(function(e){ var r=itemsForEntry(e); if(r.items){ all=all.concat(r.items); addedSigs.push(e.sig); } else skipped++; });
    if(!all.length){ gwinFlash('None are available to purchase yet'); return; }
    var label=btn?btn.textContent:''; if(btn){ btn.disabled=true; btn.textContent='Adding\u2026'; }
    addItemsVerified(all).then(function(v){
      if(v.ok){ addedSigs.forEach(function(s){ trayRemove(s); }); window.location.href='/cart'; }
      else { if(btn){ btn.disabled=false; btn.textContent=label; } gwinFlash('Couldn\u2019t add \u2014 some items may be out of stock'); }
    }).catch(function(err){
      if(btn){ btn.disabled=false; btn.textContent=label; }
      gwinFlash('Could not add: '+((err&&err.message)||'try again'));
    });
  }
  /* ---- minimal share: copy a link that encodes the build; decoded on load (boot) ---- */
  function copyText(t){
    if(navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function(res, rej){ try{ var ta=document.createElement('textarea'); ta.value=t; ta.style.position='fixed'; ta.style.opacity='0'; document.body.appendChild(ta); ta.focus(); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); res(); }catch(e){ rej(e); } });
  }
  function shareUrl(url, label, copyMsg){
    copyMsg = copyMsg || 'Link copied';
    function doCopy(){ copyText(url).then(function(){ gwinFlash(copyMsg); }).catch(function(){ gwinFlash('Copy failed'); }); }
    if(navigator.share){
      try{
        var p = navigator.share({ url:url, title:'GWIN mini-split build', text:label||'Check out this GWIN build' });
        if(p && p.then) p.then(function(){}).catch(function(err){ if(err && err.name==='AbortError') return; doCopy(); });
        return;
      }catch(e){ /* fall through to copy */ }
    }
    doCopy();
  }
  function packEntry(e){ var c=e.cfg||{}, sys=c.sys||{};
    var heads=(c.heads||[]).map(function(h){ return [h.type, +h.sizeK||0, +h.lineset||0, +h.lineGuard||0, +h.pump||0]; });
    return [ e.qty||1, e.cardKey||null, c.kind, c.condK, c.zones, c.family, c.voltage, c.lockedType, heads, +sys.mount||0, +sys.electrical||0, c.pipeCutter?1:0 ];
  }
  function encBuilds(entries){
    try{
      var json = JSON.stringify(entries.map(packEntry));        /* positional arrays — no key names */
      var b64 = btoa(unescape(encodeURIComponent(json)));        /* UTF-8 safe, no %XX inflation */
      return b64.replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');  /* URL-safe, unpadded */
    }catch(e){ return ''; }
  }
  function shareLink(entries){ return location.origin+location.pathname+'?b='+encBuilds(entries); }
  function shareBuild(entry){
    var url=shareLink([entry]); if(!url){ gwinFlash('Could not build link'); return; }
    shareUrl(url, 'My GWIN mini-split build', 'This build\u2019s link copied');
  }
  function shareAll(){
    var t=loadTray(); if(!t.length){ gwinFlash('No saved builds to share'); return; }
    var url=shareLink(t); if(!url){ gwinFlash('Could not build link'); return; }
    shareUrl(url, 'My GWIN mini-split builds', 'Link to all '+t.length+' builds copied');
  }
  function unpackEntry(a){
    if(!Array.isArray(a)) return null;
    var heads=(a[8]||[]).map(function(h){ return {type:h[0], sizeK:+h[1]||0, lineset:+h[2]||0, lineGuard:+h[3]||0, pump:+h[4]||0}; });
    var cfg={ kind:a[2], condK:a[3], zones:a[4], family:a[5], voltage:a[6], lockedType:a[7], heads:heads, sys:{mount:+a[9]||0, electrical:+a[10]||0}, pipeCutter:a[11] };
    return { sig:buildSig(cfg), qty:a[0]||1, ts:Date.now(), cardKey:a[1]||null, photo:null, cfg:cfg };
  }
  function parseSharedBuilds(){
    var m=String(location.search||'').match(/[?&]b=([^&]+)/); if(!m) return [];
    var raw=m[1], data=null;
    try{ var s=raw.replace(/-/g,'+').replace(/_/g,'/'); while(s.length%4) s+='='; data=JSON.parse(decodeURIComponent(escape(atob(s)))); }  /* compact base64url */
    catch(e){ try{ data=JSON.parse(decodeURIComponent(atob(decodeURIComponent(raw)))); }catch(e2){ return []; } }                          /* back-compat old links */
    if(!Array.isArray(data)) data=(data&&data.c)?[data]:[];
    if(data.length && Array.isArray(data[0])) return data.map(unpackEntry).filter(Boolean);                                                /* positional-array format */
    return data.filter(function(o){ return o && o.c; }).map(function(o){ var cfg=o.c;                                                       /* object format */
      return { sig:buildSig(cfg), qty:o.q||1, ts:Date.now(), cardKey:o.k||null, photo:o.p||null, cfg:cfg }; });
  }
  function traySpec(cfg){
    if(cfg.kind==='multi') return (cfg.heads||[]).map(function(h){ return h.sizeK+'k'; }).join(' · ');
    return 'Single zone';
  }
  function renderTray(){
    if(typeof root==='undefined' || !root) return;
    var reel=root.querySelector('#trayReel'); if(!reel) return;
    var t=loadTray();
    reel.innerHTML = t.length ? t.map(trayCardHTML).join('')
      : '<div class="tray-empty">No saved builds yet. Open a system, configure it, and hit <b>Save build</b> &mdash; it lands here.</div>';
    var tot=0; t.forEach(function(e){ tot += trayPrice(e.cfg)*(+e.qty||1); });
    var tEl=root.querySelector('#trayTotal'); if(tEl) tEl.textContent=money(tot);
    var mEl=root.querySelector('#trayMo'); if(mEl) mEl.textContent=monthly(tot);
    var cEl=root.querySelector('#trayCountHd'); if(cEl) cEl.textContent=t.length;
  }
  function openTray(){ var ov=root.querySelector('#trayOverlay'); if(!ov) return; renderTray(); ov.hidden=false; }
  function closeTray(){ var ov=root.querySelector('#trayOverlay'); if(ov) ov.hidden=true; }
  function findCardByKey(k){ if(!k) return null; var f=null; root.querySelectorAll('.scard').forEach(function(c){ if(!f && cardKey(c)===k) f=c; }); return f; }
  function reopenTrayBuild(entry){
    var card=entry.cardKey?findCardByKey(entry.cardKey):null;
    if(!card){ gwinFlash('That product is no longer available'); return; }
    var b=loadBuilds(); var prev=(b[entry.cardKey]&&b[entry.cardKey].saved)||0;
    b[entry.cardKey]={ heads:entry.cfg.heads, sys:entry.cfg.sys, pipeCutter:entry.cfg.pipeCutter, saved:prev, ts:Date.now() };
    saveBuilds(b);
    closeTray();
    setTab(entry.cfg.kind==='multi'?'multi':'single');
    PENDING_EDIT_SIG = entry.sig;                 /* next Save updates THIS entry, not a clone */
    setTimeout(function(){ openConfig(card); }, 70);
  }
  function addSharedToTray(entries){
    var t=loadTray(), added=0;
    entries.forEach(function(e){ if(!t.some(function(x){ return x.sig===e.sig; })){ t.push(e); added++; } });
    if(added) saveTray(t);
    return added;
  }
  /* A shared single-build link: open that product, configured and ready. Falls back to
     the tray if the card isn't on this page (e.g. shared across different catalogs). */
  function openSharedProduct(entry){
    var card = entry.cardKey ? findCardByKey(entry.cardKey) : null;
    if(!card){ addSharedToTray([entry]); updateSavedCount(); openTray(); return; }
    var b=loadBuilds(); var prev=(b[entry.cardKey]&&b[entry.cardKey].saved)||0;
    b[entry.cardKey]={ heads:entry.cfg.heads, sys:entry.cfg.sys, pipeCutter:entry.cfg.pipeCutter, saved:prev, ts:Date.now() };
    saveBuilds(b);
    setTab(entry.cfg.kind==='multi'?'multi':'single');
    setTimeout(function(){ openConfig(card); }, 60);
  }
  function resetCardToDefault(card){
    if(!card) return;
    var key=cardKey(card); if(key) clearBuild(key);
    if(card.dataset.kind==='single'){ card.dataset.lsIdx='0'; }
    else if(card.dataset.kind==='multi'){
      var z=+card.dataset.zones||2, condK=btuK(card.dataset.btu);
      var def=(typeof defaultHeads==='function') ? (defaultHeads(condK, z, 'hw-king')||[]) : [];
      if(def.length){ card.dataset.headsizes=def.join(','); card.querySelectorAll('[data-roll-i]').forEach(function(c,k){ if(def[k]!=null) c.textContent=def[k]+'k'; }); }
    }
    card.classList.remove('is-saved');
    if(card.dataset.kind==='single') refreshSingleCardPrices(); else refreshMultiCardPrices();
  }

  var TYPE_LABEL = {'hw-king':'High Wall','hw-emp':'High Wall','cassette':'Slim Cassette','ducted':'Hidden Ducted','ducted-central':'Central Ducted','emp-4way':'4-Way Cassette','emp-console':'Compact Console','hw-clean':'Clean Air'};

  /* ===================== W1 · CATALOG PRICE RESOLUTION =====================
     Maps a configured system (CFG) to the catalog (window.gwin_diy_sales_acc).
     No UI here — resolvers are exposed on GWIN_ENGINE for console verification.
     Each resolver takes an optional catalog arg (defaults to ACC_CAT) for testing. */

  function accCatalog(cat){ return cat || (typeof window!=='undefined' && window.gwin_diy_sales_acc) || ACC_CAT || {}; }

  /* ----- MULTI catalog (separate data section: window.gwin_diy_sales_acc_multi) ----- */
  function multiCat(){ return (typeof window!=='undefined' && window.gwin_diy_sales_acc_multi) || {}; }
  function multiCondenser(zones, condK){ var a=(multiCat().condensers)||[]; for(var i=0;i<a.length;i++){ if(+a[i].zones===+zones && +a[i].size===+condK) return a[i]; } return null; }
  function multiHead(type, sizeK){ var a=(multiCat().handlers)||[]; for(var i=0;i<a.length;i++){ if(a[i].type===type && +a[i].size===+sizeK) return a[i]; } return null; }
  /* auto-hide-when-empty: a type/size is "connected" only if a real product is wired to it.
     handler entries are emitted ONLY when a product is connected, so presence == connected. */
  function multiTypeConnected(type){ var a=(multiCat().handlers)||[]; for(var i=0;i<a.length;i++){ if(a[i].type===type) return true; } return false; }
  function multiAnyConnected(){ return (((multiCat().handlers)||[]).length>0); }
  function multiConnectedSizes(type){ var a=(multiCat().handlers)||[], out=[]; for(var i=0;i<a.length;i++){ if(a[i].type===type) out.push(+a[i].size); } return out; }
  function multiAccOpts(cfg, kind){ cfg=cfg||CFG; var mc=cfg?multiCondenser(cfg.zones,cfg.condK):null; var a=(mc&&((kind==='mount')?mc.mounting:mc.electrical))||[]; var opts=[{label:'None',price:0,variantId:null}]; a.forEach(function(p){ if(p){ var v=(p.variants||[])[0]; opts.push({label:p.title,price:v?v.price:(p.price||0),variantId:v?v.id:null}); } }); return opts; }

  /* which condenser family a configured system uses */
  function condFamily(cfg){
    if(!cfg) return null;
    if(cfg.kind === 'multi') return 'multi';
    if(cfg.family) return cfg.family;               /* condenser-led: family comes from the tab */
    var t = cfg.lockedType || (cfg.heads && cfg.heads[0] && cfg.heads[0].type) || 'hw-king';
    if(t === 'hw-king') return 'king';
    if(t === 'hw-clean') return 'clean';
    return 'emperor';                               /* hw-emp / cassette / ducted default */
  }

  /* find a variant on a product: own-mode = default variant; variant-mode = exact
     title override if given, else auto-match by size (digit-boundary, so 9 != 19). */
  function resolveVariant(product, opts){
    if(!product || !product.variants || !product.variants.length) return null;
    var vars = product.variants;
    opts = opts || {};
    if(opts.source === 'own' || opts.source === 'independent') return vars[0];
    if(opts.override){
      for(var i=0;i<vars.length;i++){ if(vars[i].title === opts.override) return vars[i]; }
    }
    if(opts.size != null){
      var sz = String(opts.size);
      var re = new RegExp('(^|[^0-9])' + sz + '(k|K|,?000)?([^0-9]|$)');
      for(var j=0;j<vars.length;j++){ if(re.test(String(vars[j].title))) return vars[j]; }
    }
    return vars[0];
  }

  function findSystem(type, sizeK, cat, voltage, family){
    voltage = voltage || (typeof CFG !== 'undefined' && CFG && CFG.voltage) || null;
    family  = family  || (typeof CFG !== 'undefined' && CFG && CFG.family)  || null;
    var vKey = voltage ? voltKey(voltage) : null;   /* normalize '115V'/'115v'/'208–230V' -> '115v'/'230v' */
    var ss = accCatalog(cat).systems || [];
    for(var i=0;i<ss.length;i++){
      if(ss[i].type === type && ss[i].size === sizeK
         && (!vKey   || voltKey(ss[i].voltage) === vKey)
         && (!family || ss[i].family  === family)) return ss[i];
    }
    return null;
  }
  /* back-compat shims (older call sites) */
  function findHandler(type, sizeK, cat){ return findSystem(type, sizeK, cat); }
  function findCondenser(){ return null; } /* per-card: condenser lives inside the system */

  /* resolve a configured single-zone build (per-card model) to real variant ids + prices.
     One system entry (type+size) holds everything. Bundle => one product = condenser+
     air handler+15ft+tech; else condenser + air handler separately. Multi-zone is not
     covered by the per-card model yet -> reported unresolved (placeholder stays). */
  function resolveBuild(cfg, cat){
    cfg = cfg || CFG;
    if(!cfg) return null;
    var out = { bundle:null, condenser:null, heads:[], total:0, unresolved:[] };
    var heads = cfg.heads || [];
    if(cfg.kind === 'multi' || heads.length !== 1){
      var mc = multiCondenser(cfg.zones, cfg.condK);
      if(mc && mc.product){
        var mcv = resolveVariant(mc.product, {source:mc.source, override:mc.variant, size:cfg.condK});
        if(mcv){ out.condenser = {variantId:mcv.id, price:mcv.price, title:mcv.title}; out.total += mcv.price; }
        else out.unresolved.push('multi condenser ' + cfg.zones + 'z ' + cfg.condK + 'k');
      } else out.unresolved.push('multi condenser ' + cfg.zones + 'z ' + cfg.condK + 'k');
      heads.forEach(function(h){
        var rec = {type:h.type, sizeK:h.sizeK, component:null, lineset:null};
        var mh = multiHead(h.type, h.sizeK);
        if(mh && mh.product){
          var hv = resolveVariant(mh.product, {source:mh.source, override:mh.variant, size:h.sizeK});
          if(hv){ rec.component = {variantId:hv.id, price:hv.price, title:hv.title}; out.total += hv.price; }
          else out.unresolved.push('multi head ' + h.type + ' ' + h.sizeK + 'k');
        } else out.unresolved.push('multi head ' + h.type + ' ' + h.sizeK + 'k');
        /* per-head lineset reuses the single-zone catalog by (type,size,230v) — 1-a */
        var mlso = lsOptsFor(h.type, h.sizeK, cat, '230v', null);
        var mlb = (mlso && mlso.length) ? mlso[0] : null;
        if(mlb && mlb.variantId != null){ rec.lineset = {variantId:mlb.variantId, price:mlb.price, title:mlb.label}; out.total += mlb.price; }
        else out.unresolved.push('multi lineset ' + h.type + ' ' + h.sizeK + 'k');
        out.heads.push(rec);
      });
      return out;
    }
    var h0 = heads[0];
    var sys = findSystem(h0.type, h0.sizeK, cat, cfg.voltage, condFamily(cfg));
    var rec = { type:h0.type, sizeK:h0.sizeK, component:null, lineset:null };
    if(!sys){ out.unresolved.push('system ' + h0.type + ' ' + h0.sizeK + 'k'); out.heads.push(rec); return out; }

    if(sys.connectionType === 'bundle'){
      var bv = resolveVariant(sys.bundle, {source:sys.bundleSource, override:sys.bundleVariant, size:h0.sizeK});
      if(bv){ out.bundle = {variantId:bv.id, price:bv.price, title:bv.title}; out.total += bv.price; }
      else out.unresolved.push('bundle ' + h0.type + ' ' + h0.sizeK + 'k');
    } else {
      var cv = resolveVariant(sys.condenser, {source:sys.condenserSource, override:sys.condenserVariant, size:h0.sizeK});
      if(cv){ out.condenser = {variantId:cv.id, price:cv.price, title:cv.title}; out.total += cv.price; }
      else out.unresolved.push('condenser ' + h0.type + ' ' + h0.sizeK + 'k');
      var av = resolveVariant(sys.handler, {source:sys.handlerSource, override:sys.handlerVariant, size:h0.sizeK});
      if(av){ rec.component = {variantId:av.id, price:av.price, title:av.title}; out.total += av.price; }
      else out.unresolved.push('air handler ' + h0.type + ' ' + h0.sizeK + 'k');
    }
    var lso = lsOptsFor(h0.type, h0.sizeK, cat, cfg.voltage, condFamily(cfg));
    var lb = (lso && lso.length) ? lso[0] : null;
    if(lb && lb.variantId != null){ rec.lineset = {variantId:lb.variantId, price:lb.price, title:lb.label}; out.total += lb.price; }
    else out.unresolved.push('lineset ' + h0.type + ' ' + h0.sizeK + 'k');
    out.heads.push(rec);
    return out;
  }


  /* W2 — real lineset length options for a head (type, size), shaped like ACC.linesetOpts
     [{label, price, variantId}]. The included (15 ft / $0) option is forced first so
     index 0 stays the default everywhere. Placeholder ACC.linesetOpts until connected. */
  /* MULTIZONE lineset options for one handler (type+size), resolved straight from the multi
     catalog. Standalone so the cart/price paths never depend on global CFG.kind being set. */
  function multiLsOpts(type, sizeK){
    var mhls = multiHead(type, sizeK);
    if(mhls && mhls.lineset && mhls.lineset.variants && mhls.lineset.variants.length){
      var mopts = mhls.lineset.variants.map(function(v){ return {label:v.title, price:v.price, variantId:v.id}; });
      var mi=-1, mj; for(mj=0;mj<mopts.length;mj++){ if(/15/.test(String(mopts[mj].label))){ mi=mj; break; } }   /* 15-ft length first */
      if(mi>0){ mopts.unshift(mopts.splice(mi,1)[0]); }
      return mopts;
    }
    return ACC.linesetOpts;   /* no multi lineset connected → generic placeholder, NEVER single-zone */
  }
  function lsOptsFor(type, sizeK, cat, voltage, family){
    if(CFG && CFG.kind==='multi'){ return multiLsOpts(type, sizeK); }
    var sys = findSystem(type, sizeK, cat, voltage, family);
    var opts = null;
    if(sys && sys.linesetMode === 'separate' && sys.linesetLengths && sys.linesetLengths.length){
      /* separate mode: each connected product is one length (use its first/default variant) */
      opts = [];
      sys.linesetLengths.forEach(function(p){
        var v = p && p.variants && p.variants[0];
        if(v){ opts.push({label:(p.title||v.title), price:v.price, variantId:v.id}); }
      });
      if(!opts.length) opts = null;
    } else if(sys && sys.lineset && sys.lineset.variants && sys.lineset.variants.length){
      /* variants mode: one product, its variants are the lengths */
      opts = sys.lineset.variants.map(function(v){ return {label:v.title, price:v.price, variantId:v.id}; });
    }
    if(!opts) return ACC.linesetOpts;
    var incl = -1, i;
    for(i=0;i<opts.length;i++){ if(opts[i].price===0){ incl=i; break; } }
    if(incl<0){ for(i=0;i<opts.length;i++){ if(/15/.test(String(opts[i].label))){ incl=i; break; } } }
    if(incl>0){ opts.unshift(opts.splice(incl,1)[0]); }
    return opts;
  }

  /* W3 — real condenser mounting/electrical options for the configured system.
     Matched by family+size. "None" first (opt-in default). Only connected SKUs shown,
     with friendly labels + real prices. Placeholder ACC[kind] until the condenser is
     connected (kind is 'mount' or 'electrical'). */
  var COND_ACC_LABELS = {
    mount:      { pad:'Pad', wall_bracket:'Wall-bracket', ground_stand:'Ground-stand' },
    electrical: { whip:'Whip', disconnect:'Standard disconnect', whip_disconnect:'Whip + standard disconnect',
                  disconnect_surge:'Disconnect w/ surge', whip_disconnect_surge:'Whip + disconnect w/ surge' }
  };
  var COND_ACC_ORDER = {
    mount:      ['pad','wall_bracket','ground_stand'],
    electrical: ['whip','disconnect','whip_disconnect','disconnect_surge','whip_disconnect_surge']
  };
  /* Per-card option list for the configured single-zone system. kind: 'mount'|'electrical'
     |'lineGuard'|'pump'. "None" first; options are the connected products (label = title). */
  function sysOptsFor(cfg, kind, cat, head){
    var heads = cfg ? (cfg.heads||[]) : [];
    var h = head || heads[0];
    if(cfg && cfg.kind==='multi'){
      if(kind==='mount'||kind==='electrical') return multiAccOpts(cfg, kind);
      var mh0 = h ? multiHead(h.type, h.sizeK) : null;
      if(!mh0) return null;
      if(kind==='pump' && mh0.offersPump===false) return [{label:'None', price:0, variantId:null}];
      var mp0 = (kind==='lineGuard') ? mh0.lineGuard : mh0.pump;
      var mo0 = [{label:'None', price:0, variantId:null}];
      if(mp0 && mp0.handle){ var mv0=(mp0.variants||[])[0]; mo0.push({label:mp0.title, price:mv0?mv0.price:(mp0.price||0), variantId:mv0?mv0.id:null}); }
      return mo0;
    }
    var sys = h ? findSystem(h.type, h.sizeK, cat, (cfg && cfg.voltage) || '230v', condFamily(cfg)) : null;
    if(!sys) return null;
    var keyMap = { mount:'mounting', electrical:'electrical', lineGuard:'lineGuard', pump:'pump' };
    var arr = sys[keyMap[kind]] || [];
    var opts = [{label:'None', price:0, variantId:null}];
    arr.forEach(function(p){ if(p){ var v=(p.variants||[])[0]; opts.push({label:p.title, price: v?v.price:(p.price||0), variantId: v?v.id:null}); } });
    return opts;
  }
  function condAccOpts(cfg, kind, cat){
    if(cfg && cfg.kind === 'multi'){ var mo = multiAccOpts(cfg, kind); return mo.length > 1 ? mo : ACC[kind]; }
    var opts = sysOptsFor(cfg, kind, cat);
    return opts ? opts : ACC[kind];
  }

  /* line guard / pump option list: real per-card options, else [None, placeholder]. */
  function accOptsList(key, cat, head){
    var o = sysOptsFor(CFG, key, cat, head);
    if(o) return o;
    var pl = ACC[key] || {label:key, price:0};
    return [{label:'None', price:0, variantId:null}, {label:pl.label, price:pl.price, variantId:null}];
  }
  /* adaptive control: checkbox when 0-1 options connected, dropdown when 2+. Index-based state. */
  function accControl(key, i, h){
    var list = accOptsList(key, null, h);
    var connected = list.length - 1;
    var cur = Math.min(+h[key]||0, list.length-1);
    var lbl = (ACC[key] && ACC[key].label) || key;
    if(connected >= 2){
      return '<div class="cfg-field" style="margin-top:10px;"><label>'+lbl+' <button class="moreinfo-sm" data-info="'+key+'" aria-label="More info">'+icon('info')+'</button></label>'
        + cfgSelect('data-head="'+i+'" data-accsel="'+key+'"', cur, list.map(function(o,idx){ return {value:idx, label:(idx===0?'None':optPriceLabel(o))}; }))+'</div>';
    }
    var price = list[1] ? list[1].price : 0;
    return '<div class="acc-line">'
      + '<input type="checkbox" id="'+key+i+'" '+(cur>=1?'checked':'')+' data-head="'+i+'" data-acc="'+key+'">'
      + '<span class="acc-name">'+lbl+' <button class="moreinfo-sm" data-info="'+key+'" aria-label="More info">'+icon('info')+'</button></span>'
      + '<span class="acc-price">+'+money(price)+'</span></div>';
  }
  /* line guard + pump pricing: first connected option for the configured system
     (multi-option picker UI is a follow-on; today the checkbox uses the first option). */
  function univAccPrice(key, cat){
    var opts = sysOptsFor(CFG, key, cat);
    if(opts && opts.length > 1) return opts[1].price;
    return ACC[key] ? ACC[key].price : 0;
  }
  function univAccVariant(key, cat){
    var opts = sysOptsFor(CFG, key, cat);
    if(opts && opts.length > 1) return opts[1].variantId;
    return null;
  }

  /* W5 — resolve a configured build to /cart/add.js line items.
     Returns {items:[...]} or {error:'unresolved', unresolved:[...]}.
     1-a bundle: if a single-zone (type,size) has a bundle product, add the bundle
     and skip separate condenser+component; else condenser + each component.
     Every line carries a "Build" group property (4-a). Only real variant ids are added;
     anything that can't resolve is reported as unresolved (2-a blocks the add). */
  function buildCartItems(cfg, cat){
    cfg = cfg || CFG;
    if(!cfg) return {error:'no-config', unresolved:['configuration']};
    var items = [], unresolved = [];
    var buildLabel = (cfg.title || ((cfg.kind==='multi'?'Multi-zone ':'Single-zone ')+cfg.condK+'k'));
    function add(variantId, qty, label, extra){
      if(variantId == null){ unresolved.push(label); return; }
      var props = {'Build': buildLabel};
      if(extra){ for(var k in extra){ props[k] = extra[k]; } }
      items.push({ id: variantId, quantity: qty||1, properties: props });
    }
    var heads = cfg.heads || [];
    if(cfg.kind === 'multi' || heads.length !== 1){
      /* condenser (one) */
      var mc = multiCondenser(cfg.zones, cfg.condK);
      if(mc && mc.product){ var mcv = resolveVariant(mc.product, {source:mc.source, override:mc.variant, size:cfg.condK});
        add(mcv && mcv.id, 1, 'multi condenser ' + cfg.zones + 'z ' + cfg.condK + 'k', {'Condenser': cfg.zones + '-zone ' + cfg.condK + 'k'}); }
      else unresolved.push('multi condenser ' + cfg.zones + 'z ' + cfg.condK + 'k');
      /* per zone: head + lineset + guard + pump */
      heads.forEach(function(h, zi){
        var zone = 'Zone ' + (zi+1);
        var mh = multiHead(h.type, h.sizeK);
        if(mh && mh.product){ var hv = resolveVariant(mh.product, {source:mh.source, override:mh.variant, size:h.sizeK});
          add(hv && hv.id, 1, zone + ' head ' + h.type + ' ' + h.sizeK + 'k', {'Zone': zone + ' · ' + h.sizeK + 'k ' + h.type}); }
        else unresolved.push(zone + ' head ' + h.type + ' ' + h.sizeK + 'k');
        var lso = multiLsOpts(h.type, h.sizeK);
        var lsv = (lso && lso.length) ? lso[Math.min(h.lineset||0, lso.length-1)] : null;
        if(lsv && lsv.variantId != null){ add(lsv.variantId, 1, zone + ' lineset', {'Zone': zone, 'Lineset': lsv.label}); }
        else unresolved.push(zone + ' lineset ' + h.type + ' ' + h.sizeK + 'k');
        var lgL = sysOptsFor(cfg, 'lineGuard', cat, h), lgi = Math.min(+h.lineGuard||0, (lgL||[]).length-1);
        if(lgi>0 && lgL[lgi] && lgL[lgi].variantId!=null){ add(lgL[lgi].variantId, 1, zone + ' line guard', {'Zone': zone, 'Line guard': lgL[lgi].label}); }
        var pmL = sysOptsFor(cfg, 'pump', cat, h), pmi = Math.min(+h.pump||0, (pmL||[]).length-1);
        if(pmi>0 && pmL[pmi] && pmL[pmi].variantId!=null){ add(pmL[pmi].variantId, 1, zone + ' condensate pump', {'Zone': zone, 'Pump': pmL[pmi].label}); }
      });
      /* system-level mounting + electrical (multi catalog) */
      var mmo = condAccOpts(cfg, 'mount', cat), mmi = Math.min(cfg.sys.mount||0, mmo.length-1);
      if(mmi > 0 && mmo[mmi].variantId!=null){ add(mmo[mmi].variantId, 1, 'mounting', {'Mounting': mmo[mmi].label}); }
      var meo = condAccOpts(cfg, 'electrical', cat), mei = Math.min(cfg.sys.electrical||0, meo.length-1);
      if(mei > 0 && meo[mei].variantId!=null){ add(meo[mei].variantId, 1, 'electrical', {'Electrical': meo[mei].label}); }
      /* shared pipe cutter (opt-in) */
      if(cfg.pipeCutter){ var mpc=(accCatalog()||{}).pipeCutter; var mpv=mpc&&mpc.variants&&mpc.variants[0]; if(mpc&&mpc.handle){ add(mpv&&mpv.id, 1, 'pipe cutter'); } }
      /* tech — one $0 included line; reuse first head's single-zone tech */
      var mtech = findSystem(heads[0].type, heads[0].sizeK, cat, '230v', null);
      if(mtech && mtech.tech && mtech.tech.variants && mtech.tech.variants[0]){ add(mtech.tech.variants[0].id, 1, 'tech', {'Included':'Tech inspection & commissioning'}); }
      if(unresolved.length) return {error:'unresolved', unresolved:unresolved, items:items};
      return {items:items};
    }
    var h0 = heads[0];
    var sys = findSystem(h0.type, h0.sizeK, cat, cfg.voltage, condFamily(cfg));
    if(!sys){ return {error:'unresolved', unresolved:['system ' + h0.type + ' ' + h0.sizeK + 'k']}; }

    if(sys.connectionType === 'bundle'){
      var bv = resolveVariant(sys.bundle, {source:sys.bundleSource, override:sys.bundleVariant, size:h0.sizeK});
      add(bv && bv.id, 1, 'bundle ' + h0.type + ' ' + h0.sizeK + 'k');
    } else {
      var cv = resolveVariant(sys.condenser, {source:sys.condenserSource, override:sys.condenserVariant, size:h0.sizeK});
      add(cv && cv.id, 1, 'condenser ' + h0.type + ' ' + h0.sizeK + 'k');
      var av = resolveVariant(sys.handler, {source:sys.handlerSource, override:sys.handlerVariant, size:h0.sizeK});
      add(av && av.id, 1, 'air handler ' + h0.type + ' ' + h0.sizeK + 'k');
    }

    var lso = lsOptsFor(h0.type, h0.sizeK, cat, cfg.voltage, condFamily(cfg));
    var lsv = lso[Math.min(h0.lineset||0, lso.length-1)];
    if(lsv && lsv.variantId != null){ add(lsv.variantId, 1, 'lineset', {'Lineset': lsv.label}); }
    else unresolved.push('lineset ' + h0.type + ' ' + h0.sizeK + 'k');

    if(cfg.pipeCutter){ var pcat=(accCatalog()||{}).pipeCutter; var pcv=pcat&&pcat.variants&&pcat.variants[0];
      if(pcat&&pcat.handle){ add(pcv&&pcv.id, 1, 'pipe cutter'); } }

    var mo = condAccOpts(cfg, 'mount', cat), mi = Math.min(cfg.sys.mount||0, mo.length-1);
    if(mi > 0){ add(mo[mi].variantId, 1, 'mounting', {'Mounting': mo[mi].label}); }
    var eo = condAccOpts(cfg, 'electrical', cat), ei = Math.min(cfg.sys.electrical||0, eo.length-1);
    if(ei > 0){ add(eo[ei].variantId, 1, 'electrical', {'Electrical': eo[ei].label}); }

    var lgi = +h0.lineGuard||0; if(lgi>0 && sys.lineGuard && sys.lineGuard[lgi-1]){ var lgp=sys.lineGuard[lgi-1]; var lgv=(lgp.variants||[])[0]; add(lgv && lgv.id, 1, 'line guard', {'Line guard':lgp.title}); }
    var pmi = +h0.pump||0; if(pmi>0 && sys.pump && sys.pump[pmi-1]){ var pmp=sys.pump[pmi-1]; var pmv=(pmp.variants||[])[0]; add(pmv && pmv.id, 1, 'condensate pump', {'Pump':pmp.title}); }

    /* tech — $0 included line (locked) */
    if(sys.tech && sys.tech.variants && sys.tech.variants[0]){ add(sys.tech.variants[0].id, 1, 'tech', {'Included':'Tech inspection & commissioning'}); }

    if(unresolved.length) return {error:'unresolved', unresolved:unresolved, items:items};
    return {items:items};
  }

  /* ===================== CARD / RAIL BUILDERS ===================== */
  function railNav(){return '<div class="rail-nav">'
    + '<button class="nudge" data-nudge="prev" aria-label="Previous">'+icon('arrowL')+'</button>'
    + '<button class="nudge" data-nudge="next" aria-label="Next">'+icon('arrowR')+'</button></div>';}

  var _aboutSeq = 0; var ABOUT_DETAILS = {};
  function aboutCard(c){
    var id = 'ab' + (_aboutSeq++);
    var entry = c.more ? Object.assign({}, c.more) : { html: '<p>' + c.d + '</p>' };
    if(!entry.title) entry.title = c.t;
    if(entry.photos == null) entry.photos = 3;
    ABOUT_DETAILS[id] = entry;
    return '<article class="acard"><div class="ic">'+icon(c.ic)+'</div>'
      + '<h4>'+c.t+'</h4><p>'+c.d+'</p>'
      + '<button class="acard-more" data-about="'+id+'" type="button">'+icon('info')+' More details</button></article>';
  }

  /* ===================== INFO POPOVERS (Phase 4A) =====================
     Small centered tooltip-modal shared by: tech "Learn more", the calculator
     "why" tips, about-card "More details", and (Phase 4B) the configurator (i)
     buttons. Content seeded verbatim from the mockup; editable later (Phase 6).
     Photo gallery is gated by GWIN_CFG.infoPhotos (editor toggle, default on). */
  var INFO_PHOTOS = !(typeof GWIN_CFG!=='undefined' && GWIN_CFG.infoPhotos===false);
  var INFO = {
    tech:{title:'Tech included — the Tech Guarantee', photos:3, links:[{label:'How the tech visit works', url:'https://gwinhvac.com'}], html:`
      <p>Every GWIN system includes a licensed HVAC technician — not an upsell. The tech delivers and leak-tests the refrigerant and commissions startup.</p>
      <ul><li><b>Local · Drive · Fly</b> — no local tech? GWIN drives or flies one in.</li>
      <li><b>Refund + keep the equipment</b> — if GWIN can't place a tech within 30 days of your readiness, full refund and you keep the system.</li></ul>
      <p>GWIN has never failed to place a tech.</p>
      <p class="info-ph">★ Placeholder copy.</p>`},
    pump:{title:'Condensate pump', photos:2, html:`
      <p>A condensate pump lifts and pushes drain water away when it can't flow downhill on its own.</p>
      <p><b>Exterior-wall placement is recommended whenever possible</b> — it usually drains by gravity, no pump needed. Add a condensate pump when the air handler sits on an <b>interior wall</b>, in a basement, or anywhere a gravity drain can't reach the outside.</p>
      <p class="info-ph">★ Placeholder — replace with real product copy.</p>`},
    lineGuard:{title:'Line guard (cover kit)', photos:2, html:`
      <p>A paintable channel that conceals and protects the refrigerant lineset, drain line, and control wire along the wall.</p>
      <p><b>Use case:</b> any exposed exterior run, or an interior run you want to look finished.</p>
      <p class="info-ph">★ Placeholder — add lengths &amp; color options.</p>`},
    mount:{title:'Condenser mounting', photos:2, html:`
      <p>How the outdoor condenser is supported — choose one:</p>
      <ul><li><b>Pad</b> — rests on the ground on a composite or plastic pad.</li>
      <li><b>Wall bracket</b> — bolts to an exterior wall, up off the ground.</li>
      <li><b>Ground stand</b> — elevated legs for snow or flood clearance.</li></ul>
      <p class="info-ph">★ Placeholder — add dimensions &amp; weight ratings.</p>`},
    electrical:{title:'Electrical hookup', photos:2, html:`
      <p>Options to connect the condenser to power:</p>
      <ul><li><b>Whip</b> — flexible pre-wired conduit whip.</li>
      <li><b>Disconnect</b> — code-required service disconnect box.</li>
      <li><b>Whip + disconnect</b> — both together.</li>
      <li><b>Disconnect w/ surge</b> — disconnect with surge protection.</li>
      <li><b>Disconnect w/ surge + whip</b> — the complete kit.</li></ul>
      <p class="info-ph">★ Placeholder — confirm against local code.</p>`},
    lineset:{title:'Lineset length', photos:2, html:`
      <p>15 ft of insulated, flare-less, cut-to-length lineset is included per zone. Add length here if the head sits farther from the condenser.</p>
      <p class="info-ph">★ Placeholder.</p>`},
    sizing:{title:'How air-handler sizing works', photos:2, html:`
      <p>The air handlers you choose must add up to <b>at least half</b> of the condenser's size and <b>no more than 6k over</b> it.</p>
      <p>That's why the size menu only shows sizes that keep your combination in range — you can't accidentally under- or over-size the system.</p>
      <p class="info-ph">★ Placeholder — link the full sizing guide.</p>`},
    btuWhy:{title:'Why is the BTU more than the room size?', html:`
      <p>The number the calculator shows is the room's <b>heat load</b> in BTU — not its square footage. We size the system to that load, then round up to the nearest real unit size.</p>
      <p>The load runs higher than a simple "sq ft" figure because it also accounts for <b>ceiling height, climate, sun, windows and insulation</b>. Sizing a little above the bare minimum keeps the system from running flat-out and lets it dehumidify properly.</p>
      <p class="info-ph">★ Placeholder — link the full sizing guide.</p>`},
    ceilingWhy:{title:'Why ceiling height matters', html:`
      <p>BTU load is about the <b>volume</b> of air you're conditioning, not just the floor area. A room with tall or vaulted ceilings holds more air, so it needs more capacity than the same footprint with an 8 ft ceiling.</p>
      <p>That's why the calculator asks for ceiling height — and wall + peak height for vaulted / cathedral ceilings — so it can adjust the load up for taller rooms.</p>
      <p class="info-ph">★ Placeholder.</p>`},
    climateWhy:{title:'Why climate matters', html:`
      <p>The same room needs <b>more capacity in a cold climate</b> than in a mild one. Heating and cooling loads rise the farther you are from a mild, temperate zone.</p>
      <p>Enter your <b>ZIP code</b> for a quick estimate of your climate zone, or pick your <b>zone</b> directly. The calculator nudges the recommended BTU up for colder zones and keeps it lean for mild ones. A licensed tech confirms the final load.</p>
      <p>Your ZIP maps to a regional climate zone; the dropdown is always the manual override.</p>`},
    'hw-king':{title:'King high-wall air handler', photos:4, html:`
      <p>Wall-mounted indoor head — the most common style.</p>
      <ul>
        <li><b>−22°F performance</b> when paired with the 22 Multi condenser</li>
        <li>Built-in leak detection</li>
        <li>Self cleaning</li>
        <li>Quiet operation</li>
        <li>The most sizing options (7k–36k)</li>
      </ul>
      <p><b>Measurements:</b> ★ placeholder (varies by size).</p>
      <p><b>Use cases:</b> bedrooms, living rooms, offices — any room with high wall space.</p>`},
    'hw-emp':{title:'Emperor high-wall air handler', photos:4, html:`
      <p>Premium wall-mounted head (9 / 12 / 18 / 24k).</p>
      <ul>
        <li><b>−22°F performance</b></li>
        <li>Built-in leak detection</li>
        <li>Self cleaning</li>
        <li>Stronger air flow</li>
        <li>3–5 dB quieter — as low as 19 dB</li>
        <li>Dirty-filter warning</li>
      </ul>
      <p><b>Measurements:</b> ★ placeholder.</p>
      <p><b>Use cases:</b> primary living spaces where you want the premium head.</p>`},
    'cassette':{title:'Slim ceiling cassette', photos:4, html:`
      <p>Recessed one-way ceiling cassette — only the slim grille shows. Sizes 9 / 12 / 20k.</p>
      <p><b>Measurements:</b> ★ placeholder.</p>
      <p><b>Use cases:</b> rooms with limited wall space or where a clean ceiling look matters.</p>`},
    'ducted':{title:'Hidden ducted air handler', photos:4, html:`
      <p>Fully concealed handler that ducts to one or more rooms. Sizes 9 / 12 / 18 / 24k.</p>
      <p><b>Measurements:</b> ★ placeholder.</p>
      <p><b>Use cases:</b> several small rooms off one handler, or a completely hidden look.</p>`},
    'emp-4way':{title:'Emperor 4-way ceiling cassette', photos:4, html:`
      <p>Recessed ceiling cassette that blows in <b>four directions</b> for even coverage. Sizes 9 / 12 / 18 / 24k.</p>
      <ul>
        <li>Flush ceiling look — only the square grille shows</li>
        <li>4-way airflow for large or square rooms</li>
        <li>Built-in condensate lift pump on most sizes</li>
      </ul>
      <p><b>Measurements:</b> ★ placeholder (varies by size).</p>
      <p><b>Use cases:</b> open-plan rooms, large square spaces, or anywhere you want a centered ceiling unit.</p>`},
    'emp-console':{title:'Emperor compact console', photos:4, html:`
      <p>Floor-mounted console head that sits low on the wall, like a radiator. Sizes 9 / 12 / 18k.</p>
      <ul>
        <li>Mounts near the floor — no high wall space needed</li>
        <li>Great under windows or on knee walls</li>
        <li>Dual top + bottom airflow</li>
      </ul>
      <p><b>Measurements:</b> ★ placeholder.</p>
      <p><b>Use cases:</b> rooms with low or no usable high wall — under windows, attic knee walls, sunrooms.</p>`},
    'hw-clean':{title:'Clean Air high-wall air handler', photos:4, html:`
      <p>Wall-mounted head with an <b>enhanced filtration / air-purifying</b> stage. Sizes 9 / 12 / 18 / 24k.</p>
      <p class="info-ph">★ Coming soon — full specs to follow.</p>
      <p><b>Use cases:</b> bedrooms, nurseries, allergy-sensitive spaces.</p>`}
  };
  var infoPop = root.querySelector('#infoPopOverlay');
  var IPOP = { photos:0, i:0 };
  function ipopStage(){
    if(!IPOP.photos || !INFO_PHOTOS) return '';
    var dots = Array.from({length:IPOP.photos}, function(_,k){ return '<span class="'+(k===IPOP.i?'on':'')+'"></span>'; }).join('');
    var stage = (IPOP.imgs && IPOP.imgs[IPOP.i])
      ? '<div class="info-photo"><img src="'+IPOP.imgs[IPOP.i]+'" alt="" loading="lazy"></div>'
      : '<div class="info-photo ph">'+icon('camera')+'<span>Photo '+(IPOP.i+1)+' / '+IPOP.photos+'</span></div>';
    return '<div class="info-gallery">'
      + stage
      + (IPOP.photos>1 ? '<button class="ig-arrow l" data-ipop="prev" aria-label="Previous">'+icon('arrowL')+'</button>'
          + '<button class="ig-arrow r" data-ipop="next" aria-label="Next">'+icon('arrowRt')+'</button>'
          + '<div class="info-dots">'+dots+'</div>' : '')
      + '</div>';
  }
  function openInfoPop(entry){
    if(!infoPop || !entry) return;
    var t=root.querySelector('#infoPopTitle'); if(t) t.textContent = entry.title || 'More info';
    IPOP = { imgs: entry.imgs||[], photos: (entry.imgs&&entry.imgs.length) ? entry.imgs.length : (typeof entry.photos==='number' ? entry.photos : (entry.img?1:0)), i:0 };
    var body = ipopStage();
    body += entry.html || '';
    if(entry.links && entry.links.length){
      body += '<div class="info-links">'+entry.links.map(function(l){ return '<a href="'+l.url+'" target="_blank" rel="noopener">'+l.label+' ↗</a>'; }).join('')+'</div>';
    }
    body += '<button type="button" class="info-pop-close-btm" data-ipop-close>Close</button>';
    var b=root.querySelector('#infoPopBody'); if(b) b.innerHTML = body;
    infoPop.hidden=false;
  }
  function ipopStep(dir){
    if(IPOP.photos<2) return;
    IPOP.i = (IPOP.i + (dir==='next'?1:-1) + IPOP.photos) % IPOP.photos;
    var stage = infoPop ? infoPop.querySelector('.info-gallery') : null;
    if(stage){
      var im=stage.querySelector('.info-photo img'); if(im && IPOP.imgs && IPOP.imgs[IPOP.i]) im.src = IPOP.imgs[IPOP.i];
      var ph=stage.querySelector('.info-photo span'); if(ph) ph.textContent = 'Photo '+(IPOP.i+1)+' / '+IPOP.photos;
      stage.querySelectorAll('.info-dots span').forEach(function(d,k){ d.classList.toggle('on',k===IPOP.i); });
    }
  }
  if(infoPop){
    infoPop.addEventListener('click', function(e){
      var a=e.target.closest('[data-ipop]'); if(a){ ipopStep(a.dataset.ipop); return; }
      if(e.target.closest('[data-ipop-close]')){ infoPop.hidden=true; return; }
      if(e.target===infoPop) infoPop.hidden=true;
    });
    var ix=root.querySelector('#infoPopClose'); if(ix) ix.addEventListener('click', function(){ infoPop.hidden=true; });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !infoPop.hidden) infoPop.hidden=true; });
  }

  /* ---- Fullscreen photo lightbox — shared by the card mini-gallery and the
     configurator strip. Click any photo to expand; arrows / dots / swipe / keyboard
     to navigate; × , backdrop, or Esc to close. ---- */
  var lbOverlay=null, LB={imgs:[],i:0};
  function lbRender(){
    if(!lbOverlay) return;
    var n=LB.imgs.length; if(!n){ lbOverlay.hidden=true; return; }
    if(LB.i<0) LB.i=n-1; if(LB.i>=n) LB.i=0;
    var img=lbOverlay.querySelector('.lb-img'); if(img) img.src=LB.imgs[LB.i];
    var cap=lbOverlay.querySelector('.lb-cap'); if(cap) cap.textContent='Photo '+(LB.i+1)+' / '+n;
    var multi=n>1;
    lbOverlay.querySelectorAll('.lb-arrow').forEach(function(a){ a.style.display=multi?'flex':'none'; });
    var dots=lbOverlay.querySelector('.lb-dots');
    if(dots){ dots.style.display=multi?'flex':'none';
      dots.innerHTML=multi?LB.imgs.map(function(_,k){ return '<span class="'+(k===LB.i?'on':'')+'"></span>'; }).join(''):''; }
  }
  function openLightbox(imgs,start){
    lbEnsure(); if(!lbOverlay) return;
    imgs=(imgs||[]).filter(Boolean); if(!imgs.length) return;
    LB.imgs=imgs; LB.i=Math.max(0,Math.min(start||0,imgs.length-1));
    lbRender(); lbOverlay.hidden=false;
  }
  function lbStep(dir){ if(!LB.imgs.length) return; LB.i=(LB.i+dir+LB.imgs.length)%LB.imgs.length; lbRender(); }
  function lbClose(){ if(lbOverlay) lbOverlay.hidden=true; }
  function lbEnsure(){
    if(lbOverlay || typeof root==='undefined' || !root) return;
    lbOverlay=document.createElement('div');
    lbOverlay.className='gwin-lightbox'; lbOverlay.hidden=true;
    lbOverlay.innerHTML='<div class="lb-stage">'
      +'<img class="lb-img" alt="">'
      +'<button class="lb-close" type="button" data-lb="close" aria-label="Close">\u00d7</button>'
      +'<button class="lb-arrow prev" type="button" data-lb="prev" aria-label="Previous photo">'+icon('arrowL')+'</button>'
      +'<button class="lb-arrow next" type="button" data-lb="next" aria-label="Next photo">'+icon('arrowR')+'</button>'
      +'<span class="lb-cap"></span>'
      +'<div class="lb-dots"></div>'
      +'</div>';
    root.appendChild(lbOverlay);
    lbOverlay.addEventListener('click', function(e){
      var b=e.target.closest('[data-lb]');
      if(b){ var a=b.dataset.lb; if(a==='prev') lbStep(-1); else if(a==='next') lbStep(1); else lbClose(); return; }
      if(e.target===lbOverlay) lbClose();   /* backdrop */
    });
    var lx0=null;
    lbOverlay.addEventListener('pointerdown', function(e){ lx0=e.clientX; });
    lbOverlay.addEventListener('pointerup', function(e){ if(lx0==null) return; var dx=e.clientX-lx0; lx0=null;
      if(Math.abs(dx)>40 && !e.target.closest('[data-lb]')) lbStep(dx<0?1:-1); });
  }
  (function(){
    document.addEventListener('keydown', function(e){
      if(!lbOverlay || lbOverlay.hidden) return;
      if(e.key==='Escape'){ lbClose(); e.stopImmediatePropagation(); }       /* don't also close the configurator */
      else if(e.key==='ArrowLeft'){ lbStep(-1); e.stopImmediatePropagation(); }
      else if(e.key==='ArrowRight'){ lbStep(1); e.stopImmediatePropagation(); }
    });
  })();
  /* document-level routing — works on cards (tech pill), the calculator, about cards,
     and (Phase 4B) the configurator's (i) buttons and handler "More details". */
  root.addEventListener('click', function(e){
    var ci = e.target.closest('[data-card-info]');
    if(ci){ var cc=ci.closest('.scard');
      if(cc && cc.dataset.kind==='single'){ var ck=btuK(cc.dataset.btu);
        var cfgC={kind:'single',condK:ck,family:cc.dataset.family,voltage:cc.dataset.volts,lockedType:cc.dataset.type,sys:{mount:0,electrical:0},heads:[{type:cc.dataset.type,sizeK:ck,lineset:0}]};
        var pec=infoEntryFor(cc.dataset.type,cfgC); if(pec){ openInfoPop(pec); } else if(INFO[cc.dataset.type]){ openInfoPop(INFO[cc.dataset.type]); }
      } else if(cc && cc.dataset.kind==='multi'){ var mk=btuK(cc.dataset.btu); var mz=+cc.dataset.zones||2;
        var cfgM={kind:'multi',condK:mk,zones:mz,voltage:'230v',family:null,sys:{mount:0,electrical:0},heads:[]};
        var pem=infoEntryFor('condenser',cfgM); if(pem){ openInfoPop(pem); }
      } return; }
    var mi = e.target.closest('[data-info]');
    if(mi){ var k=mi.dataset.info; var pe=infoEntryFor(k); if(pe){ openInfoPop(pe); } else if(INFO[k]){ openInfoPop(INFO[k]); } return; }
    var ab = e.target.closest('[data-about]');
    if(ab && ABOUT_DETAILS[ab.dataset.about]) openInfoPop(ABOUT_DETAILS[ab.dataset.about]);
  });

  function singleSystemCard(s, photoIcon, seriesTitle, typeId, productHandle, family, seriesVolts){
    var cover = COVER[s.btu] || '';
    var condK = btuK(s.btu);
    var volt = seriesVolts || s.volts || '208–230V';
    var tlabel = TYPE_LABEL[typeId] || 'High Wall';
    var realBase = cardRealBase(family, typeId, condK, voltKey(volt));
    var start = (realBase!=null) ? realBase : cardStartPrice('single', condK, 1, [condK]);
    return '<article class="scard" data-kind="single" data-title="'+seriesTitle+' · '+s.btu+' BTU" data-ls-idx="0"'
      + ' data-btu="'+s.btu+'" data-type="'+typeId+'" data-family="'+(family||'king')+'" data-volts="'+volt+'" data-photo="'+(photoIcon||'snow')+'" data-product="'+(productHandle||'')+'">'
      + '<div class="photo"><span class="tech-pill">Tech included <button class="tech-learn" data-info="tech" type="button">Learn more</button></span>'+savedCluster()+icon(photoIcon||'snow')+'</div>'
      + '<div class="inner"><div class="top-row"><div class="card-head"><div class="card-series">'+seriesTitle+'</div>'
      + '<div class="btu">'+s.btu+'<span class="btu-sub"><small>BTU</small><button class="card-info-btn" type="button" data-card-info aria-label="Product info">'+icon('info')+'</button></span></div></div>'
      + '<div class="tag-col"><div class="tag-row">'
      + (cover?'<span class="cover-tag">'+cover+'</span>':'')+'<span class="zone-tag">1-zone</span></div>'
      + '<span class="type-tag">'+tlabel+'</span></div></div>'
      + '<div class="ls-pick"><span class="ls-pick-label">Lineset</span>'
      + '<button class="ls-chip" type="button" data-ls-cycle>'+lsOptsFor(typeId, condK, null, volt, family)[0].label+' '+icon('arrowRt')+'</button></div>'
      + '<div class="price-row"><div class="price"><b class="card-price">'+money(start)+'</b><small>starting at</small></div>'
      + '<span class="volt-tag">'+volt+'</span></div>'
      + '<button class="fin-line" data-finance>as low as <b class="card-mo">'+monthly(start)+'</b>/mo →</button>'
      + '<div class="pick"><button class="btn primary" data-open-config>Open product '+icon('arrowRt')+'</button></div>'
      + '</div></article>';
  }

  function soonCardSingle(sizeK, seriesTitle, typeId, photoIcon, volt, family){
    var btu = (sizeK*1000).toLocaleString('en-US');
    var tlabel = TYPE_LABEL[typeId] || 'High Wall';
    var v = volt || '208–230V';
    return '<article class="scard soon" data-kind="single" data-title="'+seriesTitle+' · '+btu+' BTU"'
      + ' data-btu="'+btu+'" data-type="'+typeId+'" data-family="'+(family||'king')+'" data-volts="'+v+'" data-photo="'+(photoIcon||'snow')+'">'
      + '<div class="photo"><span class="soon-pill">Coming soon</span>'+icon(photoIcon||'snow')+'</div>'
      + '<div class="inner"><div class="top-row"><div class="card-head"><div class="card-series">'+seriesTitle+'</div>'
      + '<div class="btu">'+btu+'<span class="btu-sub"><small>BTU</small><button class="card-info-btn" type="button" data-card-info aria-label="Product info">'+icon('info')+'</button></span></div></div>'
      + '<div class="tag-col"><div class="tag-row"><span class="zone-tag">1-zone</span></div>'
      + '<span class="type-tag">'+tlabel+'</span></div></div>'
      + '<div class="price-row"><div class="price"><b class="card-price">—</b><small>coming soon</small></div>'
      + '<span class="volt-tag">'+v+'</span></div>'
      + '<div class="pick"><button class="btn primary" disabled>Coming soon</button></div>'
      + '</div></article>';
  }

  function multiSystemCard(z, size, condenserHandle){
    var soon = COMING_SOON.indexOf(size) !== -1;
    var condK = btuK(size);
    var cover = COVER[size] || '';
    var heads = defaultHeads(condK, z, 'hw-king');
    var start = cardStartPrice('multi', condK, z, heads);
    return '<article class="scard'+(soon?' soon':'')+'" data-kind="multi" data-title="'+size+' BTU · '+z+'-Zone"'
      + ' data-btu="'+size+'" data-zones="'+z+'" data-photo="truck" data-headsizes="'+heads.join(',')+'" data-product="'+(condenserHandle||'')+'">'
      + '<div class="photo">'+(soon?'<span class="soon-pill">Coming soon</span>':'<span class="tech-pill">Tech included <button class="tech-learn" data-info="tech" type="button">Learn more</button></span>'+savedCluster())+icon('truck')+'</div>'
      + '<div class="inner"><div class="top-row"><div class="card-head"><div class="card-series">22 Multi</div>'
      + '<div class="btu">'+size+'<span class="btu-sub"><small>BTU condenser</small><button class="card-info-btn" type="button" data-card-info aria-label="Condenser info">'+icon('info')+'</button></span></div></div>'
      + '<div class="tag-col"><div class="tag-row">'
      + (cover?'<span class="cover-tag">'+cover+'</span>':'')+'<span class="zone-tag">'+z+'-zone</span></div>'
      + '<span class="type-tag hyper">Hyper-heat</span></div></div>'
      + (soon ? '<div class="combo">Available soon</div>'
        : '<div class="roller" data-roller>'+heads.map(function(k,i){return (i>0?'<span class="roller-plus">+</span>':'')+'<button class="roller-chip" type="button" data-roll-i="'+i+'">'+k+'k</button>';}).join('')+'</div>'
          + '<div class="roller-hint">'+icon('gauge')+' tap a size to adjust · price updates</div>')
      + '<div class="price-row"><div class="price"><b class="card-price">'+(soon?'—':money(start))+'</b><small>'+(soon?'coming soon':'starting at')+'</small></div>'
      + '<span class="volt-tag">208–230V</span></div>'
      + (soon?'':'<button class="fin-line" data-finance>as low as <b class="card-mo">'+monthly(start)+'</b>/mo →</button>')
      + '<div class="pick">'+(soon?'<button class="btn primary" disabled>Coming soon</button>':'<button class="btn primary" data-open-config>Open product '+icon('arrowRt')+'</button>')+'</div>'
      + '</div></article>';
  }

  function railBlock(label,cardsHTML,hint){
    return '<div class="rail-block"><div class="rail-label"><h3>'+label+'</h3>'+railNav()+'</div>'
      + '<div class="rail-shell" data-at-start="true"'+(hint?' data-swipe-hint="1"':'')+'><div class="rail">'+cardsHTML+'</div></div></div>';
  }
  function mediaBlock(cap, photos){
    var imgs = (photos && photos.length) ? photos : null;   /* real photos (pickers or product) -> gallery; else icon placeholder */
    var count = imgs ? imgs.length : 3;
    var hasImg = !!imgs;
    return '<div class="media'+(hasImg?' has-img':'')+'" data-media data-mi="0" data-mn="'+count+'" data-cap="'+cap+'"'
      + (hasImg ? ' data-imgs="'+encodeURIComponent(JSON.stringify(imgs))+'"' : '')+'>'
      + (hasImg ? '<img class="media-img" src="'+imgs[0]+'" alt="" loading="lazy">' : '<div class="ph-ico">'+icon('camera')+'</div>')
      + '<div class="cap"><span class="cap-text">'+cap+' · Photo 1 / '+count+'</span></div>'
      + (count>1 ? '<button class="media-arrow prev" type="button" data-media-arrow="prev" aria-label="Previous photo">'+icon('arrowL')+'</button>'
        + '<button class="media-arrow next" type="button" data-media-arrow="next" aria-label="Next photo">'+icon('arrowR')+'</button>'
        + '<div class="media-dots">'+Array.from({length:count},function(_,i){return '<span class="'+(i===0?'on':'')+'"></span>';}).join('')+'</div>' : '')
      + '</div>';
  }
  function mediaStep(media, dir){
    var n=+media.dataset.mn||1; var i=+media.dataset.mi||0;
    i=(i+(dir==='next'?1:-1)+n)%n; media.dataset.mi=String(i);
    var t=media.querySelector('.cap-text'); if(t) t.textContent=media.dataset.cap+' · Photo '+(i+1)+' / '+n;
    media.querySelectorAll('.media-dots span').forEach(function(d,k){d.classList.toggle('on',k===i);});
    if(media.dataset.imgs){ try{ var arr=JSON.parse(decodeURIComponent(media.dataset.imgs)); var im=media.querySelector('.media-img'); if(im && arr[i]) im.src=arr[i]; }catch(e){} }
  }

  /* ===================== BOTTOM LINK ROW (Shop all + cross-links) ===================== */
  function bottomLinks(){
    var L = LINKS, out = '';
    if(L.shopAllUrl)   out += '<a class="btn primary" style="width:auto;padding:13px 26px;" href="'+L.shopAllUrl+'">'+(L.shopAllLabel||'Shop all products')+' '+icon('arrowRt')+'</a>';
    function x(o){ return (o && o.url) ? '<a class="gwin-ds-xlink" href="'+o.url+'">'+(o.label||'')+'</a>' : ''; }
    out += x(L.pillar) + x(L.warranty) + x(L.financing);
    return '<section class="series gwin-ds-bottom"><div class="gwin-ds-bottomlinks">'+out+'</div></section>';
  }

  /* ===================== BUILD: SINGLE ===================== */
  function buildSingle(){
    var html='';
    html += calcPanel('single', 'Size the room you want to condition. A tech confirms the final load.');
    SINGLE.forEach(function(s){
      var soonSeries = !!s.comingSoon;
      if(!soonSeries && (!s.systems || !s.systems.length)) return;   /* auto-hide empties; coming-soon series stay */
      var pIcon = s.photoIcon || 'wall';
      var typeId = s.typeId || 'hw-king';
      html += '<section class="series" id="'+s.id+'">';
      if(s.media) html += mediaBlock(s.mediaCap, (s.seriesPhotos&&s.seriesPhotos.length)?s.seriesPhotos:(s.productImages||[]));
      html += '<div class="series-intro"><div class="series-title"><h2>'+s.title+'</h2>'
        + '<span class="s-badge '+(soonSeries?'soon':(s.badgeAmber?'amber':''))+'">'+(soonSeries?'Coming soon':s.badge)+'</span></div>'
        + (s.desc?'<div class="series-desc">'+s.desc+'</div>':'')+'</div>';
      if(s.about && s.about.length) html += railBlock('About this series', s.about.map(aboutCard).join(''));
      if(soonSeries){
        var sizes = (s.systems && s.systems.length)
          ? s.systems.map(function(sys){ return btuK(sys.btu); })
          : String(s.comingSoonSizes||'9,12,18,24').split(',').map(function(n){ return parseInt(n,10); }).filter(function(n){ return !isNaN(n); });
        html += railBlock('Coming soon', sizes.map(function(k){ return soonCardSingle(k, s.title, typeId, pIcon, s.volts, s.family); }).join(''), true);
      } else {
        html += '<div class="series-calc-row"><button class="calc-btn" data-open-calc="'+s.title+' · '+s.badge+'" data-calc-kind="single">'+icon('gauge')+' Quick size calculator</button></div>';
        html += railBlock('Choose your size — '+s.systems.length+' system'+(s.systems.length>1?'s':''),
          s.systems.map(function(sys){ return singleSystemCard(sys, pIcon, s.title, typeId, s.productHandle, s.family, s.volts); }).join(''), true);
      }
      html += '</section>';
    });
    html += bottomLinks();
    document.getElementById('singleBody').innerHTML = html;
    /* Max / central-ducted series render into #single, then relocate to the Central Ducted tab (#central). */
    (function(){
      var cb = document.getElementById('centralBody'); if(!cb) return;
      var moved = [];
      Array.prototype.slice.call(root.querySelectorAll('#singleBody > section.series')).forEach(function(sec){
        var c = sec.querySelector('.scard[data-kind="single"]');
        if(c && c.dataset.family === 'max'){
          var cr = sec.querySelector('.series-calc-row'); if(cr){ cr.remove(); }   /* per-series single-room calc; whole-home calc is the tab panel */
          moved.push(sec);
        }
      });
      cb.innerHTML = calcPanel('central', 'Add every room you want to condition — the calculator totals them into one whole-home load and sizes a Max 22 central system. A tech confirms the final load and duct design.');   /* always render — tab is permanent like Single/Multi */
      moved.forEach(function(sec){ cb.appendChild(sec); });
    })();
    refreshSingleCardPrices();
  }

  /* ===================== BUILD: MULTI ===================== */
  function buildMulti(){
    var html='';
    html += calcPanel('multi', 'Add each room you want to condition — up to 6 — for a total BTU and condenser suggestion. A tech confirms the final load.');
    html += '<section class="series" id="choose"><div class="series-head"><div class="series-title"><h2>How to choose</h2></div></div>'
      + '<p class="series-tagline">Three decisions, in order — condenser size, how many air handlers, and which type.</p>'
      + '<div class="info-grid">'
      + '<div class="info"><div class="num">STEP 1</div><h4>Choose condenser size</h4><p>The outdoor unit\u2019s BTU sets your ceiling. Size up slightly for very cold climates.</p></div>'
      + '<div class="info"><div class="num">STEP 2</div><h4>Choose how many air handlers</h4><p>One head per room you want independent control over. Each condenser supports a set range of zones.</p></div>'
      + '<div class="info"><div class="num">STEP 3</div><h4>Choose the air handler type</h4><p>Mix and match wall, cassette and ducted heads per room. Each type is shown below.</p></div>'
      + '</div>';
    /* Info cards are educational (no product field) — always show every block,
       regardless of product connection. (The per-zone builder dropdown stays gated
       on multiTypeConnected separately, since a type with no product can't be built.) */
    var handlerCards = HANDLERS;
    html += railBlock('Air handler types', handlerCards.map(function(h){
      return '<article class="pcard"><div class="ph">'+icon(h.ic)+'</div>'
        + '<div class="body"><h4>'+h.t+'</h4><p>'+h.d+'</p>'
        + (h.info?'<button class="pcard-photos" data-info="'+h.info+'" type="button">'+icon('info')+' More details</button>':'')
        + '</div></article>';
    }).join(''));
    html += '</section>';

    html += '<section class="series" id="build"><div class="series-head"><div class="series-title"><h2>Choose condenser size, then pick a combination</h2></div></div>'
      + '<p class="series-tagline">Each card below is a condenser size. Open it to set your air-handler combination, lineset lengths and accessories.</p>';
    html += mediaBlock('Photo — building a multi-zone combination');
    html += '</section>';

    var ABOUT_MULTI = [
      {ic:'info', t:'One mode, independent control', d:'All zones heat or cool together on a single condenser \u2014 each room keeps its own temperature, fan speed and on/off.'},
      {ic:'shield', t:'Same iron-clad warranty', d:'10-year parts + compressor and year-1 bumper-to-bumper apply to every combination.'},
      {ic:'truck', t:'Tech included', d:'A licensed tech commissions the whole multi-zone startup, not just one head.'},
      {ic:'ruler', t:'Cut-to-length linesets', d:'Flare-less, easy-connect linesets sized per zone make the run DIY-friendly.'},
      {ic:'gauge', t:'Flexible head mixing', d:'Combine wall, cassette and ducted heads across rooms on one condenser.'}
    ];
    ZONES.forEach(function(zone){
      html += '<section class="series" id="zone'+zone.z+'">';
      html += mediaBlock('Photo — '+zone.z+'-zone systems');
      html += '<div class="series-intro"><div class="series-title"><h2>'+zone.z+'-Zone Combinations</h2>'
        + '<span class="s-badge">'+zone.z+' air handlers</span></div>'
        + (zone.desc?'<div class="series-desc">'+zone.desc+'</div>':'')+'</div>';
      html += railBlock('About these systems', ABOUT_MULTI.map(aboutCard).join(''));
      html += '<div class="series-calc-row"><button class="calc-btn" data-open-calc="'+zone.z+'-Zone systems" data-calc-kind="multi" data-fixed-rooms="'+zone.z+'">'+icon('gauge')+' Quick size calculator</button></div>';
      html += railBlock('Choose your condenser — '+zone.sizes.length+' size'+(zone.sizes.length>1?'s':''),
        zone.sizes.map(function(sz){ return multiSystemCard(zone.z, sz, zone.condenserHandle); }).join(''), true);
      html += '<div class="zone-note">'+icon('info')+'<div>Each system card includes the <b>air-handler combination</b>, selectable <b>lineset lengths</b> for that condenser, and optional <b>accessories</b>.</div></div>';
      html += '</section>';
    });
    html += bottomLinks();
    document.getElementById('multiBody').innerHTML = html;
    refreshMultiCardPrices();
  }

  /* ===================== JUMP NAV (data-driven) ===================== */
  function shortLabel(s){ var head = (s.title.split('·')[0]||s.title).trim(); return head + ' · ' + s.badge; }
  function buildJump(tab){
    var items;
    if(tab==='single'){ items = [['single-calc','Calculator']].concat(SINGLE.filter(function(s){ return s.family!=='max' && (s.comingSoon || (s.systems && s.systems.length)); }).map(function(s){ return [s.id, shortLabel(s)]; })); }
    else if(tab==='central'){ items = [['central-calc','Calculator']].concat(SINGLE.filter(function(s){ return s.family==='max' && (s.comingSoon || (s.systems && s.systems.length)); }).map(function(s){ return [s.id, shortLabel(s)]; })); }
    else {
      items = [['calc','Calculator'],['choose','How to choose'],['build','Build a combo']]
        .concat(ZONES.map(function(z){ return ['zone'+z.z, z.z+'-Zone']; }));
    }
    document.getElementById('jumpNav').innerHTML = items.map(function(j){ return '<a href="#'+j[0]+'">'+j[1]+'</a>'; }).join('');
  }

  /* ===================== RAIL BEHAVIOR ===================== */
  function setHint(rail){
    var cards = rail.querySelectorAll('.acard,.scard,.pcard');
    if(!cards.length) return;
    var railRight = rail.getBoundingClientRect().right;
    var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    var hinted = null;
    if(!atEnd){
      for(var i=0;i<cards.length;i++){ var r=cards[i].getBoundingClientRect(); if(r.left < railRight-6 && r.right > railRight+6){ hinted=cards[i]; break; } }
      if(!hinted){ for(var j=0;j<cards.length;j++){ if(cards[j].getBoundingClientRect().left >= railRight-6){ hinted=cards[j]; break; } } }
    }
    cards.forEach(function(c){ c.classList.toggle('swipe-hint', c===hinted && !c.classList.contains('open')); });
  }
  function setEdges(rail){
    var shell=rail.closest('.rail-shell'); if(!shell) return;
    shell.setAttribute('data-at-start', rail.scrollLeft<=2);
    shell.setAttribute('data-at-end', rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2);
    setHint(rail);
  }
  function enableDrag(el){
    var down=false,dragging=false,startX=0,startScroll=0,moved=0,pid=null;
    var DRAG_THRESHOLD=6;
    el.addEventListener('pointerdown',function(e){ if(e.button!=null && e.button!==0) return; down=true;dragging=false;moved=0;startX=e.clientX;startScroll=el.scrollLeft;pid=e.pointerId; });
    el.addEventListener('pointermove',function(e){ if(!down)return; var dx=e.clientX-startX; moved=Math.abs(dx);
      if(!dragging && moved>DRAG_THRESHOLD){ dragging=true; el.classList.add('dragging'); try{ el.setPointerCapture(pid); }catch(_){} }
      if(dragging) el.scrollLeft=startScroll-dx; });
    var end=function(){ down=false; if(dragging){ dragging=false; el.classList.remove('dragging'); try{ el.releasePointerCapture(pid); }catch(_){} } };
    el.addEventListener('pointerup',end); el.addEventListener('pointercancel',end);
    el.addEventListener('click',function(e){ if(moved>DRAG_THRESHOLD){ e.preventDefault(); e.stopPropagation(); } },true);
  }
  function initRails(scope){
    scope.querySelectorAll('.rail').forEach(function(rail){
      rail.addEventListener('scroll',function(){setEdges(rail);},{passive:true});
      enableDrag(rail); setEdges(rail);
    });
    scope.querySelectorAll('[data-nudge]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var rail=btn.closest('.rail-block').querySelector('.rail');
        var card=rail.querySelector('.acard,.scard,.pcard');
        var step=card?card.getBoundingClientRect().width+16:rail.clientWidth*0.8;
        rail.scrollBy({left:(btn.dataset.nudge==='next'?1:-1)*step,behavior:'smooth'});
      });
    });
  }
  var _railResizeT;
  window.addEventListener('resize', function(){ clearTimeout(_railResizeT); _railResizeT = setTimeout(function(){ root.querySelectorAll('.rail').forEach(setEdges); }, 120); });

  /* ---- Swipe-hint bounce: when a size rail scrolls into view on a narrow screen,
     animate scrollLeft out-and-back once so it's obvious the cards swipe sideways.
     Honors the editor toggle (data-pulse-on), intensity (data-pulse -> distance),
     and prefers-reduced-motion. Only fires on rails that actually overflow. ---- */
  function bounceRail(rail, dist){
    if(!rail || rail._bounced) return;
    if(rail.scrollWidth - rail.clientWidth < 24) return;     /* nothing to scroll -> no hint */
    rail._bounced = true;
    var snap = rail.style.scrollSnapType;
    rail.style.scrollSnapType = 'none';
    var start = rail.scrollLeft, t0 = null, dur = 740;
    function ease(p){ return p<0.5 ? 2*p*p : 1-Math.pow(-2*p+2,2)/2; }   /* easeInOutQuad */
    function frame(ts){
      if(t0==null) t0=ts;
      var p = Math.min((ts-t0)/dur, 1);
      var tri = p<0.5 ? ease(p/0.5) : ease((1-p)/0.5);                   /* out then back */
      rail.scrollLeft = start + dist*tri;
      if(p<1){ requestAnimationFrame(frame); }
      else { rail.scrollLeft = start; rail.style.scrollSnapType = snap; setEdges(rail); }
    }
    requestAnimationFrame(frame);
  }
  function initSwipeHints(scope){
    if(!('IntersectionObserver' in window) || !window.matchMedia) return;
    if(!window.matchMedia('(max-width:680px)').matches) return;          /* mobile / narrow only */
    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    if(root.getAttribute('data-pulse-on') === 'false') return;           /* editor off switch */
    var level = root.getAttribute('data-pulse') || 'medium';
    var dist = level==='subtle' ? 26 : (level==='strong' ? 60 : 42);
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        io.unobserve(en.target);
        var rail = en.target.querySelector('.rail');
        if(rail) setTimeout(function(){ bounceRail(rail, dist); }, 240);
      });
    }, {threshold:0.6});
    scope.querySelectorAll('.rail-shell[data-swipe-hint="1"]').forEach(function(sh){ io.observe(sh); });
  }

  /* ===================== EVENT HANDLERS ===================== */
  /* media arrows + swipe */
  document.addEventListener('click', function(e){ var a=e.target.closest('[data-media-arrow]'); if(!a) return; var m=a.closest('[data-media]'); if(m) mediaStep(m, a.dataset.mediaArrow); });
  (function(){ var mx=null, mt=null;
    document.addEventListener('pointerdown', function(e){ var m=e.target.closest('[data-media]'); if(m){ mx=e.clientX; mt=m; } });
    document.addEventListener('pointerup', function(e){ if(mx==null||!mt) return; var dx=e.clientX-mx, m=mt; mx=null; mt=null; if(Math.abs(dx)>40 && !e.target.closest('[data-media-arrow]')) mediaStep(m, dx<0?'next':'prev'); });
  })();
  /* multi roller */
  document.addEventListener('click', function(e){
    var chip = e.target.closest('[data-roll-i]'); if(!chip) return;
    var card = chip.closest('.scard'); if(!card) return;
    var condK = btuK(card.dataset.btu); var z = +card.dataset.zones;
    var heads = (card.dataset.headsizes||'').split(',').map(function(n){return parseInt(n,10);});
    var i = +chip.dataset.rollI;
    var otherTotal = heads.reduce(function(a,k,idx){ return idx===i ? a : a+k; }, 0);
    var valid = validSizesForHead(condK, 'hw-king', otherTotal);
    if(!valid.length) return;
    var idx = valid.indexOf(heads[i]); if(idx<0) idx = 0;
    idx = (idx + 1) % valid.length; heads[i] = valid[idx];
    card.dataset.headsizes = heads.join(',');
    card.querySelectorAll('[data-roll-i]').forEach(function(c,k){ c.textContent = heads[k]+'k'; });
    /* if this card has a saved build, the size edit updates it — carries to the open card + persists */
    var _sk = cardKey(card), _sv = _sk ? savedBuild(_sk) : null;
    if(_sv && _sv.heads && _sv.heads.length===heads.length){
      heads.forEach(function(k,ix){ _sv.heads[ix].sizeK = k; });
      persistBuild(_sk, _sv);
      setCardPrice(card, totalForBuild(cfgFromCard(card,_sv)).total, true);
    } else {
      var newStart = cardStartPrice('multi', condK, z, heads);
      var pr = card.querySelector('.card-price'); if(pr) pr.textContent = money(newStart);
      var moEl = card.querySelector('.card-mo'); if(moEl) moEl.textContent = monthly(newStart);
    }
  });
  /* single lineset cycle */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-ls-cycle]'); if(!btn) return;
    var card = btn.closest('.scard'); if(!card) return;
    var condK = btuK(card.dataset.btu);
    var lso = lsOptsFor(card.dataset.type, condK, null, card.dataset.volts, card.dataset.family);
    var idx = (parseInt(card.dataset.lsIdx,10) || 0) + 1;
    if(idx >= lso.length) idx = 0;
    card.dataset.lsIdx = idx;
    btn.innerHTML = lso[idx].label + ' ' + icon('arrowRt');
    /* if this card has a saved build, the lineset edit updates it — carries to the open card + persists */
    var _sk = cardKey(card), _sv = _sk ? savedBuild(_sk) : null;
    if(_sv && _sv.heads && _sv.heads[0]){
      _sv.heads[0].lineset = idx;
      persistBuild(_sk, _sv);
      setCardPrice(card, totalForBuild(cfgFromCard(card,_sv)).total, true);
    } else {
      var rBase = cardRealBase(card.dataset.family, card.dataset.type, condK, voltKey(card.dataset.volts));
      var base0 = (rBase!=null) ? rBase : cardStartPrice('single', condK, 1, [condK]);
      var newStart = base0 + (lso[idx].price - lso[0].price);
      var pr = card.querySelector('.card-price'); if(pr) pr.textContent = money(newStart);
      var moEl = card.querySelector('.card-mo'); if(moEl) moEl.textContent = monthly(newStart);
    }
  });
  /* finance line -> financing page (amount prefill comes in Phase 5) */
  document.addEventListener('click', function(e){ var f=e.target.closest('[data-finance]'); if(!f) return; e.preventDefault(); if(FINANCE_URL) location.href = FINANCE_URL; });
  /* open product -> inline configurator (Phase 4B). Toggle is wired in the configurator engine below. */

  /* ===================== TABS ===================== */
  function setTab(tab){
    root.setAttribute('data-tab',tab);
    root.querySelectorAll('[data-tab-btn]').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.tabBtn===tab); });
    buildJump(tab);
    requestAnimationFrame(function(){ root.querySelectorAll('#'+tab+' .rail').forEach(setEdges); });
  }
  var tabScroll = {};
  function tabCurY(){ return window.pageYOffset || (document.documentElement&&document.documentElement.scrollTop) || 0; }
  root.querySelectorAll('[data-tab-btn]').forEach(function(b){ b.addEventListener('click', function(){
    var prev=root.getAttribute('data-tab'), next=b.dataset.tabBtn;
    if(next===prev){ return; }
    if(prev){ tabScroll[prev]=tabCurY(); }            /* remember where they left this tab */
    var hasMem=(tabScroll[next]!=null);
    setTab(next);
    var y = hasMem ? tabScroll[next] : 0;             /* restore where they left off, or page top on first visit */
    requestAnimationFrame(function(){ window.scrollTo(0, Math.max(0, y|0)); });
  }); });


  /* ===================================================================
     PHASE 3 — BTU & CONDENSER CALCULATOR
     =================================================================== */
  var QC_BTU_PER_SQFT = 25;
  var CLIMATE = {
    '1':{label:'Zone 1 · Hot–humid (S. Florida, Hawaii)',       mult:0.95},
    '2':{label:'Zone 2 · Hot (Gulf Coast, S. Arizona)',         mult:0.98},
    '3':{label:'Zone 3 · Warm (Southeast, S. California)',      mult:1.00},
    '4':{label:'Zone 4 · Mixed (mid-Atlantic, Tennessee)',      mult:1.06},
    '5':{label:'Zone 5 · Cool (Midwest, Northern US)',          mult:1.14},
    '6':{label:'Zone 6 · Cold (Upper Midwest, New England)',    mult:1.24},
    '7':{label:'Zone 7 · Very cold (N. Minnesota, mountains)',  mult:1.34}
  };
  (function(){ var cm=(GWIN_CFG.climate && GWIN_CFG.climate.mult)||{}; Object.keys(CLIMATE).forEach(function(z){ if(cm[z]!=null) CLIMATE[z].mult=+cm[z]; }); })();
  /* Accurate ZIP → IECC/DOE climate zone (1–7) by 3-digit prefix range.
     Ranges are [startPrefix, endPrefix, zone] over the leading 3 digits of the ZIP,
     built from USPS state SCF blocks + within-state zone subdivisions. The climate
     dropdown remains the manual override. Overridable via GWIN_CFG.zipRanges. */
  var ZIP_ZONE_R=[[0,5,'4'],[6,9,'1'],[10,29,'5'],[30,59,'6'],[60,69,'5'],[70,119,'4'],[120,196,'5'],[197,269,'4'],[270,319,'3'],[320,329,'2'],[330,334,'1'],[335,339,'2'],[340,342,'1'],[343,349,'2'],[350,364,'3'],[365,369,'2'],[370,379,'4'],[380,381,'3'],[382,385,'4'],[386,394,'3'],[395,396,'2'],[397,399,'3'],[400,429,'4'],[430,497,'5'],[498,499,'6'],[500,529,'5'],[530,555,'6'],[556,569,'7'],[570,579,'6'],[580,589,'7'],[590,599,'6'],[600,629,'5'],[630,637,'4'],[638,639,'3'],[640,679,'4'],[680,699,'5'],[700,701,'2'],[702,702,'3'],[703,703,'2'],[704,774,'3'],[775,778,'2'],[779,779,'3'],[780,789,'2'],[790,792,'4'],[793,799,'3'],[800,813,'5'],[814,835,'6'],[836,837,'5'],[838,839,'6'],[840,846,'5'],[847,849,'3'],[850,859,'2'],[860,860,'5'],[861,862,'2'],[863,864,'5'],[865,869,'2'],[870,874,'4'],[875,877,'5'],[878,879,'4'],[880,880,'3'],[881,888,'4'],[889,893,'3'],[894,899,'5'],[900,935,'3'],[936,936,'4'],[937,955,'3'],[956,959,'4'],[960,966,'5'],[967,969,'1'],[970,976,'4'],[977,979,'5'],[980,987,'4'],[988,994,'5'],[995,999,'7']];
  (function(){ var r=GWIN_CFG.zipRanges; if(r&&r.length) ZIP_ZONE_R=r; })();
  function zoneFromZip(zip){
    var d=String(zip).replace(/\D/g,'');
    if(d.length<3) return null;              /* need 3 digits for a real lookup */
    var p=parseInt(d.slice(0,3),10);
    for(var i=0;i<ZIP_ZONE_R.length;i++){ if(p>=ZIP_ZONE_R[i][0]&&p<=ZIP_ZONE_R[i][1]) return ZIP_ZONE_R[i][2]; }
    return '4';
  }
  var SINGLE_SIZES = [9000,12000,18000,24000,30000,36000];
  var COND_SIZES   = [18000,24000,30000,36000,42000,48000,60000];
  var HEAD_SIZES_K = [7,9,12,18,24,36];
  var OVERSIZE_BTU = 36000;
  var OVERSIZE_LEN = 35;
  var MAX_ROOMS = 6;
  var n = function(v){ return parseFloat(v)||0; };
  function nearestSingle(btu){ return SINGLE_SIZES.find(function(s){return btu<=s;}) || null; }
  function nearestHeadK(btu){ return HEAD_SIZES_K.find(function(s){return btu<=s*1000;}) || 36; }
  function nearestCond(btu){ return COND_SIZES.find(function(s){return btu<=s;}) || 48000; }
  function nearestCentral(btu){ return COND_SIZES.find(function(s){return btu<=s;}) || 60000; }  /* Max 22 sizes; 60k is buyable */
  function condLabel(cond){ return cond>=60000 ? (cond/1000)+'k condenser (coming soon)' : (cond/1000)+'k condenser'; }

  function buildRoomCalc(rc, opts){
    opts = opts || {};
    var fixedRooms = opts.fixedRooms || null;
    var maxRooms = fixedRooms || opts.maxRooms || 1;
    var variant  = opts.variant || 'single';
    var onGoto = opts.onGoto || null;
    var apply  = opts.apply || null;
    var lastSpec = null;
    var mode = 'dims';
    var climateZone = '4';
    var rooms = makeRooms();
    function makeRooms(){ var c=fixedRooms||1; return Array.from({length:c},function(){return {};}); }

    rc.innerHTML = ''
      + '<div class="qc-seg" data-modes>'
      +   '<button data-mode="dims" aria-pressed="true">Room dimensions</button>'
      +   '<button data-mode="sqft" aria-pressed="false">Square footage</button>'
      + '</div>'
      + '<div class="qc-climate">'
      +   '<div class="qc-cl-field"><label>ZIP code <button class="moreinfo-sm" data-info="climateWhy" aria-label="Why climate matters">'+icon('info')+'</button></label>'
      +     '<input data-zip type="text" inputmode="numeric" maxlength="5" placeholder="e.g. 37138"></div>'
      +   '<div class="qc-cl-field qc-cl-zone"><label>Climate zone</label>'
      +     '<select data-climate>'+Object.keys(CLIMATE).map(function(z){return '<option value="'+z+'" '+(z===climateZone?'selected':'')+'>'+CLIMATE[z].label+'</option>';}).join('')+'</select></div>'
      + '</div>'
      + '<div data-rooms></div>'
      + ((!fixedRooms && maxRooms>1) ? '<button class="rc-add" data-addroom>+ Add room</button>' : '')
      + '<div class="qc-result" data-result hidden>'
      +   '<div class="big" data-btu>—</div>'
      +   '<div class="lbl">'+(variant==='central'?'Estimated whole-home load':(variant==='multi'?'Estimated total load':'Estimated load'))+'</div>'
      +   '<div class="unit" data-unit></div>'
      +   '<div class="rc-breakdown" data-breakdown hidden></div>'
      +   '<div class="rc-warn" data-warn hidden></div>'
      +   '<div class="sub" data-sub></div>'
      +   ((onGoto||apply) ? '<div class="rc-actions"><button class="btn primary" data-goto style="width:auto;padding:11px 22px;">'+(apply?'Use this size':'Show me my system')+' '+icon('arrowRt')+'</button></div>' : '')
      +   '<button class="rc-why" data-info="btuWhy" type="button">'+icon('info')+' Why is the BTU more than the room size?</button>'
      + '</div>';

    var listEl   = rc.querySelector('[data-rooms]');
    var addBtn   = rc.querySelector('[data-addroom]');
    var resultEl = rc.querySelector('[data-result]');

    function roomRow(r,i){
      var dims = mode==='dims'
        ? '<input data-f="len" type="number" inputmode="decimal" placeholder="Length ft" value="'+(r.len==null?'':r.len)+'"><input data-f="wid" type="number" inputmode="decimal" placeholder="Width ft" value="'+(r.wid==null?'':r.wid)+'">'
        : '<input data-f="sqft" type="number" inputmode="decimal" placeholder="Square feet" value="'+(r.sqft==null?'':r.sqft)+'">';
      var ceil = r.vaulted
        ? '<input data-f="wall" type="number" inputmode="decimal" placeholder="Wall ht ft" value="'+(r.wall==null?'':r.wall)+'"><input data-f="peak" type="number" inputmode="decimal" placeholder="Peak ht ft" value="'+(r.peak==null?'':r.peak)+'">'
        : '<input data-f="ceil" type="number" inputmode="decimal" placeholder="Ceiling ft" value="'+(r.ceil==null?'':r.ceil)+'">';
      var canRemove = !fixedRooms && rooms.length>1;
      return '<div class="rc-room" data-idx="'+i+'"><div class="rc-room-head"><span class="rc-rn">Room '+(i+1)+'</span>'
        + (canRemove?'<button class="rc-remove" data-remove aria-label="Remove room">&times;</button>':'')+'</div>'
        + '<div class="rc-fields">'+dims+ceil+'</div>'
        + '<label class="rc-vault"><input type="checkbox" data-f="vaulted" '+(r.vaulted?'checked':'')+'> Vaulted / cathedral ceiling</label>'
        + '<button class="rc-why" data-info="ceilingWhy" type="button">'+icon('info')+' Why ceiling height matters</button></div>';
    }
    function render(){
      listEl.innerHTML = rooms.map(roomRow).join('');
      rooms.forEach(function(r,ri){ var cb=listEl.querySelector('.rc-room[data-idx="'+ri+'"] [data-f="vaulted"]'); if(cb) cb.checked=(r.vaulted===true); });
      if(addBtn){ addBtn.disabled = rooms.length>=maxRooms; addBtn.textContent = rooms.length>=maxRooms ? ('Maximum '+maxRooms+' rooms') : '+ Add room'; }
      recalc();
    }
    function roomSqft(r){ return mode==='dims' ? n(r.len)*n(r.wid) : n(r.sqft); }
    function roomEff(r){ if(r.vaulted){ var w=n(r.wall),p=n(r.peak); return (w&&p)?(w+p)/2:(w||p||8); } return n(r.ceil)||8; }
    function roomLongest(r){ return mode==='dims' ? Math.max(n(r.len),n(r.wid)) : 0; }
    function climateMult(){ return (CLIMATE[climateZone]||CLIMATE['4']).mult; }
    function roomBtu(r){ return roomSqft(r)*QC_BTU_PER_SQFT*(roomEff(r)/8)*climateMult(); }

    function recalc(){
      var elBtu=rc.querySelector('[data-btu]'), elUnit=rc.querySelector('[data-unit]'),
          elSub=rc.querySelector('[data-sub]'), elWarn=rc.querySelector('[data-warn]'),
          elBreak=rc.querySelector('[data-breakdown]'), gotoBtn=rc.querySelector('[data-goto]');
      var filledCount = rooms.filter(function(r){return roomSqft(r)>0;}).length;
      var complete = filledCount===rooms.length && filledCount>0;
      resultEl.hidden = !complete;
      if(!complete){ return; }
      elWarn.hidden=true; elBreak.hidden=true;
      var filled = rooms.filter(function(r){return roomSqft(r)>0;});
      var total=0, sqftTotal=0;
      filled.forEach(function(r){ sqftTotal+=roomSqft(r); total+=roomBtu(r); });
      var btu=Math.round(total/500)*500, count=filled.length;
      elBtu.textContent=btu.toLocaleString();
      if(variant==='central'){
        var ducted = Math.round(total*1.15/500)*500;   /* +15% duct-loss allowance for a central ducted system */
        var size = nearestCentral(ducted);
        elBtu.textContent = ducted.toLocaleString();
        elUnit.innerHTML = 'Recommended: <b>GWIN Max 22 · '+(size/1000)+'k</b> central ducted';
        elBreak.hidden=false;
        elBreak.innerHTML = filled.map(function(r,i){return '<div class="bd-row"><span>Room '+(i+1)+' · '+Math.round(roomSqft(r)).toLocaleString()+' sq ft</span><b>'+Math.round(roomBtu(r)).toLocaleString()+' BTU</b></div>';}).join('');
        elSub.innerHTML = 'Whole-home total ≈ <b>'+Math.round(sqftTotal).toLocaleString()+' sq ft</b> + 15% duct allowance. Estimate only — a tech confirms the final load and duct design.';
        lastSpec = {kind:'central', sizeBtu:size};
        if(gotoBtn){ gotoBtn.disabled=false; gotoBtn.innerHTML = 'Show me my system '+icon('arrowRt'); }
      } else if(variant==='multi' && count>=2){
        var cond=nearestCond(btu);
        var heads = filled.map(function(r){return nearestHeadK(roomBtu(r));});
        elUnit.innerHTML='Suggested: <b>'+condLabel(cond)+'</b> · <b>'+count+' zone'+(count>1?'s':'')+'</b>';
        elBreak.hidden=false;
        elBreak.innerHTML = filled.map(function(r,i){return '<div class="bd-row"><span>Room '+(i+1)+' · '+Math.round(roomSqft(r)).toLocaleString()+' sq ft</span><b>'+heads[i]+'k head</b></div>';}).join('');
        elSub.innerHTML='Total ≈ <b>'+Math.round(sqftTotal).toLocaleString()+' sq ft</b>. Estimate only — insulation, windows, climate and sun all change the real load.';
        lastSpec = {kind:'multi', zones:count, condBtu:cond, heads:heads};
        if(gotoBtn){ gotoBtn.disabled = cond>48000; gotoBtn.innerHTML = cond>48000 ? 'Coming soon' : ('Show me my system '+icon('arrowRt')); }
      } else {
        var single=nearestSingle(btu);
        var longest=Math.max.apply(null, filled.map(roomLongest));
        var oversize = (btu>OVERSIZE_BTU) || (longest>OVERSIZE_LEN);
        var oneRoomInMulti = variant==='multi' && count===1;
        if(single && !oversize){
          elUnit.innerHTML = oneRoomInMulti
            ? 'One room — a <b>single-zone '+(single/1000)+'k</b> is the better fit'
            : 'Recommended size: <b>'+(single/1000)+'k ('+single.toLocaleString()+' BTU)</b>';
        } else {
          elUnit.innerHTML='This space is large for a single head';
        }
        if(oversize){
          elWarn.hidden=false;
          elWarn.innerHTML = (longest>OVERSIZE_LEN && btu<=OVERSIZE_BTU)
            ? 'At '+Math.round(longest)+' ft long, one head may not move air evenly end-to-end. Consider a <b>multi-zone</b> system or <b>multiple single zones</b> for proper airflow.'
            : 'For a load this large, a single head won\'t distribute air well. Consider a <b>multi-zone</b> system or <b>multiple single zones</b> for proper airflow.';
        }
        elSub.innerHTML='Based on <b>'+Math.round(sqftTotal).toLocaleString()+' sq ft</b>. Estimate only — insulation, windows, climate and sun all change the real load.';
        lastSpec = {kind:'single', sizeBtu: single || 36000};
        if(gotoBtn){ gotoBtn.disabled = false; gotoBtn.innerHTML = 'Show me my system '+icon('arrowRt'); }
      }
    }

    rc.querySelector('[data-modes]').addEventListener('click', function(e){
      var b=e.target.closest('[data-mode]'); if(!b) return;
      mode=b.dataset.mode;
      rc.querySelectorAll('[data-mode]').forEach(function(x){ x.setAttribute('aria-pressed', x===b); });
      render();
    });
    if(addBtn) addBtn.addEventListener('click', function(){ if(rooms.length<maxRooms){ rooms.push({}); render(); } });
    var zipEl = rc.querySelector('[data-zip]'); var climateEl = rc.querySelector('[data-climate]');
    if(zipEl) zipEl.addEventListener('input', function(){ var z=zoneFromZip(zipEl.value); if(z){ climateZone=z; if(climateEl) climateEl.value=z; recalc(); } });
    if(climateEl) climateEl.addEventListener('change', function(){ climateZone=climateEl.value; if(zipEl) zipEl.value=''; recalc(); });
    listEl.addEventListener('click', function(e){ var rm=e.target.closest('[data-remove]'); if(!rm) return; rooms.splice(+rm.closest('.rc-room').dataset.idx,1); render(); });
    listEl.addEventListener('input', function(e){
      var f=e.target.dataset.f; if(!f) return;
      var i=+e.target.closest('.rc-room').dataset.idx;
      if(f==='vaulted'){ rooms[i].vaulted=e.target.checked; render(); }
      else { rooms[i][f]=e.target.value; recalc(); }
    });
    /* Prevent the mouse wheel from silently changing a focused number input
       (ceiling height, sq ft, dims). Without this, scrolling the page mutates
       whatever number field is focused, which then shifts the BTU load. */
    listEl.addEventListener('wheel', function(e){
      var t=e.target;
      if(t && t.tagName==='INPUT' && t.type==='number' && t===document.activeElement){ e.preventDefault(); }
    }, {passive:false});
    var gotoBtnEl = rc.querySelector('[data-goto]');
    if(gotoBtnEl){ gotoBtnEl.addEventListener('click', function(){ if(!lastSpec) return; if(apply) apply(lastSpec); else if(onGoto) onGoto(lastSpec); }); }
    rc.reset = function(){ rooms=makeRooms(); mode='dims';
      rc.querySelectorAll('[data-mode]').forEach(function(x){ x.setAttribute('aria-pressed', x.dataset.mode==='dims'); });
      resultEl.hidden=true; render(); };
    render();
  }

  /* calc panel markup (with the "Use custom builder" tab — 1-a: blurb + link-out) */
  function calcPanel(ctx, introP){
    var bUrl = LINKS.builderUrl, bLabel = LINKS.builderLabel || 'Use the custom builder';
    return '<section class="series" id="'+(ctx==='single'?'single-calc':(ctx==='central'?'central-calc':'calc'))+'" style="border-top:0;margin-top:0;">'
      + '<div class="calc-panel" data-calc-panel>'
      +   '<div class="calc-panel-head"><div><h3>BTU &amp; condenser calculator</h3><p class="intro-p">'+introP+'</p></div></div>'
      +   '<div class="calc-tabs" data-calc-tabs>'
      +     '<button data-calc-tab="quick" aria-pressed="true">'+icon('gauge')+' Quick BTU calculator</button>'
      +     '<button data-calc-tab="builder" aria-pressed="false">'+icon('ruler')+' '+bLabel+'</button>'
      +   '</div>'
      +   '<div data-calc-tabpanel="quick"><div class="calc-panel-body"><div data-roomcalc data-ctx="'+ctx+'"></div></div></div>'
      +   '<div class="calc-builder-cta" data-calc-tabpanel="builder" hidden>'
      +     '<p>Want to build an exact system — choose every head type, size and lineset, with live pricing as you go? Open the full custom builder.</p>'
      +     (bUrl ? '<a class="btn primary" style="width:auto;padding:13px 24px;" href="'+bUrl+'">Open the custom builder '+icon('arrowRt')+'</a>' : '')
      +   '</div>'
      +   '<div class="calc-foot"><button class="cp-btn" data-calc-reset>Reset</button>'
      +     '<button class="calc-toggle" data-calc-toggle>'+icon('chevronUp')+' Close BTU calculator</button></div>'
      + '</div></section>';
  }

  /* jump from a calc result to the matching card */
  function gotoFromSpec(spec){
    closeCalc();
    var sel, tab, selFallback=null;
    if(spec.kind==='multi'){ tab='multi';
      var mb=(spec.condBtu/1000)+',000';
      /* match BOTH condenser BTU and zone count — a given condenser BTU exists at
         several zone counts, so matching by BTU alone grabbed the wrong (first) card. */
      sel='#multi .scard[data-kind=\'multi\'][data-btu=\''+mb+'\'][data-zones=\''+spec.zones+'\']';
      selFallback='#multi .scard[data-kind=\'multi\'][data-btu=\''+mb+'\']';
    }
    else if(spec.kind==='central'){ tab='central'; sel='#central .scard[data-kind=\'single\'][data-btu=\''+((spec.sizeBtu/1000)+',000')+'\']'; }
    else { tab='single'; sel='#single .scard[data-kind=\'single\'][data-btu=\''+((spec.sizeBtu/1000)+',000')+'\']'; }
    if(root.getAttribute('data-tab')!==tab) setTab(tab);
    setTimeout(function(){
      var card = root.querySelector(sel) || (selFallback ? root.querySelector(selFallback) : null);
      if(!card) return;
      if(card.classList.contains('soon')){
        card.scrollIntoView({behavior:'smooth', block:'center'}); card.classList.add('gwin-flash'); setTimeout(function(){ card.classList.remove('gwin-flash'); }, 1600);
      } else {
        /* carry the calculator's suggested per-zone head sizes into the configurator */
        if(spec.kind==='multi' && spec.heads && spec.heads.length){ PENDING_HEADS = spec.heads.slice(); }
        openConfig(card);
      }
    }, 90);
  }

  /* quick-size calculator MODAL */
  var calcOverlay = document.getElementById('calcOverlay');
  function openCalc(label, kind, opts){
    opts = opts || {};
    var t = document.getElementById('qcTitle'); if(t) t.textContent = label + ' — quick size';
    var isMulti = kind==='multi';
    var rcEl = document.querySelector('#qcWrap [data-roomcalc]');
    if(rcEl) buildRoomCalc(rcEl, { fixedRooms: opts.fixedRooms||null, maxRooms: isMulti?MAX_ROOMS:1, variant: isMulti?'multi':'single', onGoto: opts.apply?null:gotoFromSpec, apply: opts.apply||null });
    if(calcOverlay){ calcOverlay.hidden=false; document.body.style.overflow='hidden'; }
  }
  function closeCalc(){ if(calcOverlay){ calcOverlay.hidden=true; document.body.style.overflow=''; } }
  document.addEventListener('click', function(e){
    var opener=e.target.closest('[data-open-calc]'); if(!opener) return;
    openCalc(opener.dataset.openCalc, opener.dataset.calcKind, { fixedRooms: opener.dataset.fixedRooms ? +opener.dataset.fixedRooms : null });
  });
  (function(){ var x=document.getElementById('calcClose'); if(x) x.addEventListener('click', closeCalc);
    var d=document.getElementById('qcDone'); if(d) d.addEventListener('click', closeCalc);
    if(calcOverlay) calcOverlay.addEventListener('click', function(e){ if(e.target===calcOverlay) closeCalc(); }); })();

  /* calc-panel tab switch (Quick BTU calculator <-> Use custom builder) */
  document.addEventListener('click', function(e){
    var t=e.target.closest('[data-calc-tab]'); if(!t) return;
    var panel=t.closest('.calc-panel'); if(!panel) return;
    var which=t.dataset.calcTab;
    panel.querySelectorAll('[data-calc-tab]').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.calcTab===which); });
    panel.querySelectorAll('[data-calc-tabpanel]').forEach(function(p){ p.hidden = p.dataset.calcTabpanel!==which; });
  });

  /* ===================== CONFIGURATOR ENGINE (Phase 4B) =====================
     Inline-expand product configurator: opens under the clicked card's rail,
     glows the card, auto-scrolls to it, and collapses back on close.
     Placeholder pricing — real Shopify variant pricing + cart land in Phase 5. */
  var INFO_URL = (LINKS.pillar && LINKS.pillar.url) ? LINKS.pillar.url : 'https://gwinhvac.com';
  var TAB_CONTENT = {
    description:'Inverter-driven mini-split system engineered for DIY installation with a licensed technician included. Hyper-heat performance, Wi-Fi control, and an iron-clad GWIN warranty. (Placeholder copy — swap in real product description.)',
    submittals:'Submittal sheet, performance data, dimensional drawings, and electrical specifications. (Placeholder — link the real submittal PDFs here.)',
    install:'Step-by-step DIY install overview: mounting the head, running the cut-to-length flare-less lineset, setting the condenser, and scheduling the tech to leak-test and commission startup. (Placeholder — link the real install guide.)'
  };
  function condFromBtu(btu){ return btuK(btu); }

  /* ---- (i) popover content from the connected product (or air-handler override) ---- */
  function _infoFromProduct(p, title, overridePhoto, overrideText){
    var hasOverride = overridePhoto || overrideText;
    if(!p && !hasOverride) return null;
    var imgs = [];
    if(overridePhoto) imgs.push(overridePhoto);
    else if(p && p.images && p.images.length) imgs = p.images.slice();
    var desc = overrideText || (p && p.description) || '';
    var dhtml = desc ? (/<[a-z][\s\S]*>/i.test(desc) ? desc : '<p>'+desc+'</p>') : '';
    return { title: title || (p && p.title) || 'More info', imgs: imgs, html: dhtml };
  }
  function accLibrary(){ var a=window.gwin_diy_sales_acc; return (a&&a.infoLibrary)||[]; }
  function libFind(fn){ var L=accLibrary(); for(var i=0;i<L.length;i++){ try{ if(fn(L[i])) return L[i]; }catch(e){} } return null; }
  function _infoFromLib(e, title){
    if(!e) return null;
    var imgs = (e.photos||[]).slice();
    var html = e.html ? (/<[a-z][\s\S]*>/i.test(e.html) ? e.html : '<p>'+e.html+'</p>') : '';
    return { title: title || 'More info', imgs: imgs, html: html };
  }
  function infoEntryFor(kind, cfg, cat, optIdx){
    cfg = cfg || CFG; if(!cfg) return null;
    if(kind==='cutter'){
      var lec = libFind(function(e){ return e['for']==='cutter'; });
      if(lec) return _infoFromLib(lec, 'Pipe cutter');
      return _infoFromProduct((accCatalog()||{}).pipeCutter, 'Pipe cutter');
    }
    var h0 = cfg.heads[0] || {};
    if(kind==='condenser'){
      if(cfg.kind==='multi'){
        var mcc=multiCondenser(cfg.zones,cfg.condK); var cdp=mcc&&mcc.product;
        if(cdp){ var cfp=_infoFromProduct(cdp, cfg.zones+'-zone '+cfg.condK+'k condenser'); if(cfp&&((cfp.imgs&&cfp.imgs.length)||(cfp.html&&String(cfp.html).trim()))) return cfp; }
      } else {
        var csys=findSystem(h0.type,h0.sizeK,cat,cfg.voltage,condFamily(cfg)); var scp=csys&&(csys.connectionType==='bundle'?csys.bundle:csys.condenser);
        if(scp){ var sfp=_infoFromProduct(scp,'Condenser'); if(sfp&&((sfp.imgs&&sfp.imgs.length)||(sfp.html&&String(sfp.html).trim()))) return sfp; }
      }
      return {title:'Condenser', photos:0, html:'<p>The outdoor unit that powers your system. See the product page for full specs.</p>'};
    }
    if(cfg.kind==='multi'){
      if(kind==='mount'||kind==='electrical'){
        var mi2=(optIdx!=null)?+optIdx:(+((cfg.sys||{})[kind])||0);
        if(mi2<1) return INFO[kind]||null;
        var mmc=multiCondenser(cfg.zones,cfg.condK); var marr=(mmc&&((kind==='mount')?mmc.mounting:mmc.electrical))||[]; var mpr=marr[mi2-1];
        if(mpr){ var mfp=_infoFromProduct(mpr); if(mfp&&((mfp.imgs&&mfp.imgs.length)||(mfp.html&&String(mfp.html).trim()))) return mfp; }
        return INFO[kind]||null;
      }
      var mhi=multiHead(h0.type,h0.sizeK);
      if(kind==='lineGuard'||kind==='pump'){
        var mpr2=mhi&&((kind==='lineGuard')?mhi.lineGuard:mhi.pump);
        if(mpr2){ var mfp2=_infoFromProduct(mpr2,(ACC[kind]&&ACC[kind].label)); if(mfp2&&((mfp2.imgs&&mfp2.imgs.length)||(mfp2.html&&String(mfp2.html).trim()))) return mfp2; }
        return INFO[kind]||null;
      }
      if(kind==='lineset'){
        var mls=mhi&&mhi.lineset;
        if(mls){ var mfp3=_infoFromProduct(mls,'Lineset'); if(mfp3&&((mfp3.imgs&&mfp3.imgs.length)||(mfp3.html&&String(mfp3.html).trim()))) return mfp3; }
        return INFO.lineset||null;
      }
    }
    var sys = findSystem(h0.type, h0.sizeK, cat, cfg.voltage, condFamily(cfg));
    if(!sys) return null;
    if(kind==='lineGuard' || kind==='pump'){
      var idx = +(h0[kind])||0;                          /* line guard + pump: show first option's info even when unchecked (cutter-like) */
      var arr = (kind==='lineGuard') ? sys.lineGuard : sys.pump;
      var prod = arr && arr[idx>=1 ? idx-1 : 0];
      var lcat = (kind==='lineGuard') ? 'lineguard' : 'pump';
      var le = (prod && prod.handle) ? libFind(function(e){ return e['for']===lcat && e.product===prod.handle; }) : null;
      if(le) return _infoFromLib(le, (ACC[kind]&&ACC[kind].label));
      return _infoFromProduct(prod, (ACC[kind]&&ACC[kind].label));
    }
    if(kind==='mount' || kind==='electrical'){
      var i2 = (optIdx!=null) ? +optIdx : (+((cfg.sys||{})[kind])||0); if(i2<1) return INFO[kind] || null;
      var arr2 = (kind==='mount') ? sys.mounting : sys.electrical;
      var prod2 = arr2 && arr2[i2-1];
      var mcat = (kind==='mount') ? 'mounting' : 'electrical';
      var le2 = (prod2 && prod2.handle) ? libFind(function(e){ return e['for']===mcat && e.product===prod2.handle; }) : null;
      if(le2) return _infoFromLib(le2, (ACC[kind]&&ACC[kind].label));
      return _infoFromProduct(prod2);
    }
    if(kind==='lineset'){
      var li = (optIdx!=null) ? +optIdx : (+(h0.lineset)||0);
      var lsObj = (sys.linesetMode==='separate') ? (sys.linesetLengths||[])[li] : sys.lineset;
      var lsOpts = lsOptsFor(h0.type, h0.sizeK, null, cfg.voltage, condFamily(cfg)) || [];
      var lbl = (lsOpts[li]||{}).label || '';
      var nl = lbl.toLowerCase().replace(/\s+/g,' ').trim();
      var le3 = nl ? libFind(function(e){ return e['for']==='lineset' && ((e.lengthLabel||'').toLowerCase().replace(/\s+/g,' ').trim())===nl; }) : null;
      if(le3) return _infoFromLib(le3, 'Lineset');
      return _infoFromProduct(lsObj, 'Lineset');
    }
    if(kind==='hw-king'||kind==='hw-emp'||kind==='hw-clean'||kind==='cassette'||kind==='ducted'){
      var vK = voltKey(cfg.voltage), sz = +(h0.sizeK);
      var le4 = libFind(function(e){
        if(e['for']!=='air' || e.style!==kind || voltKey(e.voltage)!==vK) return false;
        var raw = (e.size==null) ? '' : String(e.size).trim();
        if(raw==='') return true;                       // blank = all sizes for this style+voltage
        var list = raw.split(',').map(function(x){ return parseFloat(x); }).filter(function(n){ return !isNaN(n); });
        return list.indexOf(sz) !== -1;                 // matches any listed size
      });
      if(le4) return _infoFromLib(le4, (TYPE_LABEL[kind]||'Air handler'));
      var ahp = (sys.connectionType==='bundle') ? sys.bundle : sys.handler;
      return _infoFromProduct(ahp, (TYPE_LABEL[kind]||null), sys.ahInfoPhoto, sys.ahInfoText);
    }
    return null;
  }

  /* Per-option (i) for dropdown rows. Shows only when that specific option resolves to
     real info — an Info Library entry OR the product's own photo/description (1-b) — and
     only when the section toggle is on. Reuses infoEntryFor with an explicit option index. */
  function optHasInfo(kind, cfg, idx){
    var e = infoEntryFor(kind, cfg, null, idx);
    return !!(e && ((e.imgs && e.imgs.length) || (e.html && String(e.html).trim())));
  }
  function optInfoBadge(kind, cfg, idx){
    if(root.getAttribute('data-optinfo-on')==='false') return '';   /* section off-switch */
    return '<button type="button" class="gwin-opt-i" data-optinfo="'+kind+'" data-opti="'+idx+'" aria-label="More info">'+icon('info')+'</button>';
  }

  /* ---- content resolution (Description / Submittals tabs) ---- */
  function sysForCfg(){
    if(!CFG) return null;
    var h0 = CFG.heads && CFG.heads[0];
    if(!h0) return null;
    return findSystem(h0.type, h0.sizeK, null, CFG.voltage, condFamily(CFG));
  }
  /* descOverride (richtext) wins; else the connected bundle/handler product description; else null (placeholder). */
  function pickDescription(sys){
    if(!sys) return null;
    if(sys.descOverride) return sys.descOverride;
    var dp = (sys.connectionType === 'bundle') ? sys.bundle : sys.handler;
    if(dp && dp.description) return /<[a-z][\s\S]*>/i.test(dp.description) ? dp.description : '<p>'+dp.description+'</p>';
    return null;
  }
  function pickSubmittal(sys){ return (sys && sys.submittal) ? sys.submittal : null; }
  /* Multi-zone description: condenser's descOverride (forward-compat with Change 2) wins,
     else the connected condenser product's own description; else null -> placeholder.
     Mirrors pickDescription but sourced from multiCondenser() instead of single findSystem. */
  function multiDescription(cfg){
    var c = cfg ? multiCondenser(cfg.zones, cfg.condK) : null;
    if(!c) return null;
    if(c.descOverride) return c.descOverride;
    var d = c.product && c.product.description;
    if(d) return /<[a-z][\s\S]*>/i.test(d) ? d : '<p>'+d+'</p>';
    return null;
  }

  /* ---- Combined build description (1-b): every CHOSEN product's description, grouped.
     condenser + each distinct head + chosen accessories (mounting/electrical/lineset/
     guard/pump). Condenser descOverride replaces ONLY the condenser portion (2-a).
     Deduped by label+title+body; products with no description are skipped. ---- */
  function _descEsc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function _descHtml(d){ return /<[a-z][\s\S]*>/i.test(d) ? d : '<p>'+d+'</p>'; }
  function combinedDescParts(cfg){
    var items = [], idx = {};
    /* aggregate by key: repeats bump the count instead of duplicating. Heading always
       shown (even with no description) so the item is visible + flags missing copy. */
    function add(key, name, html){
      if(idx[key]){ idx[key].count++; return; }
      var it = { key:key, name:name, html:html||'', count:1 };
      idx[key] = it; items.push(it);
    }
    function bodyOf(product, override){
      if(override) return override;
      var d = product && product.description;
      return d ? _descHtml(d) : '';
    }
    function lsLabel(type, sizeK, lineProd, lineIdx, volt, fam){
      var lso = lsOptsFor(type, sizeK, null, volt || '230v', fam || null);
      var li  = Math.min(+lineIdx || 0, (lso && lso.length ? lso.length - 1 : 0));
      var raw = (lso && lso[li]) ? String(lso[li].label || '') : '';
      /* display: drop only a trailing PRICE/included decoration — never length-bearing text */
      var disp = raw.replace(/\s*\([^)]*(?:\$|\bincluded\b|\bfree\b)[^)]*\)\s*$/i, '').trim();
      /* key on the RAW title so two distinct lengths can never collapse into one item */
      return { name: (disp ? disp + ' ' : '') + 'lineset', key: 'ls:' + ((lineProd && lineProd.handle) || '') + ':' + raw };
    }
    if(!cfg) return items;
    if(cfg.kind === 'multi'){
      var mc = multiCondenser(cfg.zones, cfg.condK);
      if(mc) add('cond', cfg.condK + 'k Condenser', bodyOf(mc.product, mc.descOverride || null));   /* override = condenser portion only (2-a) */
      (cfg.heads||[]).forEach(function(h){ var mh = multiHead(h.type, h.sizeK); add('head:'+h.type+':'+h.sizeK, h.sizeK+'k '+typeTitle(h.type), bodyOf(mh && mh.product)); });
      var ss = cfg.sys || {};
      if(mc){
        if((+ss.mount||0)      > 0 && mc.mounting   && mc.mounting[ss.mount-1]){     var mp = mc.mounting[ss.mount-1];     add('mount:'+(mp.handle||mp.title), mp.title||'Mounting',   bodyOf(mp)); }
        if((+ss.electrical||0) > 0 && mc.electrical && mc.electrical[ss.electrical-1]){ var ep = mc.electrical[ss.electrical-1]; add('elec:'+(ep.handle||ep.title), ep.title||'Electrical', bodyOf(ep)); }
      }
      (cfg.heads||[]).forEach(function(h){
        var mh = multiHead(h.type, h.sizeK); if(!mh) return;
        if((+h.lineGuard||0) > 0 && mh.lineGuard) add('lg:'+(mh.lineGuard.handle||''), 'Line guard',      bodyOf(mh.lineGuard));
        if((+h.pump||0)      > 0 && mh.pump)      add('pump:'+(mh.pump.handle||''),   'Condensate pump', bodyOf(mh.pump));
        if(mh.lineset){ var L = lsLabel(h.type, h.sizeK, mh.lineset, h.lineset, '230v', null); add(L.key, L.name, bodyOf(mh.lineset)); }
      });
    } else {
      var h0 = (cfg.heads||[])[0]; if(!h0) return items;
      var sys = findSystem(h0.type, h0.sizeK, null, cfg.voltage, condFamily(cfg));
      if(!sys) return items;
      if(sys.connectionType === 'bundle'){
        add('sys', cfg.condK + 'k System', bodyOf(sys.bundle, sys.descOverride || null));
      } else {
        add('cond', cfg.condK + 'k Condenser', bodyOf(sys.condenser, sys.descOverride || null));   /* override = condenser portion only (2-a) */
        add('head:'+h0.type+':'+h0.sizeK, h0.sizeK+'k '+typeTitle(h0.type), bodyOf(sys.handler));
      }
      var s2 = cfg.sys || {};
      if((+s2.mount||0)      > 0 && sys.mounting   && sys.mounting[s2.mount-1]){     var mp2 = sys.mounting[s2.mount-1];     add('mount:'+(mp2.handle||mp2.title), mp2.title||'Mounting',   bodyOf(mp2)); }
      if((+s2.electrical||0) > 0 && sys.electrical && sys.electrical[s2.electrical-1]){ var ep2 = sys.electrical[s2.electrical-1]; add('elec:'+(ep2.handle||ep2.title), ep2.title||'Electrical', bodyOf(ep2)); }
      if((+h0.lineGuard||0)  > 0 && sys.lineGuard  && sys.lineGuard[h0.lineGuard-1])  add('lg:'+((sys.lineGuard[h0.lineGuard-1].handle)||''), 'Line guard',      bodyOf(sys.lineGuard[h0.lineGuard-1]));
      if((+h0.pump||0)       > 0 && sys.pump       && sys.pump[h0.pump-1])            add('pump:'+((sys.pump[h0.pump-1].handle)||''),     'Condensate pump', bodyOf(sys.pump[h0.pump-1]));
      if(sys.lineset){ var L2 = lsLabel(h0.type, h0.sizeK, sys.lineset, h0.lineset, cfg.voltage, condFamily(cfg)); add(L2.key, L2.name, bodyOf(sys.lineset)); }
    }
    if(cfg.pipeCutter){ var pc = (accCatalog()||{}).pipeCutter; if(pc) add('cutter', pc.title || 'Lineset cutter tool', bodyOf(pc)); }
    return items;
  }
  function renderCombinedDesc(items){
    if(!items || !items.length) return null;
    return items.map(function(it){
      var head = _descEsc(it.name) + ' \u00d7' + it.count;          /* always show count, e.g. "9k Slim Cassette ×1" */
      return '<div class="cfg-desc-group" style="margin:0 0 16px;">'
        + '<div class="cfg-desc-h" style="font-weight:700;font-size:16px;color:#a855f7;margin:0 0 6px;">' + head + '</div>'
        + (it.html ? '<div class="cfg-desc-body">' + it.html + '</div>' : '')
        + '</div>';
    }).join('');
  }
  function refreshCfgDesc(){
    if(!CFG || typeof root === 'undefined' || !root) return;
    var dd = root.querySelector('#cfgDesc'); if(!dd) return;
    var html = renderCombinedDesc(combinedDescParts(CFG));
    if(html){ dd.innerHTML = html; } else { dd.textContent = TAB_CONTENT.description; }
  }
  /* Install guide steps for a product, keyed by air-handler type (shared across that type's cards). */
  function accInstall(){ var a=(typeof window!=='undefined') && window.gwin_diy_sales_acc; return (a&&a.installGuides)||[]; }
  function installStepsFor(t){
    if(!t) return [];
    var G=accInstall();
    for(var i=0;i<G.length;i++){ if(G[i] && G[i].type===t) return (G[i].steps||[]); }
    return [];
  }
  function renderInstall(steps, imgOffset){
    imgOffset = imgOffset || 0;
    var h='<ol class="cfg-install">'; var imgN=0;
    for(var i=0;i<steps.length;i++){ var s=steps[i];
      h+='<li class="ig-step"><span class="ig-num">'+(i+1)+'</span><div class="ig-step-body">';
      if(s.img){ h+='<img class="ig-img" data-i="'+(imgOffset+imgN)+'" src="'+s.img+'" alt="" loading="lazy">'; imgN++; }
      if(s.caption) h+='<p class="ig-cap">'+s.caption+'</p>';
      h+='</div></li>';
    }
    return h+'</ol>';
  }
  function populateTabs(){
    var sys = sysForCfg();
    refreshCfgDesc();
    var sb = root.querySelector('#cfgSub');
    if(sb){ var u = pickSubmittal(sys);
      if(u){ sb.innerHTML = '<a class="cfg-sub-link" href="'+u+'" target="_blank" rel="noopener">View submittal / spec sheet '+icon('arrowRt')+'</a>'; }
      else { sb.textContent = TAB_CONTENT.submittals; } }
    var ins = root.querySelector('#cfgInstall');
    var insBtn = root.querySelector('[data-tab-btn-m="install"]');
    var insPanel = root.querySelector('[data-tab-panel-m="install"]');
    var insHtml = '', anySteps = false, imgs = [];
    if(CFG.kind === 'multi'){
      /* one guide per DISTINCT head type present (guides are keyed by type; same type installs
         the same way in any zone). Image indices stay continuous across guides. */
      var seenT = {}, dtypes = [];
      (CFG.heads||[]).forEach(function(h){ if(h.type && !seenT[h.type]){ seenT[h.type]=1; dtypes.push(h.type); } });
      dtypes.forEach(function(t){
        var st = installStepsFor(t);
        if(st.length){
          anySteps = true;
          insHtml += '<div class="cfg-install-group"><h4 class="cfg-install-h">' + (TYPE_LABEL[t]||t) + ' — install</h4>' + renderInstall(st, imgs.length) + '</div>';
          imgs = imgs.concat(st.map(function(s){ return s.img; }).filter(Boolean));
        }
      });
      CFG._installImgs = imgs;
    } else {
      var itype = (CFG.heads && CFG.heads[0] && CFG.heads[0].type) || CFG.lockedType;
      var steps = installStepsFor(itype);
      CFG._installImgs = steps.map(function(s){ return s.img; }).filter(Boolean);
      if(steps.length){ anySteps = true; insHtml = renderInstall(steps); }
    }
    if(anySteps){
      if(ins) ins.innerHTML = insHtml;
      if(insBtn) insBtn.hidden = false;
    } else {                                   /* 3-a: no steps -> hide the Install tab entirely */
      if(ins) ins.innerHTML = '';
      if(insBtn) insBtn.hidden = true;
      if(insPanel) insPanel.hidden = true;
    }
  }

  var cfgOverlay2 = root.querySelector('#cfgOverlay');
  var elPrice  = root.querySelector('#cfgPrice');
  var elPrice2 = root.querySelector('#cfgPrice2');
  var CFG = null;

  /* Build the open-configurator reel from the resolved system (same source order as the
     card, 1-a). Each entry is {img:url}; empty -> single icon fallback entry (4-a). */
  function cfgPhotoReel(cfg){
    if(!cfg || !cfg.heads || !cfg.heads.length) return [{icon:(cfg&&cfg.photo)||'truck'}];
    if(cfg.kind==='multi'){
      var mimgs = multiCondenserPhotos(cfg.zones, cfg.condK);
      if(mimgs.length) return mimgs.map(function(u){ return {img:u}; });
      return [{icon: cfg.photo||'truck'}];
    }
    var sys = findSystem(cfg.heads[0].type, cfg.heads[0].sizeK, null, cfg.voltage, condFamily(cfg));
    var imgs = systemPhotos(sys);
    if(imgs.length) return imgs.map(function(u){ return {img:u}; });
    return [{icon: cfg.photo||'truck'}];
  }
  function renderGallery(){
    if(!CFG || !CFG.photos || !CFG.photos.length) return;
    var g = root.querySelector('#cfgGallery'); if(!g) return;
    if(!INFO_PHOTOS){ g.innerHTML=''; return; }
    var ps = CFG.photos, i = CFG.photoActive, p = ps[i] || ps[0];
    var multi = ps.length > 1;
    var hasImg = !!(p && p.img);
    var body = hasImg
      ? '<img class="mg-img" src="'+p.img+'" alt="" loading="lazy">'
        + '<span class="mg-cap">Photo '+(i+1)+' / '+ps.length+'</span>'
      : '<span class="mg-ico">'+icon((p&&p.icon)||'camera')+'</span>';
    g.innerHTML = '<div class="mg-stage'+(hasImg?' has-img':'')+'">'
      + body
      + (multi ? '<button class="mg-arrow prev" type="button" data-gal="prev" aria-label="Previous photo">'+icon('arrowL')+'</button>'
          + '<button class="mg-arrow next" type="button" data-gal="next" aria-label="Next photo">'+icon('arrowR')+'</button>'
          + '<div class="mg-dots">'+ps.map(function(_,k){ return '<span class="'+(k===i?'on':'')+'"></span>'; }).join('')+'</div>' : '')
      + '</div>';
  }
  function galStep(dir){
    if(!CFG || !CFG.photos || CFG.photos.length<2) return;
    var n = CFG.photos.length;
    CFG.photoActive = (CFG.photoActive + (dir==='next'?1:-1) + n) % n;
    renderGallery();
  }
  function typeOptsHTML(h, single){
    return HANDLER_TYPES.map(function(t){
      var disabled = single && t.id!==h.type;
      return '<option value="'+t.id+'" '+(t.id===h.type?'selected':'')+' '+(disabled?'disabled':'')+'>'+t.label+'</option>';
    }).join('');
  }
  /* custom dark dropdown (JS port of the gwin-select snippet — dark menu in every
     browser, including Safari). Root carries the same data-* the native select had. */
  /* dropdown option label with price suffix: "Pad +$39"; $0/None stays plain */
  function optPriceLabel(o){
    if(!o) return '';
    return (o.price>0) ? (o.label + ' +' + money(o.price)) : o.label;
  }
  function infoBadgeAsSpan(h){ return h ? h.replace('<button','<span role="button" tabindex="-1"').replace('</button>','</span>') : ''; }
  function cfgSelect(dataAttr, current, opts){
    var cur = opts.filter(function(o){ return String(o.value)===String(current); })[0] || opts[0] || {label:'Select…',value:''};
    var panel = opts.map(function(o){
      var soonCls = o.soon ? ' is-soon' : ''; var soonAttr = o.soon ? ' data-soon="1" aria-disabled="true"' : '';
      return '<div class="gwin-sel__opt'+(String(o.value)===String(current)?' is-selected':'')+soonCls+'" role="option" data-value="'+o.value+'"'+soonAttr+'><span class="gwin-sel__optwrap" style="display:inline-flex;align-items:center;gap:6px;min-width:0;">'+o.label+(o.info||'')+'</span></div>';
    }).join('');
    var btnI = cur.info ? '<span class="gwin-sel__btn-i" style="display:inline-flex;align-items:center;">'+infoBadgeAsSpan(cur.info)+'</span>' : '';
    return '<div class="gwin-sel" data-gsel '+dataAttr+'>'
      + '<button type="button" class="gwin-sel__btn" aria-haspopup="listbox" aria-expanded="false">'
      +   '<span class="gwin-sel__btn-main" style="display:flex;align-items:center;gap:6px;min-width:0;overflow:hidden;"><span class="gwin-sel__btn-text">'+String(cur.label).replace(/<[^>]*>/g,'')+'</span>'+btnI+'</span>'
      +   '<svg class="gwin-sel__caret" viewBox="0 0 12 7" fill="none" aria-hidden="true"><path d="M1 1l5 5 5-5" stroke="#9999bb" stroke-width="1.5"/></svg>'
      + '</button>'
      + '<div class="gwin-sel__panel" role="listbox">'+panel+'</div></div>';
  }
  function closeAllSel(){
    root.querySelectorAll('.gwin-sel__panel.is-open').forEach(function(p){ p.classList.remove('is-open'); });
    root.querySelectorAll('.gwin-sel__btn[aria-expanded="true"]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    root.querySelectorAll('.gwin-sel__btn-i').forEach(function(s){ s.style.display='inline-flex'; });
  }
  function headSnapNotice(typeId,fromK,toK){
    var t=(HANDLER_TYPES.find(function(x){return x.id===typeId;})||{}).label||'That air handler';
    if(toK<fromK){ return t+' doesn\u2019t come in '+fromK+'k \u2014 this head was set to its largest size, '+toK+'k. Re-check that it still covers the room.'; }
    return t+' doesn\u2019t come in '+fromK+'k \u2014 this head was moved up to '+toK+'k so it still covers the room.';
  }
  /* lineset is an option INDEX whose list can differ by (type,size). When type/size changes,
     preserve the shopper's chosen LENGTH by re-finding it in the new list (exact label, then
     numeric-length match); only fall back to "included" if that length truly isn't offered. */
  function lsLabelOf(h){ if(!h) return null; var l=lsOptsFor(h.type,h.sizeK)||[]; if(!l.length) return null; var i=Math.min(+h.lineset||0, l.length-1); return (l[i]||{}).label||null; }
  function remapLineset(h, prevLabel){
    var l=lsOptsFor(h.type,h.sizeK)||[]; if(!l.length) return 0;
    if(prevLabel){
      for(var i=0;i<l.length;i++){ if(l[i] && l[i].label===prevLabel) return i; }
      var pn=String(prevLabel).replace(/[^0-9]/g,'');
      if(pn){ for(var j=0;j<l.length;j++){ if(String((l[j]||{}).label||'').replace(/[^0-9]/g,'')===pn) return j; } }
    }
    return 0;
  }
  function applyCfgChange(selRoot, value){
    if(!CFG) return;
    if(selRoot.dataset.head!=null && selRoot.dataset.field){
      var h = CFG.heads[+selRoot.dataset.head], field=selRoot.dataset.field;
      if(field==='type'){
        var idxSelf=+selRoot.dataset.head, newType=value;
        h._notice=null;
        var prevSelf=h.sizeK;
        var prevLs=lsLabelOf(h);
        h.type=newType;
        var otherSelf=CFG.heads.reduce(function(a,hh,idx){ return idx===idxSelf?a:a+hh.sizeK; },0);
        h.sizeK=snapValid(CFG.condK,newType,otherSelf,h.sizeK);
        if(h.sizeK!==prevSelf){ h._notice=headSnapNotice(newType,prevSelf,h.sizeK); }
        h.lineset=remapLineset(h, prevLs);
        if(isHighWallType(newType)){
          CFG.heads.forEach(function(other,idx){ if(idx!==idxSelf && isHighWallType(other.type) && other.type!==newType){ var prevO=other.sizeK; var prevOLs=lsLabelOf(other); other.type=newType; var oth=CFG.heads.reduce(function(a,hh,j){ return j===idx?a:a+hh.sizeK; },0); other.sizeK=snapValid(CFG.condK,newType,oth,other.sizeK); other.lineset=remapLineset(other, prevOLs); other._notice=(other.sizeK!==prevO)?headSnapNotice(newType,prevO,other.sizeK):null; } });
        }
        renderConfigure();
      } else if(field==='size'){ var prevLsS=lsLabelOf(h); h._notice=null; h.sizeK=+value; h.lineset=remapLineset(h, prevLsS); renderConfigure(); }
      else if(field==='lineset'){ h.lineset=+value; recalcPrice(); }
    } else if(selRoot.dataset.accsel){ CFG.heads[+selRoot.dataset.head][selRoot.dataset.accsel]=+value; recalcPrice(); }
    else if(selRoot.dataset.sys){ CFG.sys[selRoot.dataset.sys]=+value; recalcPrice(); }
  }
  /* ---- Per-type air-handler info + size-snap preview (Slice C1) ---- */
  function typeTitle(typeId){ return (HANDLER_TYPES.find(function(t){return t.id===typeId;})||{}).label || TYPE_LABEL[typeId] || 'Air handler'; }
  function typeFinalSize(typeId, curSizeK, otherK){
    var snapped = snapValid(CFG.condK, typeId, otherK, curSizeK);
    var opts = validSizesForHead(CFG.condK, typeId, otherK);
    var conn = multiConnectedSizes(typeId);
    var filt = opts.filter(function(k){ return conn.indexOf(+k)!==-1; });
    if(filt.length && filt.indexOf(snapped)===-1) return filt[0];
    return snapped;
  }
  function typeSnapTag(typeId, h, otherK){
    var fin = typeFinalSize(typeId, h.sizeK, otherK);
    if(fin===h.sizeK) return '';
    var dir = fin<h.sizeK ? '\u2193' : '\u2191';
    return '<span class="gwin-snap-tag" style="display:inline-flex;align-items:center;gap:2px;background:rgba(245,158,11,.16);color:#f5c073;font-size:11px;font-weight:700;padding:1px 6px;border-radius:5px;margin-left:2px;white-space:nowrap;">'+dir+' '+fin+'k</span>';
  }
  function typeRepSize(typeId, h, otherK){
    var opts = validSizesForHead(CFG.condK, typeId, otherK);
    var conn = multiConnectedSizes(typeId);
    var filt = opts.filter(function(k){ return conn.indexOf(+k)!==-1; });
    var pool = filt.length ? filt : opts;
    if(pool.indexOf(h.sizeK)!==-1) return h.sizeK;
    return pool.length ? pool[0] : h.sizeK;
  }
  function typeInfoEntry(typeId, h, otherK){
    var vK = voltKey(CFG ? CFG.voltage : '230v');
    function libOK(e, blankOnly){
      if(!e || e['for']!=='air' || e.style!==typeId) return false;
      if(voltKey(e.voltage)!==vK) return false;
      var raw=(e.size==null)?'':String(e.size).trim();
      return blankOnly ? raw==='' : true;
    }
    var le = libFind(function(e){return libOK(e,true);}) || libFind(function(e){return libOK(e,false);});
    if(le){ var fl=_infoFromLib(le, typeTitle(typeId)); if(fl && ((fl.imgs&&fl.imgs.length)||(fl.html&&String(fl.html).trim()))) return fl; }
    if(h){ var repK=typeRepSize(typeId,h,otherK);
      if(CFG && CFG.kind==='multi'){
        var cs=multiConnectedSizes(typeId); var order=(cs.indexOf(+repK)!==-1)?[+repK].concat(cs):cs;
        for(var ci=0; ci<order.length; ci++){ var mh=multiHead(typeId, order[ci]); var mp=mh&&mh.product;
          if(mp){ var fpm=_infoFromProduct(mp, typeTitle(typeId), null, null); if(fpm && ((fpm.imgs&&fpm.imgs.length)||(fpm.html&&String(fpm.html).trim()))) return fpm; } } }
      else { var sys=findSystem(typeId, repK, accCatalog(), CFG.voltage, condFamily(CFG)); if(sys){ var ahp=(sys.connectionType==='bundle')?sys.bundle:sys.handler; var fp=_infoFromProduct(ahp, typeTitle(typeId), null, null); if(fp && ((fp.imgs&&fp.imgs.length)||(fp.html&&String(fp.html).trim()))) return fp; } } }
    if(INFO[typeId]) return INFO[typeId];
    return null;
  }
  function typeOptInfoBadge(typeId){
    return '<button type="button" class="gwin-opt-i" data-typeinfo="'+typeId+'" aria-label="More info">'+icon('info')+'</button>';
  }
  function renderConfigure(){
    if(!CFG) return;
    var single = CFG.kind==='single';
    var totalK = CFG.heads.reduce(function(a,h){ return a+h.sizeK; },0);
    var minK = condMin(CFG.condK), maxK = condMax(CFG.condK);
    var hasKing = CFG.heads.some(function(h){ return h.type==='hw-king'; });
    var rows = CFG.heads.map(function(h,i){
      var tObj = HANDLER_TYPES.find(function(t){ return t.id===h.type; }) || {};
      var tLabel = tObj.label || 'Air handler';
      var otherK = CFG.heads.reduce(function(a,hh,idx){ return idx===i ? a : a+hh.sizeK; },0);
      /* Show ALL types; ones with no connected product render as a disabled "Coming soon"
         option (see the soon-handling in cfgSelect + the click guard). They go live
         automatically once a multi product is connected for that type. */
      var typeList = HANDLER_TYPES;
      var sizeOpts = single ? [h.sizeK] : validSizesForHead(CFG.condK, h.type, otherK);
      if(!single){
        /* auto-hide: within capacity-valid sizes, keep only connected ones (fallback to capacity-valid) */
        var conn = multiConnectedSizes(h.type);
        var filtered = sizeOpts.filter(function(k){ return conn.indexOf(+k) !== -1; });
        if(filtered.length) sizeOpts = filtered;
        /* snap the head to a connected size if its current pick is no longer offered */
        if(sizeOpts.indexOf(h.sizeK) === -1 && sizeOpts.length){ h.sizeK = sizeOpts[0]; }
      }
      var pumpOffered = (CFG.kind==='multi')
        ? (function(){ var pmh=multiHead(h.type,h.sizeK); return !pmh || pmh.offersPump!==false; })()
        : isHighWallType(h.type);
      var pumpRow = pumpOffered ? (
          accControl('pump', i, h)
          + '<div class="acc-sub">Exterior-wall placement is recommended (drains by gravity). Add a pump for interior-wall placements.</div>'
        ) : '';
      var typeSizeBlock = single
        ? '<div class="cfg-static">'+tLabel+' <button class="moreinfo-sm" data-info-handler="'+i+'" aria-label="More info">'+icon('info')+'</button> · <b>'+h.sizeK+'k</b> <span class="lock-note">— fixed for this single-zone system</span></div>'
        : '<div class="cfg-grid">'
          + '<div class="cfg-field"><label>Air handler type</label>'
          + cfgSelect('data-head="'+i+'" data-field="type"', h.type, typeList.map(function(t){ var tconn=multiTypeConnected(t.id); return tconn ? {value:t.id, label:t.label + typeSnapTag(t.id, h, otherK), info: typeOptInfoBadge(t.id, h, otherK)} : {value:t.id, label:t.label + ' <span class="gwin-sel__soon">Coming soon</span>', soon:true}; }))+'</div>'
          + '<div class="cfg-field"><label>Air handler size <button class="moreinfo-sm" data-info="sizing" aria-label="More info">'+icon('info')+'</button></label>'
          + cfgSelect('data-head="'+i+'" data-field="size"', h.sizeK, sizeOpts.map(function(k){ return {value:k,label:k+'k'}; }))+'</div>'
          + '</div>';
      return '<div class="zone-row">'
        + '<div class="zr-head"><span class="zn">'+(single?'SYSTEM':'ZONE '+(i+1))+'</span><h4>Air handler'+(single?'':' '+(i+1))+'</h4>'
        + (single?'':'<button class="zr-size" data-size-zone="'+i+'">'+icon('gauge')+' Size this room</button>')+'</div>'
        + typeSizeBlock
        + (h._notice ? '<div class="zone-note">'+icon('info')+'<span>'+h._notice+'</span></div>' : '')
        + '<div style="margin-top:10px;">'
        + accControl('lineGuard', i, h)
        + pumpRow + '</div>'
        + '<div class="cfg-field" style="margin-top:10px;"><label>Lineset length (15 ft included)</label>'
        + cfgSelect('data-head="'+i+'" data-field="lineset"', Math.min(h.lineset||0, lsOptsFor(h.type,h.sizeK).length-1), lsOptsFor(h.type,h.sizeK).map(function(o,idx){ return {value:idx, label:optPriceLabel(o), info:optInfoBadge('lineset',CFG,idx)}; }))+'</div>'
        + '</div>';
    }).join('');
    function sysSelect(key,label){
      var opts = condAccOpts(CFG, key);
      return '<div class="cfg-field"><label>'+label+'</label>'
        + cfgSelect('data-sys="'+key+'"', Math.min(CFG.sys[key]||0, opts.length-1), opts.map(function(o,idx){ return {value:idx, label:optPriceLabel(o), info:optInfoBadge(key,CFG,idx)}; }))+'</div>';
    }
    var kingNote = (!single && hasKing) ? '<div class="cfg-king-note">'+icon('snow','16')+'<div>King high-wall heads on the 22 Multi condenser heat down to <b>−22°F</b> — the condenser sets the heating capability.</div></div>' : '';
    var cap = single
      ? '<div class="cfg-cap"><span class="lbl">Single-zone '+CFG.condK+'k system <button class="moreinfo-sm" data-info="condenser" aria-label="Condenser info">'+icon('info')+'</button></span></div>'
      : '<div class="cfg-cap"><span class="lbl">'+CFG.zones+' air handlers on a '+CFG.condK+'k condenser <button class="moreinfo-sm" data-info="condenser" aria-label="Condenser info">'+icon('info')+'</button></span><span class="badge">Heads '+totalK+'k · range '+minK+'–'+maxK+'k</span></div>';
    var cc = root.querySelector('#cfgConfigure');
    if(cc) cc.innerHTML = cap + kingNote + rows
      + '<div class="cfg-sub">System accessories</div>'
      + '<div class="cfg-grid">'+sysSelect('mount','Condenser mounting')+sysSelect('electrical','Electrical hookup')+'</div>';
    CFG.heads.forEach(function(h,i){ var lg=root.querySelector('#lineGuard'+i); if(lg) lg.checked=(+h.lineGuard||0)>=1; var pp=root.querySelector('#pump'+i); if(pp) pp.checked=(+h.pump||0)>=1; });
    recalcPrice();
  }
  function refreshCutterRow(){
    var row = root.querySelector('#cfgCutterRow'); if(!row) return;
    var pc = (accCatalog()||{}).pipeCutter;
    if(!(pc && pc.handle)){ row.hidden = true; row.innerHTML=''; return; }
    row.hidden = false;
    var pcv = (pc.variants && pc.variants[0]);
    var price = (pcv ? pcv.price : pc.price) || 0;
    var on = !!(CFG && CFG.pipeCutter);
    row.innerHTML = '<input type="checkbox" id="cfgCutter"'+(on?' checked':'')+'>'
      + '<span class="acc-name">' + (((accCatalog()||{}).pipeCutterLabel) || pc.title || 'Pipe cutter') + ' <button class="moreinfo-sm" data-info="cutter" type="button" aria-label="Pipe cutter info">'+icon('info')+'</button></span>'
      + '<span class="acc-price">+'+money(price)+'</span>';
    var ccb = row.querySelector('#cfgCutter');
    if(ccb) ccb.onchange = function(){ if(CFG){ CFG.pipeCutter = ccb.checked ? 1 : 0; recalcPrice(); } };
  }
  function recalcPrice(){
    if(!CFG) return;
    var _r = computeTotal(CFG); var total = _r.total, fullyReal = _r.fullyReal;
    if(elPrice)  elPrice.textContent  = money(total);
    if(elPrice2) elPrice2.textContent = money(total);
    var moTxt = monthly(total);
    var mo = root.querySelector('#cfgMo');  if(mo)  mo.textContent  = moTxt;
    var mo2= root.querySelector('#cfgMo2'); if(mo2) mo2.textContent = moTxt;
    var note = root.querySelector('#cfgPriceNote');
    if(note) note.textContent = fullyReal ? 'estimated total' : 'estimated · placeholder pricing';
    CFG.total = total;
    refreshCfgDesc();                  /* combined description reflects current selections (1-b) */
    if(CFG.openCard){                  /* Stage 1: reflect the build on the closed card + persist */
      setCardPrice(CFG.openCard, total, true);
      syncCardDisplay(CFG.openCard, CFG);
      var _k = cardKey(CFG.openCard); if(_k) persistBuild(_k, CFG);
    }
  }
  function setModalTab(name){
    root.querySelectorAll('[data-tab-btn-m]').forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.tabBtnM===name); });
    root.querySelectorAll('[data-tab-panel-m]').forEach(function(p){ p.hidden = p.dataset.tabPanelM!==name; });
  }
  function openConfig(card){
    var kind = card.dataset.kind;
    var btu  = card.dataset.btu;
    var condK = condFromBtu(btu);
    var zones = kind==='multi' ? +card.dataset.zones : 1;
    var lockedType = card.dataset.type || null;
    var family = card.dataset.family || null;
    var voltage = (card.dataset.volts && String(card.dataset.volts).indexOf('115')>=0) ? '115v' : '230v';
    CFG = { kind:kind, btu:btu, condK:condK, zones:zones, lockedType:lockedType, family:family, voltage:voltage,
      title: card.dataset.title, photo: card.dataset.photo || 'truck',
      base: basePrice(kind, condK, zones), heads:[], sys:{mount:0, electrical:0}, pipeCutter:0,
      photos:[], photoActive:0 };
    CFG._editSig = PENDING_EDIT_SIG || null; PENDING_EDIT_SIG = null;   /* set only when reopened from tray */
    var pendHeads = (PENDING_HEADS && PENDING_HEADS.length) ? PENDING_HEADS.slice() : null; PENDING_HEADS = null;
    if(kind==='single'){
      var lsIdx = parseInt(card.dataset.lsIdx,10) || 0;
      CFG.heads.push({ type: lockedType || 'hw-king', sizeK: condK, lineGuard:0, lineset:lsIdx, pump:0 });
    } else {
      /* prefer the calculator's suggested per-zone sizes (pendHeads); fall back to the card's defaults */
      var saved = pendHeads || (card.dataset.headsizes||'').split(',').map(function(n){ return parseInt(n,10); }).filter(function(n){ return !isNaN(n); });
      var def = defaultHeads(condK, zones, 'hw-king');
      for(var i=0;i<zones;i++){
        var sz = snapSize(condK,'hw-king', saved[i] || def[i]);
        CFG.heads.push({ type:'hw-king', sizeK:sz, lineGuard:0, lineset:0, pump:0 });
      }
    }
    /* Stage 1: restore a saved build for this card, if one exists — but NOT when we came from
       the calculator (pendHeads set), so the calculator's suggested sizes aren't overwritten */
    var _svk = cardKey(card), _svb = (!pendHeads && _svk) ? savedBuild(_svk) : null;
    if(_svb && _svb.heads && _svb.heads.length && (kind==='single' || _svb.heads.length===zones)){
      CFG.heads = _svb.heads.map(function(h){ return {type:h.type, sizeK:+h.sizeK, lineset:+h.lineset||0, lineGuard:+h.lineGuard||0, pump:+h.pump||0}; });
      CFG.sys = {mount:+(_svb.sys&&_svb.sys.mount)||0, electrical:+(_svb.sys&&_svb.sys.electrical)||0};
      CFG.pipeCutter = _svb.pipeCutter?1:0;
    }
    CFG.photos = cfgPhotoReel(CFG);
    renderGallery();
    var ey=root.querySelector('#cfgEyebrow'); if(ey) ey.textContent = kind==='multi' ? (zones+'-Zone System') : 'Single-Zone System';
    var ti=root.querySelector('#cfgTitle'); if(ti) ti.textContent = CFG.title;
    populateTabs();
    var it=root.querySelector('#cfgInfoTab'); if(it) it.href = INFO_URL;
    setModalTab('configure');
    renderConfigure();
    refreshCutterRow();
    var block = card.closest('.rail-block') || card.closest('.series');
    if(block && cfgOverlay2) block.insertAdjacentElement('afterend', cfgOverlay2);
    root.querySelectorAll('.scard.open').forEach(function(c){ c.classList.remove('open'); });
    card.classList.add('open');
    CFG.openCard = card;
    var ob = card.querySelector('[data-open-config]');
    if(ob){ ob.innerHTML = 'Close product ' + icon('chevronUp'); }
    if(cfgOverlay2){ cfgOverlay2.hidden=false; setTimeout(function(){ cfgOverlay2.scrollIntoView({behavior:'smooth', block:'start'}); }, 40); }
  }
  function closeConfig(){
    if(cfgOverlay2) cfgOverlay2.hidden = true;
    var card = CFG && CFG.openCard;
    if(card && CFG){ var _ck=cardKey(card); if(_ck) persistBuild(_ck, CFG); syncCardDisplay(card, CFG); }   /* Stage 1: save + reflect on close */
    root.querySelectorAll('.scard.open').forEach(function(c){ c.classList.remove('open'); });
    var ob = card && card.querySelector('[data-open-config]');
    if(ob){ ob.innerHTML = 'Open product ' + icon('arrowRt'); }
    CFG=null;
    if(card){ setTimeout(function(){ card.scrollIntoView({behavior:'smooth', block:'center'}); }, 40); }
  }
  var cfgCfgEl = root.querySelector('#cfgConfigure');
  if(cfgCfgEl){
    cfgCfgEl.addEventListener('click', function(e){
      if(!CFG) return;
      var optI = e.target.closest('.gwin-opt-i');
      if(optI){ e.stopPropagation(); e.preventDefault();
        var peo;
        if(optI.dataset.typeinfo){ var tsel=optI.closest('.gwin-sel'); var thi=tsel?+tsel.dataset.head:0; var thh=CFG.heads[thi]||CFG.heads[0]; var toth=CFG.heads.reduce(function(a,x,idx){ return idx===thi?a:a+x.sizeK; },0); peo=typeInfoEntry(optI.dataset.typeinfo, thh, toth); }
        else { peo=infoEntryFor(optI.dataset.optinfo, CFG, null, +optI.dataset.opti); }
        if(peo) openInfoPop(peo); return; }
      var selBtn = e.target.closest('.gwin-sel__btn');
      if(selBtn){ var sroot=selBtn.closest('.gwin-sel'); var panel=sroot.querySelector('.gwin-sel__panel'); var willOpen=!panel.classList.contains('is-open'); closeAllSel(); if(willOpen){ panel.classList.add('is-open'); selBtn.setAttribute('aria-expanded','true'); var obi=selBtn.querySelector('.gwin-sel__btn-i'); if(obi) obi.style.display='none'; } return; }
      var selOpt = e.target.closest('.gwin-sel__opt');
      if(selOpt && selOpt.getAttribute('data-soon')){ return; } /* "Coming soon" — not selectable */
      if(selOpt){ var sroot2=selOpt.closest('.gwin-sel'); var val=selOpt.getAttribute('data-value');
        sroot2.querySelectorAll('.gwin-sel__opt').forEach(function(o){ o.classList.remove('is-selected'); }); selOpt.classList.add('is-selected');
        var bt=sroot2.querySelector('.gwin-sel__btn-text'); if(bt){ var w=selOpt.querySelector('.gwin-sel__optwrap'); bt.textContent = (w?w.textContent:selOpt.textContent); }
        var bi=sroot2.querySelector('.gwin-sel__btn-i'); var srcI=selOpt.querySelector('.gwin-opt-i'); if(bi) bi.innerHTML = srcI ? infoBadgeAsSpan(srcI.outerHTML) : '';
        closeAllSel(); applyCfgChange(sroot2, val); return; }
      var cb = e.target.closest('input[type="checkbox"]');
      if(cb && cb.id==='cfgCutter'){ if(CFG){ CFG.pipeCutter = cb.checked ? 1 : 0; recalcPrice(); } return; }
      if(cb && cb.dataset.acc){ var h = CFG.heads[+cb.dataset.head]; h[cb.dataset.acc] = cb.checked ? 1 : 0; recalcPrice(); return; }
      var hInfo = e.target.closest('[data-info-handler]');
      if(hInfo){ var tp=CFG.heads[+hInfo.dataset.infoHandler].type; var pe2=infoEntryFor(tp); if(pe2){ openInfoPop(pe2); } else if(INFO[tp]){ openInfoPop(INFO[tp]); } return; }
      var sz = e.target.closest('[data-size-zone]');
      if(sz){
        var zi = +sz.dataset.sizeZone;
        openCalc('Zone '+(zi+1)+' ('+CFG.condK+'k condenser)', 'single', { apply: function(spec){
          var want = Math.round((spec.sizeBtu||0)/1000);
          var other = CFG.heads.reduce(function(a,hh,idx){ return idx===zi ? a : a+hh.sizeK; },0);
          var avail = validSizesForHead(CFG.condK, CFG.heads[zi].type, other);
          var chosen = avail.find(function(k){ return k>=want; });
          if(chosen===undefined) chosen = avail.length?avail[avail.length-1]:CFG.heads[zi].sizeK;
          CFG.heads[zi].sizeK = chosen;
          closeCalc();
          renderConfigure();
        }});
      }
    });
    document.addEventListener('click', function(e){ if(!e.target.closest('.gwin-sel') && !e.target.closest('#infoPopOverlay')) closeAllSel(); });
  }
  root.querySelectorAll('[data-tab-btn-m]').forEach(function(b){ b.addEventListener('click', function(){ setModalTab(b.dataset.tabBtnM); }); });
  if(cfgOverlay2){
    cfgOverlay2.addEventListener('click', function(e){
      if(e.target.closest('.mg-img')){
        var urls=((CFG&&CFG.photos)?CFG.photos:[]).map(function(p){ return p.img; }).filter(Boolean);
        if(urls.length){ openLightbox(urls, (CFG&&CFG.photoActive)||0); return; }
      }
      var ig=e.target.closest('.ig-img');
      if(ig){ var ii=(CFG&&CFG._installImgs)||[]; if(ii.length){ openLightbox(ii, +(ig.dataset.i||0)); } return; }
      var a=e.target.closest('[data-gal]'); if(a) galStep(a.dataset.gal);
    });
    var galEl = root.querySelector('#cfgGallery');
    if(galEl){ var gx0=null;
      galEl.addEventListener('pointerdown', function(e){ gx0=e.clientX; });
      galEl.addEventListener('pointerup', function(e){ if(gx0==null) return; var dx=e.clientX-gx0; gx0=null; if(Math.abs(dx)>40 && !e.target.closest('[data-gal]')) galStep(dx<0?'next':'prev'); });
    }
  }
  root.addEventListener('click', function(e){
    var opener = e.target.closest('[data-open-config]'); if(!opener) return;
    var card = opener.closest('.scard'); if(!card) return;
    if(card.classList.contains('open')) closeConfig(); else openConfig(card);
  });
  /* Stage 2 — eye toggles a card's LOCK (bookmark to come back to); capture so it never opens the product */
  root.addEventListener('click', function(e){
    var eyeBtn = e.target.closest ? e.target.closest('[data-eye]') : null;
    if(!eyeBtn) return;
    e.stopPropagation(); e.preventDefault();
    var card = eyeBtn.closest('.scard'); if(!card) return;
    var now = !isSaved(card);
    setSaved(card, now);
    applySavedState(card);
    if(now) reflectSavedCard(card);
  }, true);

  /* Stage 2 — Save build (open product) commits to the tray, then resets the card */
  (function(){
    var sb=root.querySelector('#cfgSaveBuild');
    if(sb) sb.addEventListener('click', function(){
      if(!CFG){ gwinFlash('Open a product first'); return; }
      var card=CFG.openCard, editing=CFG._editSig;
      if(editing){ updateTrayEntry(editing, CFG); } else { addToTray(CFG); }
      gwinFlash(editing ? 'Build updated' : 'Saved to your builds');
      closeConfig();
      if(card) resetCardToDefault(card);
      updateSavedCount();
    });
  })();

  /* Stage 2 — Saved-builds tray: open button, overlay close, per-card actions */
  (function(){
    var ov=root.querySelector('#trayOverlay');
    root.querySelectorAll('[data-open-tray]').forEach(function(b){ b.addEventListener('click', openTray); });
    if(!ov) return;
    ov.addEventListener('click', function(e){ if(e.target===ov || (e.target.closest && e.target.closest('[data-tray-close]'))) closeTray(); });
    var reel=ov.querySelector('#trayReel');
    if(reel) reel.addEventListener('click', function(e){
      var cardEl=e.target.closest('.tray-card'); if(!cardEl) return;
      var sig=cardEl.dataset.sig, entry=trayEntry(sig); if(!entry) return;
      if(e.target.closest('[data-tray-cart]')){ addCartFromTray(entry, e.target.closest('[data-tray-cart]')); }
      else if(e.target.closest('[data-tray-share]')){ shareBuild(entry); }
      else if(e.target.closest('[data-tray-open]')){ reopenTrayBuild(entry); }
      else if(e.target.closest('[data-tray-rm]')){ trayRemove(sig); renderTray(); updateSavedCount(); }
      else if(e.target.closest('[data-qty-dec]')){ trayQty(sig, (+entry.qty||1)-1); renderTray(); }
      else if(e.target.closest('[data-qty-inc]')){ trayQty(sig, (+entry.qty||1)+1); renderTray(); }
    });
    var allBtn=ov.querySelector('#trayAddAll');
    if(allBtn) allBtn.addEventListener('click', function(){ addAllToCart(allBtn); });
    var shareAllBtn=ov.querySelector('#trayShareAll');
    if(shareAllBtn) shareAllBtn.addEventListener('click', function(){ shareAll(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !ov.hidden) closeTray(); });
  })();
  (function(){ var x=root.querySelector('#cfgClose'); if(x) x.addEventListener('click', closeConfig);
    var cp=root.querySelector('#cfgCloseProduct'); if(cp) cp.addEventListener('click', closeConfig); })();
  (function(){
    var sh=root.querySelector('#cfgShare');
    if(sh) sh.addEventListener('click', function(){
      if(!CFG){ gwinFlash('Open a product first'); return; }
      var entry={ qty:1, cfg:trayCfgSnapshot(CFG),
        cardKey:(CFG.openCard?cardKey(CFG.openCard):null),
        photo:(CFG.openCard && CFG.openCard._gimgs && CFG.openCard._gimgs[0])||null };
      shareBuild(entry);
    });

    /* W5 — Add to cart */
    var toast = root.querySelector('#shareToast');
    function flash(msg){ if(!toast) return; toast.textContent=msg; toast.hidden=false; setTimeout(function(){ toast.hidden=true; toast.textContent='Copied to clipboard'; }, 2600); }
    var addBtns = [];
    var a1 = root.querySelector('#cfgAddCart'); if(a1) addBtns.push(a1);
    if(cfgOverlay2){ var a2 = cfgOverlay2.querySelector('.foot-actions .btn.primary'); if(a2 && a2!==a1) addBtns.push(a2); }
    addBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        if(!CFG){ flash('Open a product first'); return; }
        var res = buildCartItems(CFG);
        if(res.error){ flash('Not available to purchase yet'); return; }            // unconnected guard
        if(!res.items || !res.items.length){ flash('Nothing to add'); return; }
        var bad = unavailableInItems(res.items);
        if(bad.length){ flash('Out of stock: ' + bad.slice(0,2).join(', ')); return; } // stock guard
        var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
        addItemsVerified(res.items)
          .then(function(v){ btn.disabled=false; btn.textContent=label;
            if(v.ok){ bumpCartCount(v.post); gwinFlash('Added \u2713 \u00b7 '+v.post+' in cart'); }
            else { flash('Couldn\u2019t add \u2014 item may be out of stock'); } })
          .catch(function(){ btn.disabled=false; btn.textContent=label; flash('Could not add to cart — please try again'); });
      });
    });
  })();
  document.addEventListener('keydown', function(e){
    if(e.key!=='Escape') return;
    if(infoPop && !infoPop.hidden) return;
    if(calcOverlay && !calcOverlay.hidden) return;
    if(cfgOverlay2 && !cfgOverlay2.hidden) closeConfig();
  });

  /* ===================== BOOT ===================== */
  pruneUnlockedBuilds();
  setTimeout(function(){ fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(bumpCartUI).catch(function(){}); }, 300);
  buildSingle();
  (function(){
    var shared = parseSharedBuilds(); if(!shared.length) return;
    if(shared.length === 1){ setTimeout(function(){ openSharedProduct(shared[0]); }, 220); }
    else { addSharedToTray(shared); setTimeout(updateSavedCount, 0); setTimeout(openTray, 420); }
    try{ history.replaceState(null, '', location.pathname); }catch(e){}
  })();
  setTimeout(updateSavedCount, 0); setTimeout(updateSavedCount, 520);
  setTimeout(refreshSingleCardPrices, 0); setTimeout(refreshSingleCardPrices, 500);
  setTimeout(refreshMultiCardPrices, 0); setTimeout(refreshMultiCardPrices, 500);
  setTimeout(refreshSingleCardPhotos, 0); setTimeout(refreshSingleCardPhotos, 500);
  setTimeout(refreshMultiCardPhotos, 0); setTimeout(refreshMultiCardPhotos, 500);
  buildMulti();
  initRails(root);
  initSwipeHints(root);
  buildJump('single');

  /* v1.98 — ?go=king|emperor|multi|ducted deep-link (homepage "Build a … system" buttons):
     switch to the right tab, then scroll to the matching series once cards have rendered.
     The ?b= share block above returns early (leaving the URL intact) when there is no share
     payload, so ?go survives to here. Clean the param so a refresh doesn't re-fire it. */
  (function(){
    var m = String(location.search||'').match(/[?&]go=([^&]+)/);
    if(!m) return;
    var go = decodeURIComponent(m[1]).toLowerCase();
    try{ history.replaceState(null,'',location.pathname); }catch(_){}
    var tab = (go==='multi') ? 'multi' : (go==='ducted' ? 'central' : 'single');
    setTab(tab);
    setTimeout(function(){
      var target=null;
      if(go==='multi'){
        target = root.querySelector('#build') || root.querySelector('#multi section.series') || root.querySelector('#multi');
      } else if(go==='ducted'){
        var mc = root.querySelector("#central .scard[data-kind='single'][data-family='max']");
        target = mc ? (mc.closest('section.series') || mc) : (root.querySelector('#central section.series') || root.querySelector('#centralBody'));
      } else {
        var fam = (go==='emperor') ? 'emperor' : (go==='king' ? 'king' : null);
        if(fam){
          var card = root.querySelector("#single .scard[data-kind='single'][data-family='"+fam+"']");
          target = card ? (card.closest('section.series') || card) : null;
        }
      }
      if(target && target.scrollIntoView){ target.scrollIntoView({behavior:'smooth', block:'start'}); }
    }, 160);
  })();

  /* When a cart drawer / modal opens, drop the GWIN sticky bar beneath it so the
     drawer (and its close button, which sits in the same top strip) is clickable.
     Detects either a scroll-lock OR a visible cart-drawer element; restores on close.
     Non-destructive: if nothing is detected the bar keeps its normal z-index. */
  (function(){
    var baseOverflow;
    try{ baseOverflow = getComputedStyle(document.body).overflow; }catch(e){ baseOverflow='visible'; }
    var DRAWER_SEL = '#cart-drawer,.cart-drawer,#CartDrawer,.drawer--cart,.cart-sidebar,.mini-cart,.minicart,.ajaxcart,.slide-cart,#slidecart,[class*="cart-drawer"],[id*="cart-drawer"],[class*="CartDrawer"],[class*="cartDrawer"],[data-cart-drawer]';
    function bars(){ return root.querySelectorAll('.top, .jump'); }
    function scrollLocked(){
      try{
        var b=document.body, h=document.documentElement;
        var ov=getComputedStyle(b).overflow, ovh=getComputedStyle(h).overflow;
        if(baseOverflow!=='hidden' && (ov==='hidden' || ovh==='hidden')) return true;
        var cn=(b.className||'')+' '+(h.className||'');
        return /(cart[-_ ]?(open|drawer)|drawer[-_ ]?open|modal[-_ ]?open|no[-_ ]?scroll|scroll[-_ ]?lock)/i.test(cn);
      }catch(e){ return false; }
    }
    function drawerVisible(){
      try{
        var els=document.querySelectorAll(DRAWER_SEL), vw=window.innerWidth, vh=window.innerHeight;
        for(var i=0;i<els.length;i++){ var el=els[i];
          if(root.contains(el)) continue;                 /* ignore our own section */
          var cs=getComputedStyle(el);
          if(cs.visibility==='hidden' || cs.display==='none' || (+cs.opacity||1)<0.05) continue;
          var r=el.getBoundingClientRect();
          if(r.width>120 && r.height>120 && r.left < vw-40 && r.right>40 && r.top < vh-40) return true;
        }
      }catch(e){}
      return false;
    }
    var _wasOn=false;
    function apply(){ var on = scrollLocked() || drawerVisible(); bars().forEach(function(el){ el.style.zIndex = on ? '1' : ''; });
      if(on && !_wasOn){ try{ cartCount().then(bumpCartCount).catch(function(){}); }catch(e){} }   /* drawer just opened — sync the count to the real cart */
      _wasOn=on;
    }
    try{
      var mo=new MutationObserver(apply);
      mo.observe(document.body, {attributes:true, attributeFilter:['class','style']});
      mo.observe(document.documentElement, {attributes:true, attributeFilter:['class','style']});
    }catch(e){}
    document.addEventListener('click', function(){ setTimeout(apply,380); }, false);
    setInterval(apply, 300);
    apply();
  })();

  /* "Continue Shopping" in the cart drawer should drop you back where you were, not bounce
     to a collection page. Intercept that button (only inside the cart drawer) and close the
     drawer instead — clicking its own close control if we can find it, else hiding it. */
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('a,button') : null;
    if(!t) return;
    if((t.textContent||'').replace(/\s+/g,' ').trim().toLowerCase().indexOf('continue shopping')===-1) return;
    var drawer = t.closest(GWIN_DRAWER_SEL);
    if(!drawer || root.contains(drawer)) return;
    e.preventDefault(); e.stopPropagation();
    var x = drawer.querySelector('[aria-label*="close" i],[data-drawer-close],.drawer__close,button.close,.cart-close,.close-cart,.cart-drawer__close');
    if(x){ x.click(); return; }
    try{ drawer.style.display='none'; }catch(_){}
    ['cart-open','drawer-open','js-drawer-open','no-scroll','overflow-hidden','scroll-lock','cart-drawer-open'].forEach(function(c){ document.body.classList.remove(c); document.documentElement.classList.remove(c); });
    try{ document.body.style.overflow=''; }catch(_){}
  }, true);

  /* Cart-drawer ✕ fix. The drawer is the Hyper theme's <cart-drawer id="CartDrawer"> web
     component; its ✕ is button.drawer__close-btn. Vibe re-renders the drawer's inner HTML
     after cart changes, which detaches the theme's close-button listener — so the ✕ stops
     working. The <cart-drawer> element itself survives (only its contents are swapped) and
     its .close() method still works, so call that directly. Delegated + capture so it fires
     even on the freshly re-rendered button; no display:none, so re-open is unaffected. */
  document.addEventListener('click', function(e){
    var btn = (e.target && e.target.closest) ? e.target.closest('.drawer__close-btn,[class*="drawer__close"]') : null;
    if(!btn) return;
    var d = btn.closest('cart-drawer,#CartDrawer,.cart-drawer');
    if(!d) return;
    e.preventDefault();
    try{ if(typeof d.close==='function'){ d.close(); } }catch(_){}
    /* fallbacks if .close() isn't available for any reason */
    try{ d.classList.remove('active','animate','is-open','open','drawer--active'); d.removeAttribute('open'); }catch(_){}
    ['overflow-hidden','no-scroll','js-drawer-open','cart-drawer-open','scroll-lock','drawer-open'].forEach(function(c){ document.body.classList.remove(c); document.documentElement.classList.remove(c); });
    try{ document.body.style.overflow=''; }catch(_){}
  }, true);

  /* mount the page-top calculators (the modal calc mounts on open) */
  var singleCalcRoot = root.querySelector('#single [data-roomcalc]');
  var multiCalcRoot  = root.querySelector('#multi [data-roomcalc]');
  if(singleCalcRoot) buildRoomCalc(singleCalcRoot, {maxRooms:1, variant:'single', onGoto:gotoFromSpec});
  if(multiCalcRoot)  buildRoomCalc(multiCalcRoot,  {maxRooms:MAX_ROOMS, variant:'multi', onGoto:gotoFromSpec});
  var centralCalcRoot = root.querySelector('#central [data-roomcalc]');
  if(centralCalcRoot) buildRoomCalc(centralCalcRoot, {maxRooms:12, variant:'central', onGoto:gotoFromSpec});

  /* calc panel open/close + reset (toggle + foot stay outside the tab panels) */
  root.querySelectorAll('[data-calc-panel]').forEach(function(panel){
    var toggle = panel.querySelector('[data-calc-toggle]');
    var resetBtn = panel.querySelector('[data-calc-reset]');
    var rcEl = panel.querySelector('[data-roomcalc]');
    var startOpen = !(typeof GWIN_CFG!=='undefined' && GWIN_CFG.calcStartOpen===false);
    var open = true;
    function setOpen(o, init){
      open=o;
      if(o){
        panel.querySelectorAll('.calc-panel-head, .calc-tabs').forEach(function(el){ el.hidden=false; });
        var active = panel.querySelector('[data-calc-tab][aria-pressed="true"]');
        active = active ? active.dataset.calcTab : 'quick';
        panel.querySelectorAll('[data-calc-tabpanel]').forEach(function(p){ p.hidden = p.dataset.calcTabpanel!==active; });
      } else {
        panel.querySelectorAll('.calc-panel-head, .calc-tabs, [data-calc-tabpanel]').forEach(function(el){ el.hidden=true; });
      }
      if(resetBtn) resetBtn.hidden=!o;
      panel.classList.toggle('collapsed', !o);
      if(toggle) toggle.innerHTML = o ? (icon('chevronUp')+' Close BTU calculator') : (icon('gauge')+' Open BTU calculator');
      if(!o && !init) setTimeout(function(){ panel.scrollIntoView({behavior:'smooth', block:'center'}); }, 40);
    }
    if(toggle) toggle.addEventListener('click', function(){ setOpen(!open); });
    if(resetBtn) resetBtn.addEventListener('click', function(){ if(rcEl && rcEl.reset) rcEl.reset(); });
    if(!startOpen) setOpen(false, true);
  });

  /* pin the Single/Multi bar + jump nav just under the theme's sticky header */
  (function(){
    var topBar = root.querySelector('.top');
    var jumpBar = root.querySelector('.jump');
    /* lowest VISIBLE content bottom inside a pinned header — skips a hidden/collapsed
       menu bar that still reserves layout space. Returns 0 if nothing usable found. */
    function visBottom(el, cap){
      var best=0, found=false, all;
      try{ all=el.querySelectorAll('*'); }catch(e){ return 0; }
      var n=Math.min(all.length,400);
      for(var i=0;i<n;i++){
        var d=all[i];
        if(d===root || (d.contains&&d.contains(root)) || (root.contains&&root.contains(d))) continue;
        var cs; try{ cs=getComputedStyle(d); }catch(e){ continue; }
        if(cs.display==='none' || cs.visibility==='hidden' || parseFloat(cs.opacity||'1')<0.05) continue;
        var r=d.getBoundingClientRect();
        if(r.width<=0 || r.height<=0) continue;
        if(r.top>cap) continue;        // sits below the header band — ignore
        if(r.bottom<=1) continue;      // scrolled/translated off the top (e.g. hidden menu) — ignore
        if(r.bottom>cap+4) continue;   // overflows past the pinned box — ignore
        if(r.bottom>best){ best=r.bottom; found=true; }
      }
      return found?best:0;
    }
    /* once a pinned element is found, trust its visible-content bottom only when it
       removes a real gap (>24px); otherwise the difference is just padding. */
    function usableBottom(el){
      var rr=el.getBoundingClientRect();
      if(rr.top>2 || rr.height>320) return 0;
      var vb=visBottom(el, rr.bottom);
      return (vb>0 && (rr.bottom - vb) > 24) ? vb : rr.bottom;
    }
    function headerBottom(){
      var b=0;
      try{
        if(document.elementsFromPoint){
          var cx=Math.round((window.innerWidth||document.documentElement.clientWidth||390)/2);
          var stack=document.elementsFromPoint(cx, 2);
          for(var j=0;j<stack.length;j++){
            var e=stack[j];
            if(e===root || (e.contains&&e.contains(root)) || (root.contains&&root.contains(e))) continue;
            var c=getComputedStyle(e);
            if(c.position!=='fixed' && c.position!=='sticky') continue;
            var use=usableBottom(e);
            if(use>b) b=use;
          }
        }
      }catch(err){}
      if(b===0){
        var cands = document.querySelectorAll('header,[class*="header" i],[id*="header" i],[class*="sticky" i],sticky-header,.shopify-section-group-header-group');
        cands.forEach(function(el){
          if(el===root || (el.contains && el.contains(root))) return;
          var cs=getComputedStyle(el);
          if(cs.position!=='fixed' && cs.position!=='sticky') return;
          var r=el.getBoundingClientRect();
          if(r.top>1 || r.bottom<=0 || r.height>320) return;
          var use=usableBottom(el);
          if(use>b) b=use;
        });
      }
      if(b===0){
        var kids=document.body?document.body.children:[];
        for(var i=0;i<kids.length;i++){ var el=kids[i]; if(el===root||(el.contains&&el.contains(root))) continue;
          var cs=getComputedStyle(el); if(cs.position!=='fixed'&&cs.position!=='sticky') continue;
          var use=usableBottom(el); if(use>b) b=use; }
      }
      return Math.max(0, Math.round(b));
    }
    function place(){
      var mob = window.matchMedia && window.matchMedia('(max-width:640px)').matches;
      var manual = mob ? (+STICKY.mobile||0) : (+STICKY.desktop||0);
      var hb = manual>0 ? manual : headerBottom();
      if(topBar) topBar.style.top=hb+'px';
      if(jumpBar) jumpBar.style.top=(hb+(topBar?topBar.offsetHeight:0))+'px';
    }
    var ticking=false;
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ place(); ticking=false; }); } }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('scroll', onScroll, {passive:true});
    setTimeout(place,300); setTimeout(place,1000);
  })();

  /* scroll restoration: come back from a product/other page to exactly where you left off.
     Live-chat widgets block bfcache, so back = full reload; we take manual control and save continuously. */
  (function(){
    var KEY='gwinScroll:'+location.pathname;
    try{ if('scrollRestoration' in history) history.scrollRestoration='manual'; }catch(e){}
    function curY(){ return window.pageYOffset || (document.documentElement&&document.documentElement.scrollTop) || 0; }
    function save(){ try{ sessionStorage.setItem(KEY, String(curY())); }catch(e){} }
    var st=false;
    window.addEventListener('scroll', function(){ if(!st){ st=true; setTimeout(function(){ save(); st=false; }, 200); } }, {passive:true});
    window.addEventListener('pagehide', save);
    window.addEventListener('beforeunload', save);
    document.addEventListener('visibilitychange', function(){ if(document.visibilityState==='hidden') save(); });
    function navType(){
      try{ var n=performance.getEntriesByType && performance.getEntriesByType('navigation'); if(n&&n[0]) return n[0].type; }catch(e){}
      try{ if(performance.navigation){ var t=performance.navigation.type; return t===2?'back_forward':(t===1?'reload':'navigate'); } }catch(e){}
      return 'navigate';
    }
    function restore(){
      var y=null; try{ y=sessionStorage.getItem(KEY); }catch(e){}
      if(y==null) return;
      var target=parseInt(y,10)||0; if(target<=0) return;
      var n=0; (function tick(){ window.scrollTo(0, target); if(++n<30 && Math.abs(curY()-target)>2) setTimeout(tick,40); })();
    }
    var t=navType(), shouldRestore=(t==='back_forward');
    if(shouldRestore){ restore(); setTimeout(restore,250); setTimeout(restore,800); }
    window.addEventListener('pageshow', function(e){ if(e.persisted || shouldRestore) restore(); });
  })();

  requestAnimationFrame(function(){ root.querySelectorAll('#single .rail').forEach(setEdges); });
  setTimeout(function(){ root.querySelectorAll('.rail').forEach(setEdges); }, 350);

  /* W1 — expose catalog resolvers for console verification */
  if(window.GWIN_ENGINE){
    window.GWIN_ENGINE.resolveBuild   = resolveBuild;
    window.GWIN_ENGINE.resolveVariant = resolveVariant;
    window.GWIN_ENGINE.findHandler    = findHandler;
    window.GWIN_ENGINE.findCondenser  = findCondenser;
    window.GWIN_ENGINE.condFamily     = condFamily;
    window.GWIN_ENGINE.lsOptsFor      = lsOptsFor;
    window.GWIN_ENGINE.condAccOpts    = condAccOpts;
    window.GWIN_ENGINE.sysOptsFor     = sysOptsFor;
    window.GWIN_ENGINE.univAccPrice   = univAccPrice;
    window.GWIN_ENGINE.buildCartItems = buildCartItems;
    window.GWIN_ENGINE.findSystem     = findSystem;
    window.GWIN_ENGINE.cardRealBase   = cardRealBase;
    window.GWIN_ENGINE.multiCardRealBase = multiCardRealBase;
    window.GWIN_ENGINE.optPriceLabel  = optPriceLabel;
    window.GWIN_ENGINE.refreshSingleCardPrices = refreshSingleCardPrices;
    window.GWIN_ENGINE.refreshMultiCardPhotos = refreshMultiCardPhotos;
    window.GWIN_ENGINE.multiCondenserPhotos = multiCondenserPhotos;
    window.GWIN_ENGINE.cfgPhotoReel = cfgPhotoReel;
    window.GWIN_ENGINE.multiDescription = multiDescription;
    window.GWIN_ENGINE.combinedDescParts = combinedDescParts;
    window.GWIN_ENGINE.computeTotal = computeTotal;
    window.GWIN_ENGINE.totalForBuild = totalForBuild;
    window.GWIN_ENGINE.cfgFromCard = cfgFromCard;
    window.GWIN_ENGINE.persistBuild = persistBuild;
    window.GWIN_ENGINE.savedBuild = savedBuild;
    window.GWIN_ENGINE.clearBuild = clearBuild;
    window.GWIN_ENGINE.cardKey = cardKey;
    window.GWIN_ENGINE.loadBuilds = loadBuilds;
    window.GWIN_ENGINE.syncCardDisplay = syncCardDisplay;
    window.GWIN_ENGINE.debugBuild = function(){
      if(typeof CFG === 'undefined' || !CFG) return 'Open a product configurator first, then run GWIN_ENGINE.debugBuild() again.';
      return {
        kind: CFG.kind, condK: CFG.condK, zones: CFG.zones,
        heads: (CFG.heads||[]).map(function(h){
          var mh  = (CFG.kind==='multi') ? multiHead(h.type, h.sizeK) : null;
          var lso = lsOptsFor(h.type, h.sizeK) || [];
          var li  = Math.min(+h.lineset||0, lso.length ? lso.length-1 : 0);
          return {
            type: h.type, size: h.sizeK, lineIdx: h.lineset,
            linesetProduct: (mh && mh.lineset) ? mh.lineset.handle : (CFG.kind==='multi' ? '(none connected)' : 'single'),
            chosenLength: lso[li] ? lso[li].label : null,
            allLengths: lso.map(function(o){ return o.label; })
          };
        }),
        manifest: combinedDescParts(CFG).map(function(i){ return i.name + ' x' + i.count; })
      };
    };
    window.GWIN_ENGINE.pickDescription = pickDescription;
    window.GWIN_ENGINE.pickSubmittal = pickSubmittal;
    window.GWIN_ENGINE.infoEntryFor = infoEntryFor;
  }

  console.log('[GWIN] Section 2 engine ready (Phase 4B) — series:', SINGLE.length,
    '· zones:', ZONES.length, '· handler types:', HANDLER_TYPES.length);
})();
